// ============================================================
// 📦 IMPORTS — React tools and product photos
// Add new photo imports here when you add new products
// ============================================================
import { useState, useRef, useEffect } from "react";


import ahli from "./assets/ahli.png";
import riffa from "./assets/riffa.png";
import darkulain from "./assets/darkulaib.png";
import darkulain1 from "./assets/darkulaib1.png";





    // ======================FootBall=============================

import mundialBlack from "./assets/mundial.Black.png";
import mundialBlack1 from "./assets/mundial.Black1.png";
import mundialwhite from "./assets/mundial.white.png";
import mundialwhite1 from "./assets/mundial.white1.png";
import mundialYellow from "./assets/mundial.Y.jpg"
import mundialYellow1 from "./assets/mundial.Y1.jpg"
import mundialwYellow from "./assets/mundial.whiteY.jpg"
import mundialwYellow1 from "./assets/mundial.whiteY1.jpg"
import topflex from "./assets/topFlex.png";
import topflexb from "./assets/topFlex.B.jpg";
import topflexb1 from "./assets/topFlex.B1.jpg";
import topflexb2 from "./assets/topFlex.B2.jpg";
import topflexbw from "./assets/topFlex.W.jpg";
import topflexbw1 from "./assets/topFlex.W1.jpg";
import topflexbw2 from "./assets/topFlex.W2.jpg";
import driblingblue from "./assets/dribling.blue.png";
import driblingblue1 from "./assets/dribling.blue2.png";
import driblingblack from "./assets/dribling.black1.png";
import driblingblack1 from "./assets/dribling.black.png";
import driblingorange from "./assets/dribling.Orange.png";
import driblingorange1 from "./assets/dribling.Orange1.png";
import liga from "./assets/liga.png";
import liga1 from "./assets/liga1.png";
import ligablue from "./assets/ligablue.png";
import ligablue1 from "./assets/ligablue1.png";
import maxima from "./assets/maxima.png";
import maxima1 from "./assets/maxima1.png";
import maximaf from "./assets/maxima_F.jpg";
import maximaf1 from "./assets/maxima_F1.jpg";
import maximao from "./assets/maxima_O.jpg";
import maximao1 from "./assets/maxima_O1.jpg";
import aguilaCBlack from "./assets/aguliaCup.png";
import aguilaCBlack1 from "./assets/aguliaCup1.png";
import aguilaBlack from "./assets/agulia.png";
import supercopaCBlack from "./assets/superCopa.png";

      // ======================Running=============================
import fnv1 from "./assets/fnv.png";
import R200Black from "./assets/R2000.Black.png";
import R200Black1 from "./assets/R2000.Black1.png";
import R200White from "./assets/R2000.White.png";
import R200White1 from "./assets/R2000.White1.png";
import ViperBlack from "./assets/Viper.Black.png";
import ViperBlack1 from "./assets/Viper.Black1.png";
import ViperWhite from "./assets/Viper.White.png";
import ViperGrey from "./assets/Viper.Grey.png";
import ViperWhite1 from "./assets/Viper.White1.png";
import ViperYellow from "./assets/viper.Yelow.jpg";
import ViperYellow1 from "./assets/viper.Yelow1.jpg";
import hispalisBlack from "./assets/Hispalis.Black.png";
import hispalisBlack1 from "./assets/Hispalis.Black1.png";
import hispalisWhite from "./assets/Hispalis.White.png";
import hispalisWhite1 from "./assets/Hispalis.White1.png";
import hispalisBEIGE from "./assets/Hispalis.BEIGE.png";
import hispalisBEIGE1 from "./assets/Hispalis.BEIGE1.png";
import hispalisKHAKI from "./assets/Hispalis.KHAKI.png";
import hispalisKHAKI1 from "./assets/Hispalis.KHAKI1.png";
import fenixBlack from "./assets/Fenix.Black.png";
import fenixBlack1 from "./assets/Fenix.Blackf1.png";
import fenixBlackf from "./assets/Fenix.Blackf.png";
import fenixBlackf1 from "./assets/Fenix.Blackf1.png";
import fenixWhite from "./assets/Fenix.White.png";
import fenixWhite1 from "./assets/Fenix.White1.png";
import superCrossWhite from "./assets/superCross.White.png";
import superCrossWhite1 from "./assets/superCross.White1.png";
import superCrossKhaki from "./assets/superCross.Khaki.png";
import superCrossKhaki1 from "./assets/superCross.Khaki1.png";
import victoryBlack from "./assets/victory.Black.png";
import victoryNavy from "./assets/victory.Navy.png";
import victoryNavy1 from "./assets/victory.Navy1.png";
import victoryPetroleum from "./assets/victory.Petroleum.png";
import victoryPetroleum1 from "./assets/victory.Petroleum1.png";
import titanuimRoyal from "./assets/titaniumRoyal.png";
import titanuimRoyal1 from "./assets/titaniumRoyal1.png";
import titanuimNavy from "./assets/titaniumNavy.png";



      // ======================gYN=============================

import neonBlack from "./assets/neon.BlackG.png";
import neonSky from "./assets/neonS.png";
import neonSky1 from "./assets/neonS1.png.webp";
import neonBlack1 from "./assets/neon.BlackG1.png";
import neonDrakG from "./assets/neon.DarkG.png";
import neonDrakG1 from "./assets/neon.DarkG1.png";
import neonLigtG from "./assets/neon.Lightg.png";
import neonLigtG1 from "./assets/neon.Lightgq.png";
import speedOrange from "./assets/speed.Orange.png";
import speedOrange1 from "./assets/speed.Orange1.png";
import speedGreen from "./assets/speed.Green.png";
import speedGreen1 from "./assets/speed.Green1.png";
import speedblue from "./assets/speedb.png";
import speedblue1 from "./assets/speedb1.png";
import metaBlackG from "./assets/meta.BlackG.png";
import metaBlackG1 from "./assets/meta.BlackG1.png";
import metaBlackGr from "./assets/meta.BlackGr.png";
import metaBlackGr1 from "./assets/meta.BlackGr1.png";
import metaNavy from "./assets/meta.Navy.png";
import metaNavy1 from "./assets/meta.Navy1.png";
import argonBlack from "./assets/argon.Black.png";
import argonBlack1 from "./assets/argon.Black1.png";
import argonGrey from "./assets/argon.Grey.png";
import argonGrey1 from "./assets/argon.Grey1.png";
import vitalyNavy from "./assets/vitaly.Navy.png";
import vitalyNavy1 from "./assets/vitaly.Navy1.png";
import vitalyRoyal from "./assets/vitaly.Royal.png";
import vitalyDrakN from "./assets/vitaly.DarkN.png";
import vitalyDrakN1 from "./assets/vitaly.DarkN1.png";
import vitalyGreen from "./assets/vitaly.Green.png";
import vitalyGreen1 from "./assets/vitaly.Green1.png";
import vitalyWwhite from "./assets/vitaly.White.png";
import vitalyWwhite1 from "./assets/vitaly.White1.png";




 // ======================Casual=============================

import lecelessb from "./assets/Laceless.B.jpg"
import lecelessb1 from "./assets/Laceless.B1.jpg"
import lecelessbw from "./assets/Laceless.BW.jpg"
import lecelessn from "./assets/Laceless.N.jpg"
import lecelessn1 from "./assets/Laceless.N1.jpg"
import atolonBlack from "./assets/atolon.Black.png"
import atolonBlack1 from "./assets/atolon.Black1.png"
import ateneaBlack from "./assets/atenea.Black.png"
import ateneaNavy from "./assets/atenea.Navy.png"
import ateneaNavy1 from "./assets/atenea.Navy1.png"
import ateneaBrown from "./assets/atenea.Brown.png"
import sodioBlack from "./assets/sodio.Black.png"
import sodioBlack1 from "./assets/sodio.Black1.png"
import sodioBlackw from "./assets/sodio.Blackw.png"
import sodioKhaki from "./assets/sodio.Khaki.png"
import teseoBlack from "./assets/tesceo.Black.png"
import choesNavy from "./assets/choes.Navy.png"
import teseoBlack1 from "./assets/tesceo.Black1.png"
import teseoNavy from "./assets/tesceo.Navy.png"
import teseoNavy1 from "./assets/tesceo.Navy1.png"
import ironBlack from "./assets/ironBlack.png"
import ironBlack1 from "./assets/ironBlack1.png"
import ironKhaki from "./assets/ironKhaki.png"
import ironKhaki1 from "./assets/ironKhaki1.png"
import zenBlack from "./assets/zenBlack.png"
import zenBlack1 from "./assets/zenBlack1.png"
import zenGrey from "./assets/zenGrey.png"
import zenBrown from "./assets/zenBrown.png"
import cdailyBlack from "./assets/cdailyBlack.png"
import cdailyBlack1 from "./assets/cdailyBlack1.png"
import cdailyBrown from "./assets/cdailyBrown.png"
import cdailyBrown1 from "./assets/cdailyBrown1.png"
import corintoBlack from "./assets/corinto.png"
import corintoBlack1 from "./assets/corintoBlack.png"
import corintoGrey from "./assets/corintoGrey.png"
import corintoGrey1 from "./assets/corintoGrey1.png"
import dalia from "./assets/dalia.png"
import rt50 from "./assets/rt50.png"
import rt501 from "./assets/rt501.png"
import rt50w from "./assets/rt50w.png"
import rt50w1 from "./assets/rt50w1.png"
import rt50g from "./assets/rt50g.png"
import rt50g1 from "./assets/rt50g1.png"
import rt50n from "./assets/rt50n.png"
import rt50n1 from "./assets/rt50n1.png"

      // ======================Padek=============================
  import pointKhaki from "./assets/point.Khaki.png"
   import pointWhite from "./assets/point.White.png"
   import pointWhite1 from "./assets/point.White1.png"
   import pointGreen from "./assets/point.Green.png"
   import pointGreen1 from "./assets/point.Green1.png"



      // ======================VollyBall=============================


import kneeCapB from "./assets/kneeCap.Black.png"
import kneeCapB1 from "./assets/kneeCap.Black3.png"
import kneeCapBW from "./assets/kneeCap.White1.png"
import kneeCapBW1 from "./assets/kneeCap.White.png"
import vscreenBlack from "./assets/vscreenBlack.png"
import vscreenBlack1 from "./assets/vscreenBlack1.png"
import vscreenWhite from "./assets/vscreenWhite.png"
import vscreenWhite1 from "./assets/vscreenWhite1.png"


      // ======================Clothing======TSHIRT=======================
import combiBlack from "./assets/CombiBlack.png"
import combiBlack1 from "./assets/CombiBlack1.png"
import combiWhite from "./assets/CombiWhite.png"
import combiWhite1 from "./assets/CombiWhite1.png"
import combiNavy from "./assets/CombiNavy.png"
import combiNavy1 from "./assets/CombiNavy1.png"
import CombiBurgundy from "./assets/CombiBurgundy.png"
import CombiBurgundy1 from "./assets/CombiBurgundy1.png"
import CombiRed from "./assets/CombiRed.png"
import CombiRed1 from "./assets/CombiRed1.png"
import CombiRoyal from "./assets/CombiRoyal.png"
import CombiRoyal1 from "./assets/CombiRoyal1.png"
import CombiSky from "./assets/CombiSky.png"
import CombiSky1 from "./assets/CombiSky1.png"
import CombiLgrey from "./assets/CombiLgrey.png"
import CombiLgrey1 from "./assets/CombiLgrey1.png"
import CombiDgrey from "./assets/CombiDgrey.png"
import CombiDgrey1 from "./assets/CombiDgrey1.png"
import CombiOrange from "./assets/CombiOrange.png"
import CombiOrange1 from "./assets/CombiOrange1.png"

 // ======================Clothing======Pants=======================

import pantElbaB from "./assets/pantElbaB.png"
import pantElbaB1 from "./assets/pantElbaB1.png"
import pantElbaG from "./assets/pantElbaG.png"
import pantElbaG1 from "./assets/pantElbaG1.png"
import pantElbaN from "./assets/pantElbaV.png"
import pantElbaN1 from "./assets/pantElbaN.png"
import pantStaffB from "./assets/pantStaffB.png"
import pantStaffB1 from "./assets/pantStaffB1.png"
import pantStaffN from "./assets/pantStaffN.png"
import pantStaffN1 from "./assets/pantStaffN1.png"
import pantSuezB from "./assets/pantSuezB.png"
import pantSuezB1 from "./assets/pantSuezB1.png"
import pantSuezN from "./assets/pantSuezN.png"
import pantSuezN1 from "./assets/pantSuezN1.png"
import pantNilloB from "./assets/pantNiloB.png"
import pantNilloB1 from "./assets/pantNiloB1.png"
import pantNilloN from "./assets/pantNiloN.png"
import pantNilloN1 from "./assets/pantNiloN1.png"




























      // ======================acc=============================

import sockBlackM from "./assets/socksBlackS.png"
import sockBlackM1 from "./assets/socksBlackS1.webp"
import sockBlackL from "./assets/sockBlack.png"
import sockBlackL1 from "./assets/sockBlack1.png"
import sockSWhite from "./assets/sockWhite.png"
import sockSWhite1 from "./assets/sockWhite1.png"
import sockLWhite1 from "./assets/sockWhiteL.png"





































































// ============================================================
// 🖼️ EMBEDDED IMAGES — Logo stored as base64 (do not edit)
// ============================================================
const JOMA_J = "data:image/png;base64,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";

// ============================================================
// ⚙️ CONSTANTS — Edit these to configure your store
// ============================================================

// 🔑 ADMIN PASSWORD — Change this to secure your admin panel
const ADMIN_PASSWORD = "joma2025";

// 📂 CATEGORIES — Add or remove store categories here
const CATEGORIES = ["Football", "Running","Gym", "Casual", "Futsal", "Volleyball", "Tennis & Padel", "Clothing", "Accessories"];

// 👕 CLOTHING TYPES — Sub-categories for clothing
const CLOTHING_TYPES = ["Pants", "T-Shirt", "Shorts", "Socks"];

// 🏷️ CATEGORY META — Icon and description for each category
const categoryMeta = {
  Football:   { icon: "⚽", desc: "Pitch-ready boots built for traction and control" },
  Casual:     { icon: "👟", desc: "Everyday comfort with a clean Spanish style" },
  Running:    { icon: "🏃", desc: "Lightweight shoes engineered for every km" },
  Gym:         { icon: "🏋️", desc: "Pants, T-Shirts, Shorts & Socks for every sport" },
  Futsal:     { icon: "🥅", desc: "Low-profile grip for indoor court domination" },
  Volleyball: { icon: "🏐", desc: "Explosive cushioning for jump and lateral play" },
  Clothing:   { icon: "👕", desc: "Pants, T-Shirts, Shorts & Socks for every sport" },
  Accessories: { icon: "🎒", desc: "Bags, balls, shin guards and more" },
  "Tennis & Padel": { icon: "🎾", desc: "Shoes, rackets and gear for tennis and padel" },

};

// 📏 SIZES — Default sizes shown in Admin Panel per category
const SIZES_BY_CAT = {
  Football:   ["39","40","41","42","43","44","45","46"],
  Casual:     ["38","39","40","41","42","43","44","45"],
  Running:    ["38","39","40","41","42","43","44","45","46"],
  Gym:        ["39","40","41","42","43","44","45","46"],
  Futsal:     ["39","40","41","42","43","44","45"],
  Volleyball: ["38","39","40","41","42","43","44"],
  Clothing:   ["XS","S","M","L","XL","XXL"],
  Accessories: ["One Size"],
  "Tennis & Padel": ["38","39","40","41","42","43","44","45"],
};

// 🎖️ BADGES — Available badges for products
const BADGES = ["None","NEW","BESTSELLER","PRO","SALE"];

// 🖼️ PLACEHOLDER — Grey "No Image" shown when product has no photo
const PLACEHOLDER =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 240'%3E%3Crect width='320' height='240' fill='%23dce8ff'/%3E%3Ctext x='160' y='125' text-anchor='middle' fill='%231a3a8f' font-size='13' font-family='sans-serif' opacity='0.5'%3ENo Image%3C/text%3E%3Ctext x='160' y='143' text-anchor='middle' fill='%231a3a8f' font-size='11' font-family='sans-serif' opacity='0.4'%3EClick to upload%3C/text%3E%3C/svg%3E";

// ============================================================
// 🛍️ PRODUCTS — YOUR FULL PRODUCT LIST
// Add, edit, or remove products here
// Each product needs: id, name, category, price, badge, sizes, images
// Optional: discount, discountLabel, colors, description, features
// ============================================================
const DEMO_PRODUCTS = [

    // ======================FootBall=============================

 /*{
    id: 1,
    category: "Football",
    name: "Mundial 2601 BLACK TURF",
    price: "30.000",
    description: "A reliable football boot made for turf pitches. Great grip, comfortable fit, and built to last.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "BESTSELLER",
    brand : "Joma",
    sizes: ["45.5"],
    
    images: [mundialBlack , mundialBlack1],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" },
    ],
  }*/,{
    id: 2,
    category: "Football",
    name: "MUNDIAL 2602 WHITE TURF",
    price: "30.000",
    description: "A reliable football boot made for turf pitches. Great grip, comfortable fit, and built to last.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["45.5","46"],
     stock: {"39": 1 },
    images: [mundialwhite , mundialwhite1],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780648/IMG_0888.mov", label: "Video" },
      { type: "image", url: "mundialwhite", label: "Front View" }
    ],
    
  },
  {
    id: 3,
    category: "Football",
    name: "MUNDIAL 2628 YELLOW TURF",
    price: "30.000",
    description: "A reliable football boot made for turf pitches. Great grip, comfortable fit, and built to last.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["44.5","45","45.5","46"],
     stock: {"39": 1 },
    images: [mundialYellow , mundialYellow1],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780573/IMG_0887.mov", label: "Video" },
      { type: "image", url: "mundialYellow", label: "Front View" }
    ],
    
  },{
    id: 4,
    category: "Football",
    name: "MUNDIAL 2502 WHITE TURF ",
    price: "30.000",
    description: "A reliable football boot made for turf pitches. Great grip, comfortable fit, and built to last.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand :["42","46"],
     stock: {"39": 1 },
    images: [mundialwYellow , mundialwYellow1],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780573/IMG_0886.mov", label: "Video" },
      { type: "image", url: "mundialwYellow", label: "Front View" }
    ],
    
  },
 
  ,{
    id: 5,
    category: "Football",
    name: "TOP FLEX 2601 BLACK TURF",
    price: "30.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["46"],
    images: [topflex ],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780622/IMG_0889.mov", label: "Video" },
      { type: "image", url: "topflex", label: "Front View" }
    ],
  } ,{
    id: 6,
    category: "Football",
    name: "TOP FLEX 2635 ROYAL TURF ",
    price: "30.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["46"],
    images: [topflexb ,topflexb1 , topflexb2 ],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780626/IMG_0890.mov", label: "Video" },
      { type: "image", url: "topflexb", label: "Front View" }
    ],
  } ,{
    id: 7,
    category: "Football",
    name: "TOP FLEX 2602 WHITE TURF",
    price: "30.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
   sizes: ["36","36.5","37","45","45.5","46"],
    images: [topflexbw ,topflexbw1 , topflexbw2 ],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780626/IMG_0890.mov", label: "Video" },
      { type: "image", url: "topflexbw", label: "Front View" }
    ],
  } ,
  {
    id: 8,
    category: "Football",
    name: "MAXIMA 2631 BLACK FUCHSIA TURF  ",
    price: "25.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["41","44","45","46"],
    images: [maxima , maxima1 ],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780633/IMG_0895.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  } ,
   {
    id: 9,
    category: "Football",
    name: "MAXIMA 2632 WHITE FUCHSIA TURF ",
    price: "25.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["42.5","44","44.5","45","46"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789825782/joma-maxima-maxs2632tf.jpg" , "https://res.cloudinary.com/kps0gulg/image/upload/v1789825778/joma-maxima-maxs2632tf_1.jpg"],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780627/IMG_0894.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825782/joma-maxima-maxs2632tf.jpg", label: "Front View" }
    ],
  } ,
   {
    id: 10,
    category: "Football",
    name: "MAXIMA 2603 NAVY BLUE TURF  ",
    price: "25.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["39","41","42.5","44","44.5","45","46"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789825886/MAXW2603TF_1.jpg" , "https://res.cloudinary.com/kps0gulg/image/upload/v1789825863/MAXW2603TF_2.jpg"],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780634/IMG_0892.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825886/MAXW2603TF_1.jpg", label: "Front View" }
    ],
  } ,
  {
    id: 11,
    category: "Football",
    name: "MAXIMA 2641 BLACK TURF  ",
    price: "25.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["45"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg" ],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780656/IMG_0893.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  } ,
  {
    id: 12,
    category: "Football",
    name: "MAXIMA 2638 FLUOR YELLOW TURF",
    price: "25.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynhetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
     sizes: ["45"],
    images: [maximaf , maximaf1 ],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780641/IMG_0897.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  } ,
   {
    id: 13,
    category: "Football",
    name: "MAXIMA 2608 SAFFRON TURF ",
    price: "25.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["44","44.5","45","45.5","46"],
    images : [maximao , maximao1 ],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780650/IMG_0896.mov", label: "Video" }
    ],
  } ,{
    id: 16,
    category: "Football",
    name: "DRIBLING 2608 ORANGE FLASH",
    price: "25.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    deal: true,          // ← ADD THIS
    dealPrice: "22.500", // ← ADD THIS
    discount: "20",
    badge: "",
    brand : "Joma",
     sizes: ["44","46"],
    images: [driblingorange ,driblingorange1 ],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },
  ,{
    id: 17,
    category: "Football",
    name: "AGUILA 2501 BLACK FLUOR GREEN TURF ",
    price: "25.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes:  ["40","41","42","43","44","45","46"],
    images: [aguilaBlack],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },






                          // ======================Futsal=============================

,{
    id: 50,
    category: "Futsal",
    name: "INDOOR TOP FLEX 2602 WHITE",
    price: "30.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["40.5","41","42","42.5","43","44","44.5","45","45.5"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789828359/picture.jpg", "https://res.cloudinary.com/kps0gulg/image/upload/v1789828360/TOPS2602IN_3.jpg"],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780656/IMG_0901.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789828359/picture.jpg", label: "Front View" }
    ],
  },
,{
    id: 51,
    category: "Futsal",
    name: "INDOOR TOP FLEX 2612 LIGHT GRAY",
    price: "35.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["42.5","43","44","45","45.5","46"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789828651/TOPS2612IN_1.jpg", "https://res.cloudinary.com/kps0gulg/image/upload/v1789828652/TOPS2612IN_2.jpg"],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780637/IMG_0902.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789828651/TOPS2612IN_1.jpg", label: "Front View" }
    ],
  },
  ,{
    id: 52,
    category: "Futsal",
    name: "INDOOR TOP FLEX 2632 WHITE",
    price: "35.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["40","41","42","43","44","45"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789828700/TOPS2632IN_1.jpg", "https://res.cloudinary.com/kps0gulg/image/upload/v1789828699/TOPS2632IN_2.jpg"],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780642/IMG_0903.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789828700/TOPS2632IN_1.jpg", label: "Front View" }
    ],
  },
  ,{
    id: 53,
    category: "Futsal",
    name: "INDOOR TOP FLEX 2608 ORANGE",
    price: "30.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["42","44","45"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789828753/TOPW2608IN_1.jpg", "https://res.cloudinary.com/kps0gulg/image/upload/v1789828756/TOPW2608IN_4.jpg"],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780638/IMG_0905.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789828753/TOPW2608IN_1.jpg", label: "Front View" }
    ],
  },
  ,{
    id: 54,
    category: "Futsal",
    name: "INDOOR TOP FLEX REBOUND 2631 BLACK",
    price: "40.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["41","43","44","45","45.5","46"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789828870/TORS2601IN_1.jpg", "https://res.cloudinary.com/kps0gulg/image/upload/v1789828872/TORS2601IN_2.jpg"],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780632/IMG_0900.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789828870/TORS2601IN_1.jpg", label: "Front View" }
    ],
  },
  ,{
    id: 55,
    category: "Futsal",
    name: "INDOOR TOP FLEX REBOUND 2631 BLACK",
    price: "40.000",
    description: "A solid football boot in bold royal blue, made for turf pitches. Great for players who want style and performance.",
    features: "Turf stud pattern\nSynthetic upper\nComfortable fit\nDurable sole",
    badge: "",
    brand : "Joma",
    sizes: ["39","40","40.5","41","42.5"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789828931/TORW2631IN_1.jpg", "https://res.cloudinary.com/kps0gulg/image/upload/v1789828931/TORW2631IN_1.jpg"],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780656/IMG_0904.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789828931/TORW2631IN_1.jpg", label: "Front View" }
    ],
  },




    
 ,
  
      // ======================Running=============================

      {
        id: 100,
        category: "Running",
        name: "R.6000 2609 FLUOR YELLOW",
        price: "40.000",
        description: "A clean white and gold running shoe built for comfort and speed. Lightweight and breathable for everyday runs.",
        features: "EVA cushioning midsole\nBreathable mesh upper\nAnti-slip rubber outsole\nReflective details",
        badge: "PRO",
        brand : "Joma",
        sizes: ["40","40.5","41","42","42.5","43"],
        images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789825113/R600.jpg", "https://res.cloudinary.com/kps0gulg/image/upload/v1789825112/R600_1.jpg"],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780635/IMG_0906.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825113/R600.jpg", label: "Front View" }
    ],
      },
  
  {
    id: 101,
    category: "Running",
    name: "VIPER MEN 2625 BEIGE",
    price: "40.000",
    description: "A bold fluor yellow running shoe that stands out on any track. Lightweight and responsive for daily training.",
    features: "EVA cushioning midsole\nBreathable mesh upper\nAnti-slip rubber outsole\nReflective details",
    badge: "",
    brand : "Joma",
    sizes:  ["41","42","43","44","45"],
    images: [ "https://res.cloudinary.com/kps0gulg/image/upload/v1789821201/Viper.Beige.jpg" , "https://res.cloudinary.com/kps0gulg/image/upload/v1789821201/Viper.Beige1.jpg"],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780649/IMG_0911.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789821201/Viper.Beige.jpg", label: "Front View" }
    ],

  }
  ,
   {
    id: 102,
    category: "Running",
    name: "HISPALIS 2621 BLACK",
    price: "35.000",
    description: "A bold fluor yellow running shoe that stands out on any track. Lightweight and responsive for daily training.",
    features: "EVA cushioning midsole\nBreathable mesh upper\nAnti-slip rubber outsole\nReflective details",
    badge: "",
    brand : "Joma",
    sizes: ["36","36.5","37.5","40.5","44.5","45.5"],
      images: [hispalisBlack , hispalisBlack1],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780667/IMG_0908.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],

  }
  ,
   {
    id: 103,
    category: "Running",
    name: "HISPALIS MEN 2625 BEIGE",
    price: "35.000",
    description: "A bold fluor yellow running shoe that stands out on any track. Lightweight and responsive for daily training.",
    features: "EVA cushioning midsole\nBreathable mesh upper\nAnti-slip rubber outsole\nReflective details",
    badge: "",
    brand : "Joma",
    sizes: ["39","40","40.5","41","42","45"],

      images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789820289/db7felxjq3ljvmldgrmg.jpg"],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780649/IMG_0912.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789820289/db7felxjq3ljvmldgrmg.jpg", label: "Front View" }
    ],

  }
   ,{
    id: 104,
    category: "Running",
    name: "HISPALIS 2604 ROYAL BLUE ",
    price: "35.000",
    description: "A bold fluor yellow running shoe that stands out on any track. Lightweight and responsive for daily training.",
    features: "EVA cushioning midsole\nBreathable mesh upper\nAnti-slip rubber outsole\nReflective details",
    badge: "",
    brand : "Joma",
    sizes: ["40","41","42","43","44","45","46"],
      images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789824864/Hispalis.Blue.jpg" , "https://res.cloudinary.com/kps0gulg/image/upload/v1789824863/Hispalis.Blue1.jpg"],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780661/IMG_0909.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789824864/Hispalis.Blue.jpg", label: "Front View" }
    ],

  },{
    id: 105,
    category: "Running",
    name: "HISPALIS 2609 FLUOR YELLOW  ",
    price: "35.000",
    description: "A bold fluor yellow running shoe that stands out on any track. Lightweight and responsive for daily training.",
    features: "EVA cushioning midsole\nBreathable mesh upper\nAnti-slip rubber outsole\nReflective details",
    badge: "",
    brand : "Joma",
    sizes: ["41","42","43","44","45"],
      images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789825218/Hispalis.Flash.jpg" , "https://res.cloudinary.com/kps0gulg/image/upload/v1789825223/Hispalis.Flash1.jpg"],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780665/IMG_0910.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825218/Hispalis.Flash.jpg", label: "Front View" }
    ],

  }
  ,{
    id: 106,
    category: "Running",
    name: "VICTORY 7 2632 WHITE BLUE",
    price: "30.000",
    description: "A bold fluor yellow running shoe that stands out on any track. Lightweight and responsive for daily training.",
    features: "EVA cushioning midsole\nBreathable mesh upper\nAnti-slip rubber outsole\nReflective details",
    badge: "",
    brand : "Joma",
    sizes: ["40","41","42","43","44","45","46"],
      images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789828121/RVICTW2632_1.jpg" , "https://res.cloudinary.com/kps0gulg/image/upload/v1789828122/RVICTW2632_2.jpg"],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789828121/RVICTW2632_1.jpg", label: "Front View" }
    ],

  }
 
 


       // ======================Gym=============================

  ,{
   id: 200,
    category: "Gym",
    name: "SPEED MEN 2602 WHITE ",
    price: "28.000",
    description: "Responsive EVA midsole with breathable mesh — engineered for Bahrain's heat.",
    features: "EVA cushioning midsole\nReflective details\nEngineered mesh upper\nAnti-slip rubber outsole",
    badge: "",
    brand : "Joma",
    sizes: ["42","43","44","45"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789827769/RSPEES2602_1.jpg" ,"https://res.cloudinary.com/kps0gulg/image/upload/v1789827771/RSPEES2602_2.jpg" ],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780647/IMG_0914.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789827769/RSPEES2602_1.jpg", label: "Front View" }
    ],
  },
  ,{
   id: 201,
    category: "Gym",
    name: "NEON MEN 2602 WHITE ",
    price: "25.000",
    description: "Responsive EVA midsole with breathable mesh — engineered for Bahrain's heat.",
    features: "EVA cushioning midsole\nReflective details\nEngineered mesh upper\nAnti-slip rubber outsole",
    brand : "Joma",
    sizes: ["40","41","42","43","44","45"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789827830/RNEOW2602_1.jpg" ,"https://res.cloudinary.com/kps0gulg/image/upload/v1789827832/RNEOW2602_2.jpg" ],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780649/IMG_0912.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789827830/RNEOW2602_1.jpg", label: "Front View" }
    ],
  },
  {
   id: 202,
    category: "Gym",
    name: "NEON MEN 2625 BEIGE ",
    price: "25.000",
    description: "Responsive EVA midsole with breathable mesh — engineered for Bahrain's heat.",
    features: "EVA cushioning midsole\nReflective details\nEngineered mesh upper\nAnti-slip rubber outsole",
    brand : "Joma",
    sizes: ["41","42","43","44","45","45"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789827889/RNEOW2625_1.jpg" ,"https://res.cloudinary.com/kps0gulg/image/upload/v1789827891/RNEOW2625_2.jpg" ],
    highlights: [
      { type: "video", url: "https://res.cloudinary.com/kps0gulg/video/upload/v1790780649/IMG_0911.mov", label: "Video" },
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789827889/RNEOW2625_1.jpg", label: "Front View" }
    ],
  },{
   id: 203,
    category: "Gym",
    name: "NEON MEN 2505 SKY BLUE  ",
    price: "25.000",
    description: "Responsive EVA midsole with breathable mesh — engineered for Bahrain's heat.",
    features: "EVA cushioning midsole\nReflective details\nEngineered mesh upper\nAnti-slip rubber outsole",
    brand : "Joma",
     sizes: ["40","41","44"],
    images: [neonSky ,neonSky1 ],
    highlights: [
      { type: "image", url: "neonSky", label: "Front View" }
    ],
  },
   
 {
    id: 205,
     category: "Gym",
     name: "VITALY 2502 WHITE",
     price: "25.000",
     description: "Responsive EVA midsole with breathable mesh — engineered for Bahrain's heat.",
     features: "EVA cushioning midsole\nReflective details\nEngineered mesh upper\nAnti-slip rubber outsole",
     badge: "",
     brand : "Joma",
     deal: true,          // ← ADD THIS
     dealPrice: "15.000", // ← ADD THIS
     discount: "25",      // ← ADD THIS
     sizes: ["36"],
     images:  [vitalyWwhite , vitalyWwhite1] ,
   },

   // ======================Padel=============================

 {
  id: 2001,
  category: "Tennis & Padel",
  name: "POINT MEN 2523 WHITE",
  price: "40.000",
  description: "Tennis shoes for men. Model equipped with high technology to achieve maximum performance.",
  features: "Breathable SPORTECH VTS cut\nSTABILIS phylon midsole\nSole with optimised strength thanks to the DURABILITY technology",
  badge: "",
  deal: true,          // ← ADD THIS
  dealPrice: "27.000", // ← ADD THIS
  discount: "35",      // ← ADD THIS
  brand: "Joma",
  sizes: ["37","38","39","40"],
  images: [pointWhite , pointWhite1],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
}, 


      // ======================VollyBall=============================

   {
        id: 800,
        category: "Volleyball",
        name: "B.SCREEN 2501 BLACK ",
        price: "25.000",
        description: "Clean silhouette with foam cushioning — perfect for daily wear in Bahrain.",
        features: "Memory foam insole\nVulcanised rubber sole\nCotton canvas upper\nReinforced toe box",
        badge: "",
        deal: true,          // ← ADD THIS
        dealPrice: "20.000", // ← ADD THIS
        discount: "20",      // ← ADD THIS
        brand : "Joma",
        sizes: ["43.5","44.5","47","48"],
        images: [vscreenBlack, vscreenBlack1],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
      },{
        id: 801,
        category: "Volleyball",
        name: "B.SCREEN 2501 WHITE ",
        price: "25.000",
        description: "Clean silhouette with foam cushioning — perfect for daily wear in Bahrain.",
        features: "Memory foam insole\nVulcanised rubber sole\nCotton canvas upper\nReinforced toe box",
        badge: "",
        brand : "Joma",
        deal: true,          // ← ADD THIS
        dealPrice: "20.000", // ← ADD THIS
        discount: "20",      // ← ADD THIS
         sizes: ["37","40","40.5","42.5","43","43.5","44","44.5","45","46","47","48"],
        images: [vscreenWhite ],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
      },
  {
    id: 802,
    category: ["Volleyball","Accessories"],
    name: "KneeCap Black",
    price: "11.000",
    description: "Lateral stability zones and gel heel cushioning for hard court landings.",
    features: "Gel heel cushioning\nLateral stability zones\nNon-marking sole\nPadded ankle collar",
    badge: "PRO",
    brand : "Joma",
    featured: true,
    sizes: ["M","L"],
    images: [kneeCapB , kneeCapB1],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },
  {
    id: 803,
    category: ["Volleyball","Accessories"],
    name: "KneeCap  White",
    price: "11.000",
    description: "Mid-cut ankle support for libero and blocker positions. Superior lateral traction on indoor courts.",
    features: "Mid-cut ankle support\nLateral traction outsole\nQuick-lace system\nShock absorption foam",
    badge: "",
    brand : "Joma",
    featured: true,
    sizes: ["M","L"],
    images: [kneeCapBW , kneeCapBW1],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },


        // ======================Casual=============================
  {
    id: 300,
    category: "Casual",
    name: "RT50 MEN 2602 WHITE ",
    price: "30.000",
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
    sizes: ["40","40.5","41","42.5","43","44","44.5","45","45.5","46"],
    images: [rt50w , rt50w1],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },
   
   {
    id: 302,
    category: "Casual",
    name: "RT50 MEN 2612 GRAY ",
    price: "30.000",
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
     sizes: ["40","40.5","41","42.5","43","44","44.5","45","45.5","46"],
    images: [rt50g , rt50g1],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },
  {
    id: 303,
    category: "Casual",
    name: "LACELESS MEN 2601 BLACK ",
    price: "25.000",
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    brand : "Joma",
     sizes: ["41","42.5","43","44","44.5","45","46"],
    images: [lecelessb , lecelessb1],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },
  {
    id: 304,
    category: "Casual",
    name: "LACELESS MEN 2601 BLACK WHITE ",
    price: "25.000",
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
     sizes: ["40.5","41","42","42.5","43","44","44.5","45","45.5","46"],
    images: [lecelessbw ],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },{
    id: 305,
    category: "Casual",
    name: "LACELESS MEN 2603 NAVY BLUE ",
    price: "25.000",
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
     sizes: ["40","41","43","45","46"],
    images: [lecelessn , lecelessn1 ],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },
  
  {
    id: 306,
    category: "Casual",
    name: "ATOLON MEN 2501 BLACK ",
    price: "25.000",
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
    sizes: ["40"],
    images: [atolonBlack , atolonBlack1],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },
    {
    id: 307,
    category: "Casual",
    name: "EROS MEN 2621 BLACK ",
    price: "25.000",
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
    sizes: ["40","40.5","41","42","42.5","43","44"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789827043/CEROS2621_1.jpg" , "https://res.cloudinary.com/kps0gulg/image/upload/v1789827047/CEROS2621_2.jpg"],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789827043/CEROS2621_1.jpg", label: "Front View" }
    ],
  },
  {
    id: 308,
    category: "Casual",
    name: "EROS MEN 2603 NAVY BLUE ",
    price: "25.000",
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
    sizes: ["44","44.5","45","46"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789827181/CEROS2603_1.jpg" , "https://res.cloudinary.com/kps0gulg/image/upload/v1789827183/CEROS2603_2.jpg"],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789827181/CEROS2603_1.jpg", label: "Front View" }
    ],
  },
  {
    id: 309,
    category: "Casual",
    name: "ATENEA MEN 2601 BLACK  ",
    price: "25.000",
    deal: true,          // ← ADD THIS
    dealPrice: "18.000", // ← ADD THIS
    discount: "25",      // ← ADD THIS
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
    sizes: ["40","41","42","43","45"],
    images: [ateneaBrown],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },/*{
    id: 69,
    category: "Casual",
    name: " TESEO MEN 2603 NAVY BLUE ",
    price: "25.000",
    deal: true,          // ← ADD THIS
    dealPrice: "18.500", // ← ADD THIS
    discount: "25",      // ← ADD THIS
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
    sizes: ["41","45"],
    images: [teseoNavy , teseoNavy1],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },*/{
    id: 111,
    category: "Casual",
    name: " IRON 2615 KHAKI ",
    price: "25.000",
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    deal: true,          // ← ADD THIS
    dealPrice: "18.000", // ← ADD THIS
    discount: "25",      // ← ADD THIS
    badge: null,
    brand : "Joma",
    sizes: ["40","41","44"],
    images: [ironKhaki ,ironKhaki1 ],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },{
    id: 112,
    category: "Casual",
    name: " ZEN 2524 BROWN ",
    price: "25.000",
    deal: true,          // ← ADD THIS
    dealPrice: "16.000", // ← ADD THIS
    discount: "40",      // ← ADD THIS
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
    sizes: ["40"],
    images: [ zenBrown, ],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  },{
    id: 113,
    category: "Casual",
    name: " C.DAILY 2421 BLACK ",
    price: "25.000",
    deal: true,          // ← ADD THIS
    dealPrice: "18.000", // ← ADD THIS
    discount: "25",      // ← ADD THIS
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
     sizes: ["40"],
    images: [cdailyBlack ,cdailyBlack1 ],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" }
    ],
  }
  ,
   {
    id: 115,
    category: "Casual",
    name: " C.HOES 2621 BLACK ",
    price: "25.000",
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
    sizes: ["41","42","42.5","43","44","45"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789827254/CHEOW2625_1.jpg","https://res.cloudinary.com/kps0gulg/image/upload/v1789827264/CHEOW2625_2.jpg"],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789827254/CHEOW2625_1.jpg", label: "Front View" }
    ],
  }
  ,
   {
    id: 116,
    category: "Casual",
    name: " KRUM MEN 2601 BLACK ",
    price: "25.000",
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
    sizes: ["40","40.5","42","42.5","43","43.5","44"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789827401/CKRUMW2621_1.jpg","https://res.cloudinary.com/kps0gulg/image/upload/v1789827404/CKRUMW2621_2.jpg"],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789827401/CKRUMW2621_1.jpg", label: "Front View" }
    ],
  }
  ,
   {
    id: 117,
    category: "Casual",
    name: " ONIX MEN 2601 BLACK ",
    price: "25.000",
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
    sizes: ["40","40.5","42","42.5","43","43.5","44"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789827619/5179ca1e34c2190888f6268ba6dd1012.webp","https://res.cloudinary.com/kps0gulg/image/upload/v1789827635/06e62d30df64cc9aa263b0be8a204094.webp"],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789827619/5179ca1e34c2190888f6268ba6dd1012.webp", label: "Front View" }
    ],
  }
  ,
  {
    id: 118,
    category: "Casual",
    name: " HELEO MEN 2612 LIGHT GRAY",
    price: "25.000",
    description: "Inspired by Joma's hometown of Toledo, Spain. A minimalist everyday trainer.",
    features: "Premium nubuck leather\nOrthoLite footbed\nFlat rubber sole\nClassic Spanish design",
    badge: null,
    brand : "Joma",
    sizes: ["40","40.5","41","42","42.5","43","43.5","44"],
    images: ["https://res.cloudinary.com/kps0gulg/image/upload/v1789843077/4454d63bbd0e4acb7334f32fa0309dde.webp","https://res.cloudinary.com/kps0gulg/image/upload/v1789843079/557ed1671969572a8522722568aa26cc.webp"],
    highlights: [
      { type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789843077/4454d63bbd0e4acb7334f32fa0309dde.webp", label: "Front View" }
    ],
  }
  ,
  
        // ======================Clothing=============================
  {
    id: 600,
    category: "Clothing",
    name: "T-SHIRT COMBI BLACK",
    price: "5.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "T-Shirt",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [combiBlack , combiBlack1],
    highlights: [
      { type: "image", url: "combiBlack", label: "Front View" }
    ],
  },
  {
    id: 601,
    category: "Clothing",
    name: "T-SHIRT COMBI DARK MELANGE",
    price: "5.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "T-Shirt",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [CombiDgrey , CombiDgrey1],
    highlights: [
      { type: "image", url: "CombiDgrey", label: "Front View" }
    ],
  },
  {
    id: 602,
    category: "Clothing",
    name: "T-SHIRT COMBI WHITE",
    price: "5.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "T-Shirt",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [combiWhite , combiWhite1],
    highlights: [
      { type: "image", url: "combiWhite", label: "Front View" }
    ],
  },{
    id: 603,
    category: "Clothing",
    name: "T-SHIRT COMBI LIGHT MELANGE",
    price: "5.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "T-Shirt",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [CombiLgrey1 , CombiLgrey],
    highlights: [
      { type: "image", url: "CombiLgrey1", label: "Front View" }
    ],
  },{
    id: 604,
    category: "Clothing",
    name: "T-SHIRT COMBI DARK NAVY ",
    price: "5.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "T-Shirt",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [combiNavy , combiNavy1],
    highlights: [
      { type: "image", url: "combiNavy", label: "Front View" }
    ],
  },{
    id: 605,
    category: "Clothing",
    name: "T-SHIRT COMBI SKY BLUE",
    price: "5.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "T-Shirt",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [CombiSky , CombiSky1],
    highlights: [
      { type: "image", url: "CombiSky", label: "Front View" }
    ],
  },{
    id: 506,
    category: "Clothing",
    name: "T-SHIRT COMBI RED",
    price: "5.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "T-Shirt",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [CombiRed , CombiRed1],
    highlights: [
      { type: "image", url: "CombiRed", label: "Front View" }
    ],
  },{
    id: 607,
    category: "Clothing",
    name: "T-SHIRT COMBI BURGUNDY",
    price: "5.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "T-Shirt",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [CombiBurgundy , CombiBurgundy1],
    highlights: [
      { type: "image", url: "CombiBurgundy", label: "Front View" }
    ],
  },{
    id: 608,
    category: "Clothing",
    name: "T-SHIRT COMBI ROYAL",
    price: "5.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "T-Shirt",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [CombiRoyal , CombiRoyal1],
    highlights: [
      { type: "image", url: "CombiRoyal", label: "Front View" }
    ],
  },
  {
    id: 609,
    category: "Clothing",
    name: "STAFF PANT BLACK",
    price: "9.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "Pants",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [pantStaffB , pantStaffB1],
    highlights: [
      { type: "image", url: "pantStaffB", label: "Front View" }
    ],
  },{
    id: 610, 
    category: "Clothing",
    name: "STAFF PANT NAVY",
    price: "9.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "Pants",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [pantStaffN , pantStaffN1],
    highlights: [
      { type: "image", url: "pantStaffN", label: "Front View" }
    ],
  },{
    id: 611,
    category: "Clothing",
    name: "PANTS NILO BLACK",
    price: "9.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "Pants",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [pantNilloB , pantNilloB1],
    highlights: [
      { type: "image", url: "pantNilloB", label: "Front View" }
    ],
  },{
    id: 612,
    category: "Clothing",
    name: " PANTS NILO NAVY",
    price: "9.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "Pants",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [pantNilloN , pantNilloN1],
    highlights: [
      { type: "image", url: "pantNilloN", label: "Front View" }
    ],
  },{
    id: 613,
    category: "Clothing",
    name: " PANTS ELBA BLACK",
    price: "9.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "Pants",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [pantElbaB , pantElbaB1],
    highlights: [
      { type: "image", url: "pantElbaB", label: "Front View" }
    ],
  },{
    id: 614,
    category: "Clothing",
    name: " PANTS ELBA MELANGE",
    price: "9.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "Pants",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [pantElbaN , pantElbaN1],
    highlights: [
      { type: "image", url: "pantElbaN", label: "Front View" }
    ],
  },{
    id: 615,
    category: "Clothing",
    name: " PANTS ELBA NAVY",
    price: "9.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "Pants",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [pantElbaG , pantElbaG1],
    highlights: [
      { type: "image", url: "pantElbaG", label: "Front View" }
    ],
  },{
    id: 616,
    category: "Clothing",
    name: "SUEZ POLYFLEECE LONG PANT BLACK",
    price: "9.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "Pants",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [pantSuezB , pantSuezB1],
    highlights: [
      { type: "image", url: "pantSuezB", label: "Front View" }
    ],
  },{
    id: 617,
    category: "Clothing",
    name: "SUEZ POLYFLEECE LONG PANT NAVY",
    price: "9.000",
    description: "Lightweight performance track pants with elastic waistband — perfect for training and casual wear.",
    features: "Moisture-wicking fabric\nElastic waistband with drawstring\nTwo side zip pockets\nTapered fit",
    badge: "NEW",
    clothingType: "Pants",
    sizes: ["XS","S","M","L","XL","XXL"],
    images: [pantSuezN , pantSuezN1],
    highlights: [
      { type: "image", url: "pantSuezN", label: "Front View" }
    ],
  },
  
  
  
  
  
  {
    id: 510,
    category: ["Clothing","Accessories"],
    name: "MEDIUM SOCK BLACK ",
    price: "1.000",
    description: "Mid-cut ankle support for libero and blocker positions. Superior lateral traction on indoor courts.",
    features: "Mid-cut ankle support\nLateral traction outsole\nQuick-lace system\nShock absorption foam",
    badge: "",
    brand : "Joma",
    featured: true,
    sizes: ["FreeSize"],
    images: [sockBlackM , sockBlackM1],
    highlights: [
      { type: "image", url: "sockBlackM", label: "Front View" }
    ],
  },{
    id: 511,
    category: ["Clothing","Accessories"],
    name: "LONG SOCK BLACK ",
    price: "1.500",
    description: "Mid-cut ankle support for libero and blocker positions. Superior lateral traction on indoor courts.",
    features: "Mid-cut ankle support\nLateral traction outsole\nQuick-lace system\nShock absorption foam",
    badge: "",
    brand : "Joma",
    featured: true,
    sizes: ["FreeSize"],
    images: [sockBlackL ,sockBlackL1 ],
    highlights: [
      { type: "image", url: "sockBlackL", label: "Front View" }
    ],
  },{
    id: 566,
    category: ["Clothing","Accessories"],
    name: "LONG SOCK WHIE ",
    price: "1.500",
    description: "Mid-cut ankle support for libero and blocker positions. Superior lateral traction on indoor courts.",
    features: "Mid-cut ankle support\nLateral traction outsole\nQuick-lace system\nShock absorption foam",
    badge: "",
    brand : "Joma",
    sizes: ["FreeSize"],
    featured: true,
    images: [ sockLWhite1],
    highlights: [
      { type: "image", url: "sockLWhite1", label: "Front View" }
    ],
  },{
    id: 544,
    category: ["Clothing","Accessories"],
    name: "MEDIUM SOCK WHITE ",
    price: "1.000",
    description: "Mid-cut ankle support for libero and blocker positions. Superior lateral traction on indoor courts.",
    features: "Mid-cut ankle support\nLateral traction outsole\nQuick-lace system\nShock absorption foam",
    badge: "",
    brand : "Joma",
    featured: true,
    sizes: ["FreeSize"],
    images: [sockSWhite,sockSWhite1 ],
    highlights: [
      { type: "image", url: "sockSWhite", label: "Front View" }
    ],
  },

  // ======================Shorts=============================
  {
    id: 700,
    category: "Clothing",
    name: "GYM BERMUDA BEIGE",
    price: "TBD",
    description: "Lightweight gym bermuda shorts with elastic waistband — perfect for training and indoor workouts.",
    features: "Elastic waistband with drawstring\nBreathable lightweight fabric\nSide pockets\nComfortable fit",
    badge: "NEW",
    clothingType: "Shorts",
    brand: "Joma",
    sizes: ["M", "L", "XL"],
    images: [
      "https://gomagcdn.ro/domains/echipamentesport.ro/files/product/medium/pantaloni-scurti-indoor-gym-104194-008-380190.jpg",
      "https://www.joma-sport.com/dw/image/v2/BFRV_PRD/on/demandware.static/-/Sites-joma-masterCatalog/default/dw47e1179e/images/medium/104194.008_3.jpg?sw=900&sh=900&sm=fit",
    ],
    highlights: [
{ type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" },
    ],
  },
  {
    id: 701,
    category: "Clothing",
    name: "GYM BERMUDA BLUE",
    price: "TBD",
    description: "Lightweight gym bermuda shorts with elastic waistband — perfect for training and indoor workouts.",
    features: "Elastic waistband with drawstring\nBreathable lightweight fabric\nSide pockets\nComfortable fit",
    badge: "NEW",
    clothingType: "Shorts",
    brand: "Joma",
    sizes: ["M", "L", "XL"],
    images: [
      "https://www.joma-sport.com/dw/image/v2/BFRV_PRD/on/demandware.static/-/Sites-joma-masterCatalog/default/dwb9d26894/images/medium/104194.323_1.jpg?sw=900&sh=900&sm=fit",
    ],
    highlights: [
{ type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" },
    ],
  },
  {
    id: 702,
    category: "Clothing",
    name: "SOFT BERMUDA BLACK",
    price: "TBD",
    description: "Soft-touch bermuda shorts with a relaxed fit — versatile enough for gym sessions or casual wear.",
    features: "Soft-touch fabric\nElastic waistband\nRelaxed fit\nSide pockets",
    badge: "NEW",
    clothingType: "Shorts",
    brand: "Joma",
    sizes: ["M", "L", "XL"],
    images: [
      "https://www.joma-sport.com/dw/image/v2/BFRV_PRD/on/demandware.static/-/Sites-joma-masterCatalog/default/dwb9a30fae/images/medium/105184.100_1.jpg?sw=900&sh=900&sm=fit",
      "https://www.mundodeportivo.com.mx/cdn/shop/files/104002.100_1_900x.jpg?v=1761943844",
    ],
    highlights: [
{ type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" },
    ],
  },
  {
    id: 703,
    category: "Clothing",
    name: "SOFT BERMUDA GREEN",
    price: "TBD",
    description: "Soft-touch bermuda shorts with a relaxed fit — versatile enough for gym sessions or casual wear.",
    features: "Soft-touch fabric\nElastic waistband\nRelaxed fit\nSide pockets",
    badge: "NEW",
    clothingType: "Shorts",
    brand: "Joma",
    sizes: ["M", "L", "XL"],
    images: [
      "https://www.joma-sport.com/dw/image/v2/BFRV_PRD/on/demandware.static/-/Sites-joma-masterCatalog/default/dwfbbf11a7/images/medium/105184.172_1.jpg?sw=900&sh=900&sm=fit",
      "https://www.joma-sport.com/dw/image/v2/BFRV_PRD/on/demandware.static/-/Sites-joma-masterCatalog/default/dw7af42c0e/images/medium/105184.172_2.jpg?sw=900&sh=900&sm=fit",
    ],
    highlights: [
{ type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" },
    ],
  },
  {
    id: 704,
    category: "Clothing",
    name: "SOFT BERMUDA GRAY",
    price: "TBD",
    description: "Soft-touch bermuda shorts with a relaxed fit — versatile enough for gym sessions or casual wear.",
    features: "Soft-touch fabric\nElastic waistband\nRelaxed fit\nSide pockets",
    badge: "NEW",
    clothingType: "Shorts",
    brand: "Joma",
    sizes: ["M", "L", "XL"],
    images: [
      "https://www.joma-sport.com/dw/image/v2/BFRV_PRD/on/demandware.static/-/Sites-joma-masterCatalog/default/dw772eaf3b/images/medium/105184.278_1.jpg?sw=900&sh=900&sm=fit",
      "https://www.joma-sport.com/dw/image/v2/BFRV_PRD/on/demandware.static/-/Sites-joma-masterCatalog/default/dw80b11d45/images/medium/105184.278_2.jpg?sw=900&sh=900&sm=fit",
    ],
    highlights: [
{ type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" },
    ],
  },
  {
    id: 705,
    category: "Clothing",
    name: "SOFT LONG PANTS BLACK",
    price: "TBD",
    description: "Soft-touch long pants with a tapered leg — comfortable for training or everyday wear.",
    features: "Soft-touch fabric\nTapered leg\nElastic waistband\nSide pockets",
    badge: "NEW",
    clothingType: "Pants",
    brand: "Joma",
    sizes: ["M", "L", "XL"],
    images: [
      "https://www.joma-sport.com/dw/image/v2/BFRV_PRD/on/demandware.static/-/Sites-joma-masterCatalog/default/dw4fb2ab1b/images/medium/105183.100_1.jpg?sw=900&sh=900&sm=fit",
    ],
    highlights: [
{ type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" },
    ],
  },
  {
    id: 706,
    category: "Clothing",
    name: "SOFT LONG PANTS GRAY",
    price: "TBD",
    description: "Soft-touch long pants with a tapered leg — comfortable for training or everyday wear.",
    features: "Soft-touch fabric\nTapered leg\nElastic waistband\nSide pockets",
    badge: "NEW",
    clothingType: "Pants",
    brand: "Joma",
    sizes: ["M", "L", "XL"],
    images: [
      "https://www.joma-sport.com/dw/image/v2/BFRV_PRD/on/demandware.static/-/Sites-joma-masterCatalog/default/dw3cafc2c7/images/medium/105183.172_1.jpg?sw=900&sh=900&sm=fit",
      "https://www.joma-sport.com/dw/image/v2/BFRV_PRD/on/demandware.static/-/Sites-joma-masterCatalog/default/dw1c7f9a87/images/medium/105183.172_2.jpg?sw=900&sh=900&sm=fit",
    ],
    highlights: [
{ type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" },
    ],
  },
  {
    id: 707,
    category: "Clothing",
    name: "SOFT LONG PANTS LIGHT GRAY",
    price: "TBD",
    description: "Soft-touch long pants with a tapered leg — comfortable for training or everyday wear.",
    features: "Soft-touch fabric\nTapered leg\nElastic waistband\nSide pockets",
    badge: "NEW",
    clothingType: "Pants",
    brand: "Joma",
    sizes: ["M", "L", "XL"],
    images: [
      "https://www.joma-sport.com/dw/image/v2/BFRV_PRD/on/demandware.static/-/Sites-joma-masterCatalog/default/dw7d92e9ee/images/medium/105183.278_1.jpg?sw=900&sh=900&sm=fit",
      "https://www.joma-sport.com/dw/image/v2/BFRV_PRD/on/demandware.static/-/Sites-joma-masterCatalog/default/dw28d95a3e/images/medium/105183.278_2.jpg?sw=900&sh=900&sm=fit",
    ],
    highlights: [
{ type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" },
    ],
  },
  {
    id: 708,
    category: "Clothing",
    name: "HEROIC SHORT SLEEVE T-SHIRT WHITE BLACK",
    price: "TBD",
    description: "Classic short sleeve t-shirt with a heroic design — comfortable for training or everyday wear.",
    features: "Breathable fabric\nClassic fit\nShort sleeve\nDurable stitching",
    badge: "NEW",
    clothingType: "T-Shirt",
    brand: "Joma",
    sizes: ["M", "L", "XL"],
    images: [
      "https://joma.ua/media/cache/1b/5f/1b5f4e63c72be97bba138a6880fddaad.webp",
      "https://www.joma-sport.com/dw/image/v2/BFRV_PRD/on/demandware.static/-/Sites-joma-masterCatalog/default/dwdd4d69b7/images/medium/104232.201_3.jpg?sw=900&sh=900&sm=fit",
    ],
    highlights: [
{ type: "image", url: "https://res.cloudinary.com/kps0gulg/image/upload/v1789825571/20260109090412-maxs2641tfh.jpg", label: "Front View" },
    ],
  },
];


// ============================================================
// ============================================================
// 🎨 ADMIN PANEL STYLES — Form label and input styles
// ============================================================
const labelStyle = {
  display: "block",
  fontSize: "11px",
  fontWeight: "800",
  color: "#0c1e5c",
  letterSpacing: "1.5px",
  textTransform: "uppercase",
  marginBottom: "6px",
};

const inputStyle = {
  width: "100%",
  padding: "10px 13px",
  border: "2px solid #e8eef8",
  borderRadius: "6px",
  fontSize: "13px",
  color: "#0c1e5c",
  outline: "none",
  fontFamily: "inherit",
  background: "#fafcff",
  transition: "border-color 0.2s",
};

// ============================================================
// 🔧 HELPER FUNCTIONS — Small utilities used across the app
// ============================================================
function readFileAsDataURL(file) {
  return new Promise((res, rej) => {
    const r = new FileReader();
    r.onload = () => res(r.result);
    r.onerror = rej;
    r.readAsDataURL(file);
  });
}

// ⭐ Star icon SVG used in product modal
// ============================================================
// 🏆 CUSTOM LOGO — JomaBahrainSport shield crest
// ============================================================
function JomaBHLogo({ size = 44, dark = false }) {
  const textColor = dark ? "#0c1e5c" : "#fff";
  const subColor = dark ? "#7a9acf" : "rgba(255,255,255,0.8)";
  const shieldFill = dark ? "#0c1e5c" : "rgba(255,255,255,0.12)";
  const shieldStroke = dark ? "#1a3a8f" : "rgba(255,255,255,0.5)";
  const w = size * 0.85;
  return (
    <svg width={w} height={size} viewBox="0 0 44 52" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M22 2 L40 9 L40 28 C40 38 32 46 22 50 C12 46 4 38 4 28 L4 9 Z" fill={shieldFill} stroke={shieldStroke} strokeWidth="1.5"/>
      <path d="M22 6 L37 12 L37 28 C37 36 30 43 22 47 C14 43 7 36 7 28 L7 12 Z" fill="none" stroke={dark ? "#7ab4ff" : "rgba(255,255,255,0.25)"} strokeWidth="0.8"/>
      <polygon points="22,10 23.2,13.6 27,13.6 24,15.8 25.2,19.4 22,17.2 18.8,19.4 20,15.8 17,13.6 20.8,13.6" fill="#f59e0b"/>
      <text x="22" y="30" textAnchor="middle" fill={textColor} fontSize="9" fontWeight="900" fontFamily="Georgia, serif" letterSpacing="2">JOMA</text>
      <line x1="10" y1="32" x2="34" y2="32" stroke={dark ? "#7ab4ff" : "rgba(255,255,255,0.35)"} strokeWidth="0.6"/>
      <text x="22" y="40" textAnchor="middle" fill={subColor} fontSize="5.5" fontWeight="700" fontFamily="sans-serif" letterSpacing="1.5">BAHRAIN</text>
    </svg>
  );
}


// ============================================================
// 🔧 HELPER — Check if product belongs to a category
// Supports both single: category: "Football"
// and multiple: category: ["Football", "Futsal"]
// ============================================================
function hasCategory(product, cat) {
  if (!product.category) return false;
  if (Array.isArray(product.category)) return product.category.includes(cat);
  return product.category === cat;
}

function getFirstCategory(product) {
  if (!product.category) return "";
  if (Array.isArray(product.category)) return product.category[0];
  return product.category;
}

function StarIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
      <polygon points="8,1 10,6 15,6 11,9.5 12.5,15 8,11.5 3.5,15 5,9.5 1,6 6,6" />
    </svg>
  );
}

// ============================================================
// 🪟 PRODUCT DETAIL MODAL
// Popup shown when customer clicks "Details" on a product
// Shows: image gallery, name, price, sizes, features, Add to Cart
// ============================================================
function ProductModal({ product, onClose, onAdd, wishlisted, onWishlist, allProducts = [], onOpen, showPrice = (p) => `BD ${parseFloat(p).toFixed(3)}`, visitorCurrency = { code: "BHD" }, onShowStories }) {
  const [activeImg, setActiveImg] = useState(0);
  const [selectedSize, setSelectedSize] = useState(null);
  const [added, setAdded] = useState(false);
  const [lightbox, setLightbox] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const handleTouchStart = (e) => { touchStartX.current = e.targetTouches[0].clientX; };
  const handleTouchMove = (e) => { touchEndX.current = e.targetTouches[0].clientX; };
  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > 40) {
      if (diff > 0) setActiveImg(i => (i + 1) % images.length);
      else setActiveImg(i => (i - 1 + images.length) % images.length);
    }
  };
  const features = product.features ? product.features.split("\n").filter(Boolean) : [];
  const images = product.images && product.images.length > 0 ? product.images : [PLACEHOLDER];

  const handleAdd = () => {
    if (!selectedSize) { alert("Please select a size first"); return; }
    const priceToUse = product.dealPrice || product.price;
    onAdd({ ...product, price: priceToUse, selectedSize });
    setAdded(true);
    setTimeout(() => setAdded(false), 2000);
  };

  return (
    <div
      style={{ position: "fixed", inset: 0, zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", overscrollBehavior: "contain" }}
      onClick={e => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div onClick={onClose} style={{ position: "absolute", inset: 0, background: "rgba(6,15,46,0.75)", backdropFilter: "blur(4px)" }} />
      <div style={{
        position: "relative", background: "#fff", borderRadius: "12px",
        width: "min(94vw, 900px)", maxHeight: "90vh", overflow: "hidden",
        display: "flex", animation: "modalIn 0.3s ease",
        boxShadow: "0 40px 80px rgba(0,0,0,0.35)",
      }} className="joma-modal-inner">
        <button onClick={onClose} style={{
          position: "fixed", top: "14px", right: "14px", zIndex: 2000,
          background: "#0c1e5c", border: "none", borderRadius: "50%",
          width: "36px", height: "36px", fontSize: "16px", cursor: "pointer",
          color: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
        }}>✕</button>

        {/* Gallery */}
        <div className="joma-modal-gallery" style={{ width: "48%", background: "#f0f5ff", display: "flex", flexDirection: "column", flexShrink: 0, position: "relative" }}>
          {product.discount && (
            <div style={{ position: "absolute", top: "12px", left: "12px", zIndex: 5, background: "#e63946", color: "#fff", fontSize: "10px", fontWeight: "900", letterSpacing: "1px", padding: "5px 12px", borderRadius: "3px" }}>
              {product.discountLabel ? `🏷️ ${product.discountLabel} -${product.discount}%` : `-${product.discount}% OFF`}
            </div>
          )}
          {/* Lightbox fullscreen */}
          {lightbox && (
            <div onClick={() => setLightbox(false)} style={{
              position: "fixed", inset: 0, zIndex: 2000, background: "rgba(0,0,0,0.95)",
              display: "flex", alignItems: "center", justifyContent: "center", cursor: "zoom-out",
            }}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}>
              <button onClick={() => setLightbox(false)} style={{
                position: "absolute", top: "16px", right: "16px",
                background: "rgba(255,255,255,0.15)", border: "none", borderRadius: "50%",
                width: "40px", height: "40px", fontSize: "18px", cursor: "pointer", color: "#fff",
                display: "flex", alignItems: "center", justifyContent: "center",
              }}>✕</button>
              <img src={images[activeImg]} alt={product.name} style={{ maxWidth: "95vw", maxHeight: "95vh", objectFit: "contain" }} />
              {images.length > 1 && (
                <button onClick={e => { e.stopPropagation(); setActiveImg(i => (i - 1 + images.length) % images.length); }} style={{
                  position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)",
                  background: "#1a3a8f", border: "none",
                  borderRadius: "50%", width: "48px", height: "48px", fontSize: "26px", cursor: "pointer", color: "#fff",
                  display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "900",
                  zIndex: 10, boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                }}>‹</button>
              )}
              {images.length > 1 && (
                <button onClick={e => { e.stopPropagation(); setActiveImg(i => (i + 1) % images.length); }} style={{
                  position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)",
                  background: "#1a3a8f", border: "none",
                  borderRadius: "50%", width: "48px", height: "48px", fontSize: "26px", cursor: "pointer", color: "#fff",
                  display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "900",
                  zIndex: 10, boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
                }}>›</button>
              )}
              {images.length > 1 && (
                <div style={{ position: "absolute", bottom: "20px", display: "flex", gap: "8px" }}>
                  {images.map((_, idx) => (
                    <div key={idx} onClick={e => { e.stopPropagation(); setActiveImg(idx); }} style={{
                      width: activeImg === idx ? "24px" : "8px", height: "8px",
                      borderRadius: "4px", background: activeImg === idx ? "#fff" : "rgba(255,255,255,0.4)",
                      cursor: "pointer",
                    }} />
                  ))}
                </div>
              )}
            </div>
          )}

          <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "28px", minHeight: "280px", cursor: "zoom-in", position: "relative" }}
            onClick={() => setLightbox(true)}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}>
            {/* Prev button - mobile */}
            {images.length > 1 && (
              <button onClick={e => { e.stopPropagation(); setActiveImg(i => (i - 1 + images.length) % images.length); }} style={{
                position: "absolute", left: "8px", top: "50%", transform: "translateY(-50%)",
                background: "rgba(12,30,92,0.7)", color: "#fff", border: "none",
                width: "32px", height: "32px", borderRadius: "50%", fontSize: "16px",
                cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                zIndex: 5,
              }}>‹</button>
            )}
            {/* Next button - mobile */}
            {images.length > 1 && (
              <button onClick={e => { e.stopPropagation(); setActiveImg(i => (i + 1) % images.length); }} style={{
                position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)",
                background: "rgba(12,30,92,0.7)", color: "#fff", border: "none",
                width: "32px", height: "32px", borderRadius: "50%", fontSize: "16px",
                cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
                zIndex: 5,
              }}>›</button>
            )}
            {/* Image counter */}
            {images.length > 1 && (
              <div style={{ position: "absolute", bottom: "8px", left: "8px", background: "rgba(12,30,92,0.7)", color: "#fff", fontSize: "10px", fontWeight: "700", padding: "3px 8px", borderRadius: "4px", pointerEvents: "none" }}>
                {activeImg + 1} / {images.length}
              </div>
            )}
            <div style={{ position: "absolute", bottom: "8px", right: "8px", background: "rgba(26,58,143,0.7)", color: "#fff", fontSize: "10px", fontWeight: "700", padding: "4px 8px", borderRadius: "4px", pointerEvents: "none" }}>🔍 Tap to zoom</div>
            <img
              src={images[activeImg]}
              alt={product.name}
              style={{ width: "100%", maxHeight: "500px", objectFit: "contain" }}
              className="joma-modal-main-img"
            />
          </div>
          {images.length > 1 && (
            <div style={{ display: "flex", gap: "8px", padding: "10px 14px", background: "rgba(255,255,255,0.6)", borderTop: "1px solid #e0eaff", overflowX: "auto" }}>
              {images.map((img, i) => (
                <div
                  key={i}
                  onClick={() => { setActiveImg(i); setLightbox(false); }}
                  style={{
                    width: "58px", height: "46px", borderRadius: "5px", overflow: "hidden", flexShrink: 0,
                    border: activeImg === i ? "2px solid #1a3a8f" : "2px solid transparent",
                    cursor: "pointer", background: "#fff",
                    display: "flex", alignItems: "center", justifyContent: "center",
                  }}
                >
                  <img src={img} alt="" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Info */}
        <div className="joma-modal-info" style={{ flex: 1, padding: "28px", overflowY: "scroll", overflowX: "hidden", display: "flex", flexDirection: "column", gap: "14px", WebkitOverflowScrolling: "touch", touchAction: "pan-y", minHeight: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ fontSize: "10px", letterSpacing: "2px", color: "#7a9acf", fontWeight: "700", textTransform: "uppercase" }}>
              {categoryMeta[getFirstCategory(product)] ? categoryMeta[getFirstCategory(product)].icon : ""} {Array.isArray(product.category) ? product.category.join(" · ") : product.category}
            </span>
            {product.badge && product.badge !== "None" && (
              <span style={{
                background: product.badge === "PRO" ? "#e63946" : product.badge === "BESTSELLER" ? "#0c6e3a" : product.badge === "SALE" ? "#f59e0b" : "#1a3a8f",
                color: "#fff", fontSize: "9px", fontWeight: "900", letterSpacing: "1.5px", padding: "3px 8px", borderRadius: "2px",
              }}>{product.badge}</span>
            )}
          </div>

          <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "24px", fontWeight: "900", color: "#0c1e5c", margin: 0 }}>
            {product.name}
          </h2>

          <div>
            {product.discount ? (
              <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                <span style={{ fontSize: "26px", fontWeight: "900", color: "#e63946", fontFamily: "'Playfair Display', Georgia, serif" }}>
                  {showPrice(product.dealPrice ? product.dealPrice : (parseFloat(product.price) * (1 - parseFloat(product.discount) / 100)).toFixed(3))}
                </span>
                <span style={{ fontSize: "16px", color: "#aab4c8", textDecoration: "line-through", fontFamily: "'Playfair Display', Georgia, serif" }}>{showPrice(product.originalPrice || product.price)}</span>
              </div>
            ) : (
              <div style={{ fontSize: "26px", fontWeight: "900", color: "#1a3a8f", fontFamily: "'Playfair Display', Georgia, serif" }}>
                {showPrice(product.price)}
                <span style={{ fontSize: "12px", color: "#7a9acf", fontWeight: "600", marginLeft: "8px", fontFamily: "sans-serif" }}>incl. VAT</span>
              </div>
            )}
          </div>

          <p style={{ fontSize: "13px", color: "#4a6aab", lineHeight: "1.7", margin: 0 }}>{product.description}</p>

          {product.sizes && product.sizes.length > 0 && (
            <div>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "7px" }}>
                <span style={{ fontSize: "10px", fontWeight: "800", color: "#0c1e5c", letterSpacing: "1.5px", textTransform: "uppercase" }}>Size (EU)</span>
                <span style={{ fontSize: "10px", color: "#7a9acf", textDecoration: "underline", cursor: "pointer" }}>Size Guide</span>
              </div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {product.sizes.map(sz => {
                  const qty = product.stock ? product.stock[sz] : undefined;
                  const outOfStock = qty === 0;
                  const lowStock = qty !== undefined && qty > 0 && qty <= 3;
                  return (
                    <button
                      key={sz}
                      onClick={() => !outOfStock && setSelectedSize(sz)}
                      style={{
                        minWidth: "42px", height: "44px", padding: "0 8px",
                        border: selectedSize === sz ? "2px solid #1a3a8f" : outOfStock ? "2px solid #e8eef8" : "2px solid #dce8ff",
                        background: selectedSize === sz ? "#1a3a8f" : outOfStock ? "#f8f8f8" : "#fff",
                        color: selectedSize === sz ? "#fff" : outOfStock ? "#ccc" : "#0c1e5c",
                        borderRadius: "4px", cursor: outOfStock ? "not-allowed" : "pointer",
                        position: "relative", textDecoration: outOfStock ? "line-through" : "none",
                        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "1px",
                      }}
                    >
                      <span style={{ fontSize: "12px", fontWeight: "700", lineHeight: 1 }}>{sz}</span>
                      {qty !== undefined && (
                        <span style={{ fontSize: "8px", fontWeight: "600", lineHeight: 1,
                          color: outOfStock ? "#ccc" : lowStock ? (selectedSize === sz ? "#ffd700" : "#f59e0b") : (selectedSize === sz ? "rgba(255,255,255,0.7)" : "#0c6e3a")
                        }}>
                          {outOfStock ? "sold" : lowStock ? `${qty} left` : "✓"}
                        </span>
                      )}
                    </button>
                  );
                })}
              </div>
              {selectedSize && product.stock && product.stock[selectedSize] !== undefined && (
                <div style={{ fontSize: "11px", marginTop: "4px" }}>
                  {product.stock[selectedSize] === 0 && <span style={{ color: "#e63946", fontWeight: "700" }}>❌ Out of stock in size {selectedSize}</span>}
                  {product.stock[selectedSize] > 0 && product.stock[selectedSize] <= 3 && <span style={{ color: "#f59e0b", fontWeight: "700" }}>⚠️ Only {product.stock[selectedSize]} left in size {selectedSize}!</span>}
                  {product.stock[selectedSize] > 3 && <span style={{ color: "#0c6e3a", fontWeight: "700" }}>✓ In stock</span>}
                </div>
              )}
              {!selectedSize && (
                <p style={{ fontSize: "11px", color: "#e63946", marginTop: "5px", fontWeight: "600" }}>* Select a size</p>
              )}
            </div>
          )}

          {features.length > 0 && (
            <div>
              <div style={{ fontSize: "10px", fontWeight: "800", color: "#0c1e5c", letterSpacing: "1.5px", marginBottom: "7px", textTransform: "uppercase" }}>Key Features</div>
              {features.map((f, i) => (
                <div key={i} style={{ display: "flex", alignItems: "center", gap: "7px", fontSize: "12px", color: "#4a6aab", marginBottom: "5px" }}>
                  <div style={{ width: "5px", height: "5px", borderRadius: "50%", background: "#1a3a8f", flexShrink: 0 }} />
                  {f}
                </div>
              ))}
            </div>
          )}

          {/* Story Highlights */}
          {product.highlights && product.highlights.length > 0 && (
            <div style={{ borderTop: "1px solid #e8eef8", paddingTop: "14px" }}>
              <div style={{
                fontSize: "10px", fontWeight: "800", color: "#0c1e5c",
                letterSpacing: "1.5px", textTransform: "uppercase",
                marginBottom: "10px", display: "flex", alignItems: "center", gap: "6px",
              }}>
                <span style={{ fontSize: "14px" }}>📸</span> Product Highlights
              </div>
              <div style={{ display: "flex", gap: "8px", overflowX: "auto", paddingBottom: "4px", WebkitOverflowScrolling: "touch" }}>
                {product.highlights.map((h, i) => (
                  <div
                    key={i}
                    onClick={() => onShowStories && onShowStories(i)}
                    style={{ flexShrink: 0, width: "72px", textAlign: "center", cursor: "pointer" }}
                  >
                    <div style={{
                      width: "60px", height: "60px", borderRadius: "50%",
                      padding: "3px",
                      background: "linear-gradient(45deg, #f59e0b, #e63946, #1a3a8f)",
                      margin: "0 auto 4px",
                    }}>
                      <div style={{
                        width: "100%", height: "100%", borderRadius: "50%",
                        background: "#e8eef8", display: "flex", alignItems: "center", justifyContent: "center",
                        fontSize: "20px", border: "3px solid #fff",
                      }}>{h.type === "video" ? "▶" : "👟"}</div>
                    </div>
                    <div style={{ fontSize: "8px", fontWeight: 700, color: "#0c1e5c" }}>{h.label}</div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Color Variants */}
          {(() => {
            const baseName = product.name.trim().split(" ")[0].toLowerCase();
            const variants = allProducts && baseName.length > 1 ? allProducts.filter(p => p.id !== product.id && p.name.trim().toLowerCase().startsWith(baseName)) : [];
            return variants.length > 0 && (
              <div>
                <div style={{ fontSize: "10px", fontWeight: "800", color: "#0c1e5c", letterSpacing: "1.5px", marginBottom: "8px", textTransform: "uppercase" }}>Other Colors</div>
                <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                  {variants.slice(0, 6).map(v => (
                    <div key={v.id} onClick={() => onOpen && onOpen(v)} style={{
                      width: "56px", height: "56px", border: "2px solid #e8eef8",
                      borderRadius: "8px", overflow: "hidden", cursor: "pointer",
                      background: "#f0f5ff", display: "flex", alignItems: "center", justifyContent: "center",
                      padding: "4px",
                    }}>
                      <img src={v.images && v.images[0] ? v.images[0] : PLACEHOLDER} alt={v.name}
                        style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                    </div>
                  ))}
                </div>
              </div>
            );
          })()}

          <div style={{ display: "flex", gap: "10px", marginTop: "4px" }}>
            <button
              onClick={handleAdd}
              style={{
                flex: 1, background: added ? "#0c6e3a" : "#1a3a8f", color: "#fff", border: "none",
                padding: "13px", fontSize: "12px", fontWeight: "900", letterSpacing: "2px",
                cursor: "pointer", borderRadius: "4px", textTransform: "uppercase", transition: "background 0.3s",
              }}
            >{added ? "✓ Added!" : "Add to Cart"}</button>
            <button
              onClick={() => onWishlist(product)}
              style={{
                flex: 1, background: wishlisted ? "#fff0f3" : "transparent",
                color: wishlisted ? "#e63946" : "#1a3a8f",
                border: wishlisted ? "2px solid #e63946" : "2px solid #1a3a8f",
                padding: "13px", fontSize: "12px", fontWeight: "900", letterSpacing: "2px",
                cursor: "pointer", borderRadius: "4px", textTransform: "uppercase", transition: "all 0.2s",
              }}
            >{wishlisted ? "♥ Saved" : "♡ Wishlist"}</button>
          </div>

          <div style={{ background: "#f0f5ff", borderRadius: "6px", padding: "11px 13px", fontSize: "12px", color: "#4a6aab", display: "flex", gap: "8px" }}>
            🇧🇭 <span><strong>Free delivery across Bahrain</strong> · Ships in 1–2 business days</span>
          </div>

          {/* Share buttons */}
          <div>
            <div style={{ fontSize: "10px", fontWeight: "800", color: "#0c1e5c", letterSpacing: "1.5px", marginBottom: "8px", textTransform: "uppercase" }}>Share This Product</div>
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
              <button onClick={() => {
                const productUrl = `${window.location.origin}/?product=${product.id}`;
                const msg = `Check out this product from JomaBahrainSport! 🛍️

👟 *${product.name}*
💰 BD ${parseFloat(product.price).toFixed(3)}

Visit: ${productUrl}`;
                window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank");
              }} style={{ display: "flex", alignItems: "center", gap: "6px", background: "#25D366", color: "#fff", border: "none", padding: "8px 14px", borderRadius: "6px", fontSize: "11px", fontWeight: "800", cursor: "pointer" }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                WhatsApp
              </button>
              {navigator.share && (
                <button onClick={() => navigator.share({ title: product.name, text: `Check out ${product.name} — BD ${parseFloat(product.price).toFixed(3)} at JomaBahrainSport!`, url: `${window.location.origin}/?product=${product.id}` })}
                  style={{ display: "flex", alignItems: "center", gap: "6px", background: "#1a3a8f", color: "#fff", border: "none", padding: "8px 14px", borderRadius: "6px", fontSize: "11px", fontWeight: "800", cursor: "pointer" }}>
                  📤 Share
                </button>
              )}
              <button onClick={() => {
                const productUrl = `${window.location.origin}/?product=${product.id}`;
                navigator.clipboard.writeText(productUrl).then(() => alert("Link copied! ✅\n" + productUrl));
              }} style={{ display: "flex", alignItems: "center", gap: "6px", background: "#f0f5ff", color: "#1a3a8f", border: "2px solid #dce8ff", padding: "8px 14px", borderRadius: "6px", fontSize: "11px", fontWeight: "800", cursor: "pointer" }}>
                🔗 Copy Link
              </button>
            </div>
          </div>



        </div>
      </div>
    </div>
  );
}

// ============================================================
// 📸 STORY VIEWER — Full-screen immersive story overlay
// ============================================================
function StoryViewer({ product, stories, startIndex, onClose, onNavigate }) {
  const [current, setCurrent] = useState(startIndex);
  const [progress, setProgress] = useState(0);
  const [videoReady, setVideoReady] = useState(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);
  const story = stories[current];

  useEffect(() => {
    setCurrent(startIndex);
    setProgress(0);
    setVideoReady(false);
  }, [startIndex]);

  useEffect(() => {
    if (!story) return;
    const duration = story.type === "video" ? 10000 : 5000;
    const interval = setInterval(() => {
      setProgress(p => {
        if (p >= 100) {
          if (current < stories.length - 1) {
            onNavigate(current + 1);
            return 0;
          } else {
            onClose();
            return 100;
          }
        }
        return p + (100 / (duration / 50));
      });
    }, 50);
    return () => clearInterval(interval);
  }, [current, stories.length, story, onClose, onNavigate]);

  const handleTouchStart = (e) => { touchStartX.current = e.targetTouches[0].clientX; };
  const handleTouchMove = (e) => { touchEndX.current = e.targetTouches[0].clientX; };
  const handleTouchEnd = () => {
    const diff = touchStartX.current - touchEndX.current;
    if (Math.abs(diff) > 50) {
      if (diff > 0) goNext();
      else goPrev();
    }
  };

  if (!story) return null;

  const goNext = () => {
    if (current < stories.length - 1) {
      onNavigate(current + 1);
    } else {
      onClose();
    }
  };

  const goPrev = () => {
    if (current > 0) {
      onNavigate(current - 1);
    }
  };

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 3000,
      background: "#060f2e",
      display: "flex", alignItems: "center", justifyContent: "center",
    }} onClick={onClose}>
      <div style={{
        position: "relative",
        width: "min(92vw, 420px)",
        height: "min(85vh, 750px)",
        background: "#0c1e5c",
        borderRadius: "16px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }} onClick={e => e.stopPropagation()}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}>
        {/* Progress bars */}
        <div style={{ display: "flex", gap: "3px", padding: "12px 12px 0", position: "relative", zIndex: 2 }}>
          {stories.map((_, i) => (
            <div key={i} style={{ flex: 1, height: "2px", background: "rgba(255,255,255,0.3)", borderRadius: "1px", overflow: "hidden" }}>
              <div style={{
                height: "100%",
                background: "#fff",
                width: i < current ? "100%" : i === current ? `${progress}%` : "0%",
                transition: "width 0.05s linear",
              }} />
            </div>
          ))}
        </div>

        {/* Header */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px", padding: "12px 16px", position: "relative", zIndex: 2 }}>
          <div style={{
            width: "32px", height: "32px", borderRadius: "50%",
            background: "linear-gradient(45deg, #f59e0b, #e63946)",
            padding: "2px",
          }}>
            <div style={{
              width: "100%", height: "100%", borderRadius: "50%",
              background: "#1a3a8f", display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: "14px", border: "2px solid #0c1e5c",
            }}>👟</div>
          </div>
          <div>
            <div style={{ color: "#fff", fontSize: "12px", fontWeight: 700 }}>{product.name}</div>
            <div style={{ color: "rgba(255,255,255,0.5)", fontSize: "10px" }}>2h ago</div>
          </div>
          <button onClick={onClose} style={{
            marginLeft: "auto", background: "none", border: "none",
            color: "#fff", fontSize: "18px", cursor: "pointer",
          }}>✕</button>
        </div>

        {/* Body */}
        <div style={{
          flex: 1, display: "flex", flexDirection: "column",
          alignItems: "center", justifyContent: "center",
          padding: "16px", textAlign: "center", color: "#fff",
          position: "relative", minHeight: 0,
        }}>
          {story.type === "video" ? (
            <>
              {!videoReady && (
                <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "12px" }}>
                  <div style={{
                    width: "40px", height: "40px", borderRadius: "50%",
                    border: "3px solid rgba(255,255,255,0.3)", borderTopColor: "#fff",
                    animation: "spin 0.8s linear infinite",
                  }} />
                  <div style={{ color: "rgba(255,255,255,0.7)", fontSize: "12px" }}>Loading video...</div>
                  <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                </div>
              )}
              <video
                src={story.url}
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                onLoadedData={() => setVideoReady(true)}
                onCanPlay={() => setVideoReady(true)}
                style={{ maxWidth: "100%", maxHeight: "100%", width: "100%", height: "100%", objectFit: "contain", borderRadius: "8px", opacity: videoReady ? 1 : 0, transition: "opacity 0.3s" }}
              />
            </>
          ) : (
            <img src={story.url} alt={story.label} style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain", borderRadius: "8px" }} />
          )}
          <div style={{
            position: "absolute", bottom: "16px",
            fontSize: "14px", fontWeight: 700,
            background: "rgba(0,0,0,0.5)", padding: "6px 16px", borderRadius: "20px",
          }}>{story.label}</div>
        </div>

        {/* Nav buttons */}
        {current > 0 && (
          <button onClick={e => { e.stopPropagation(); goPrev(); }} style={{
            position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)",
            background: "rgba(255,255,255,0.15)", border: "none", color: "#fff",
            width: "36px", height: "36px", borderRadius: "50%", cursor: "pointer", fontSize: "18px", zIndex: 2,
          }}>‹</button>
        )}
        {current < stories.length - 1 && (
          <button onClick={e => { e.stopPropagation(); goNext(); }} style={{
            position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)",
            background: "rgba(255,255,255,0.15)", border: "none", color: "#fff",
            width: "36px", height: "36px", borderRadius: "50%", cursor: "pointer", fontSize: "18px", zIndex: 2,
          }}>›</button>
        )}


      </div>
    </div>
  );
}

// ============================================================
// 🃏 PRODUCT CARD
// Individual product box shown in the grid
// Shows: image, badge, discount label, name, price, color buttons
// ============================================================
function ProductCard({ product, index, onAdd, onOpen, adminMode, onDelete, wishlisted, onWishlist, showPrice = (p) => `BD ${parseFloat(p).toFixed(3)}`, onShowStories }) {
  const [hovered, setHovered] = useState(false);
  const img = product.images && product.images[0] ? product.images[0] : PLACEHOLDER;
  const highlights = product.highlights || [];

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      className="joma-product-card"
      style={{
        background: "#fff",
        border: "2px solid #e8eef8",
        borderRadius: "8px", overflow: "hidden",
        position: "relative",
      }}
    >
      {adminMode && (
        <div style={{ position: "absolute", top: "8px", right: "8px", zIndex: 5, display: "flex", gap: "5px" }}>
          <button
            onClick={e => { e.stopPropagation(); onDelete(product.id); }}
            style={{ background: "#e63946", color: "#fff", border: "none", borderRadius: "4px", padding: "5px 9px", fontSize: "11px", fontWeight: "700", cursor: "pointer" }}
          >🗑️ Delete</button>
        </div>
      )}

      <div
        onClick={() => onOpen(product)}
        style={{
          background: "linear-gradient(140deg, #dce8ff 0%, #f0f5ff 100%)",
          height: "270px", display: "flex", alignItems: "center",
          justifyContent: "center", position: "relative", overflow: "hidden", cursor: "pointer",
        }}
      >
        {product.badge && product.badge !== "None" && (
          <div style={{
            position: "absolute", top: "12px", left: "12px", zIndex: 2,
            background: product.badge === "PRO" ? "#e63946" : product.badge === "BESTSELLER" ? "#0c6e3a" : product.badge === "SALE" ? "#f59e0b" : "#1a3a8f",
            color: "#fff", fontSize: "9px", fontWeight: "900", letterSpacing: "1.5px", padding: "4px 10px", borderRadius: "2px",
          }}>{product.badge}</div>
        )}
        {product.featured && (
          <div style={{
            position: "absolute", top: "12px", right: "12px", zIndex: 2,
            background: "#f59e0b", color: "#060f2e", fontSize: "9px", fontWeight: "900",
            letterSpacing: "1px", padding: "4px 8px", borderRadius: "2px",
          }}>📌 PINNED</div>
        )}
        {product.discount && (
          <div style={{
            position: "absolute", top: product.badge && product.badge !== "None" ? "38px" : "12px", left: "12px", zIndex: 2,
            background: "#e63946", color: "#fff", fontSize: "9px", fontWeight: "900",
            letterSpacing: "1px", padding: "4px 10px", borderRadius: "2px",
          }}>{product.discountLabel ? `🏷️ ${product.discountLabel} -${product.discount}%` : `-${product.discount}% OFF`}</div>
        )}
        <div style={{
          position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1,
          opacity: hovered ? 1 : 0, transition: "opacity 0.2s", background: "rgba(26,58,143,0.08)",
        }}>
          <div style={{ background: "rgba(26,58,143,0.85)", color: "#fff", fontSize: "10px", fontWeight: "700", letterSpacing: "1.5px", padding: "7px 14px", borderRadius: "2px" }}>
            🔍 VIEW DETAILS
          </div>
        </div>
        <img
          src={img}
          alt={product.name}
          style={{ width: "100%", height: "100%", maxHeight: "250px", objectFit: "contain", padding: "10px", transition: "transform 0.3s", transform: hovered ? "scale(1.06)" : "scale(1)" }}
        />
      </div>

      <div style={{ padding: "15px 17px 17px" }}>
        <div style={{ fontSize: "9px", letterSpacing: "2px", color: "#7a9acf", fontWeight: "800", marginBottom: "3px", textTransform: "uppercase" }}>
          {categoryMeta[getFirstCategory(product)] ? categoryMeta[getFirstCategory(product)].icon : ""} {Array.isArray(product.category) ? product.category.join(" · ") : product.category}
          {product.clothingType && <span style={{ marginLeft: "6px", background: "#f0f5ff", color: "#1a3a8f", padding: "1px 6px", borderRadius: "8px", fontSize: "8px" }}>{product.clothingType}</span>}
        </div>
        <div
          onClick={() => onOpen(product)}
          style={{ fontSize: "15px", fontWeight: "800", color: "#0c1e5c", marginBottom: "4px", fontFamily: "'Playfair Display', Georgia, serif", cursor: "pointer" }}
        >
          {product.name}
        </div>
        <div style={{ fontSize: "11px", color: "#7a8aab", marginBottom: "13px", lineHeight: "1.5" }}>
          {product.description ? product.description.slice(0, 72) + "…" : ""}
        </div>

        {/* Story Highlights */}
        {highlights.filter(h => h.type === "video").length > 0 && (
          <div style={{ display: "flex", gap: "6px", marginBottom: "13px", overflowX: "auto", paddingBottom: "4px", WebkitOverflowScrolling: "touch" }}>
            {highlights.filter(h => h.type === "video").map((h, i) => (
              <div
                key={i}
                onClick={e => { e.stopPropagation(); onShowStories && onShowStories(i); }}
                style={{ flexShrink: 0, width: "48px", textAlign: "center", cursor: "pointer" }}
              >
                <div style={{
                  width: "40px", height: "40px", borderRadius: "50%",
                  padding: "2px",
                  background: "linear-gradient(45deg, #f59e0b, #e63946, #1a3a8f)",
                  margin: "0 auto 3px",
                }}>
                  <div style={{
                    width: "100%", height: "100%", borderRadius: "50%",
                    background: "#e8eef8", display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: "14px", border: "2px solid #fff",
                  }}>{h.type === "video" ? "▶" : "👟"}</div>
                </div>
                <div style={{ fontSize: "7px", fontWeight: 700, color: "#0c1e5c", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{h.label}</div>
              </div>
            ))}
          </div>
        )}

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div>
            {product.discount ? (
              <div>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <span style={{ fontWeight: "900", fontSize: "18px", color: "#e63946", fontFamily: "'Playfair Display', Georgia, serif" }}>
                    {showPrice(product.dealPrice ? product.dealPrice : (parseFloat(product.price) * (1 - parseFloat(product.discount) / 100)).toFixed(3))}
                  </span>
                </div>
                <div style={{ fontSize: "12px", color: "#aab4c8", textDecoration: "line-through", fontFamily: "'Playfair Display', Georgia, serif" }}>{showPrice(product.originalPrice || product.price)}</div>
              </div>
            ) : (
              <div style={{ fontWeight: "900", fontSize: "18px", color: "#1a3a8f", fontFamily: "'Playfair Display', Georgia, serif" }}>
                {showPrice(product.price)}
              </div>
            )}
          </div>
          <div style={{ display: "flex", gap: "5px" }}>
            <button
              onClick={() => onOpen(product)}
              style={{ background: "transparent", color: "#1a3a8f", border: "2px solid #dce8ff", padding: "6px 10px", fontSize: "10px", cursor: "pointer", borderRadius: "3px", fontWeight: "700" }}
            >Details</button>
            <button
              onClick={() => onAdd(product)}
              style={{
                background: "transparent",
                color: "#1a3a8f",
                border: "2px solid #1a3a8f", padding: "6px 12px", fontSize: "10px", fontWeight: "900",
                letterSpacing: "1px", cursor: "pointer", borderRadius: "3px", textTransform: "uppercase",
              }}
            >+ Cart</button>
            <button
              onClick={e => { e.stopPropagation(); onWishlist(product); }}
              style={{
                background: wishlisted ? "#fff0f3" : "transparent",
                color: wishlisted ? "#e63946" : "#7a9acf",
                border: wishlisted ? "2px solid #e63946" : "2px solid #dce8ff",
                padding: "6px 10px", fontSize: "14px", cursor: "pointer", borderRadius: "3px",
                transition: "all 0.2s", lineHeight: 1,
              }}
            >{wishlisted ? "♥" : "♡"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ============================================================
// 🔐 ADMIN PANEL — Press Ctrl+Shift+A then enter password
// Add, edit, delete products and upload photos
// ============================================================
function AdminPanel({ products, onSave, onClose }) {
  const [productList, setProductList] = useState(products);
  const [view, setView] = useState("list");
  const [editingId, setEditingId] = useState(null);
  const [deleteConfirm, setDeleteConfirm] = useState(null);

  const emptyForm = {
    id: Date.now(), name: "", category: "Football", price: "",
    description: "", features: "", badge: "None",
    sizes: ["40","41","42","43"],
    images: [],
  };
  const [form, setForm] = useState(emptyForm);
  const [imgPreviews, setImgPreviews] = useState([]);
  const [dragOver, setDragOver] = useState(false);
  const fileRef = useRef();

  const openNew = () => {
    setForm({ ...emptyForm, id: Date.now() });
    setImgPreviews([]);
    setEditingId(null);
    setView("form");
  };

  const openEdit = (p) => {
    setForm({
      ...p,
      features: typeof p.features === "string" ? p.features : (Array.isArray(p.features) ? p.features.join("\n") : ""),
    });
    setImgPreviews((p.images || []).filter(i => i !== PLACEHOLDER));
    setEditingId(p.id);
    setView("form");
  };

  const handleDelete = (id) => {
    setProductList(prev => prev.filter(p => p.id !== id));
    setDeleteConfirm(null);
  };

  const handleImgUpload = async (files) => {
    const slots = 4 - imgPreviews.length;
    if (slots <= 0) return;
    const arr = Array.from(files).slice(0, slots);
    const results = await Promise.all(arr.map(readFileAsDataURL));
    setImgPreviews(prev => [...prev, ...results].slice(0, 4));
  };

  const toggleSize = (sz) => {
    setForm(prev => ({
      ...prev,
      sizes: prev.sizes.includes(sz) ? prev.sizes.filter(s => s !== sz) : [...prev.sizes, sz],
    }));
  };

  const handleCategoryChange = (cat) => {
    setForm(prev => ({
      ...prev,
      category: cat,
      sizes: SIZES_BY_CAT[cat] ? SIZES_BY_CAT[cat].slice(0, 5) : ["S","M","L","XL"],
      clothingType: cat === "Clothing" ? "T-Shirt" : undefined,
    }));
  };

  const handleSubmit = () => {
    if (!form.name.trim()) { alert("Product name is required"); return; }
    if (!form.price || isNaN(parseFloat(form.price))) { alert("Enter a valid price"); return; }
    if (form.sizes.length === 0) { alert("Select at least one size"); return; }
    const finalProduct = {
      ...form,
      id: editingId || Date.now(),
      images: imgPreviews.length > 0 ? imgPreviews : [PLACEHOLDER],
      price: parseFloat(form.price).toFixed(3),
    };
    if (editingId) {
      setProductList(prev => prev.map(p => p.id === editingId ? finalProduct : p));
    } else {
      setProductList(prev => [...prev, finalProduct]);
    }
    setView("list");
    setEditingId(null);
  };

  const handlePublish = () => {
    onSave(productList);
    onClose();
  };

  // ── LIST VIEW ──
  if (view === "list") {
    return (
      <div style={{ position: "fixed", inset: 0, zIndex: 2000, background: "rgba(6,15,46,0.85)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ background: "#fff", borderRadius: "12px", width: "min(96vw, 860px)", maxHeight: "92vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 40px 80px rgba(0,0,0,0.4)" }}>

          <div style={{ background: "linear-gradient(135deg, #0c1e5c, #1a3a8f)", padding: "20px 28px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <JomaBHLogo size={36} dark={false} />
              <div>
                <div style={{ color: "#fff", fontSize: "16px", fontWeight: "900", fontFamily: "'Playfair Display', Georgia, serif" }}>Admin Panel</div>
                <div style={{ color: "rgba(255,255,255,0.6)", fontSize: "11px", letterSpacing: "1.5px" }}>PRODUCT MANAGER</div>
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px" }}>
              <button onClick={openNew} style={{ background: "#fff", color: "#1a3a8f", border: "none", padding: "9px 18px", fontSize: "12px", fontWeight: "900", cursor: "pointer", borderRadius: "5px" }}>+ Add Product</button>
              <button onClick={handlePublish} style={{ background: "#22c55e", color: "#fff", border: "none", padding: "9px 18px", fontSize: "12px", fontWeight: "900", cursor: "pointer", borderRadius: "5px" }}>✓ Publish ({productList.length})</button>
              <button onClick={onClose} style={{ background: "rgba(255,255,255,0.15)", color: "#fff", border: "none", padding: "9px 14px", fontSize: "14px", cursor: "pointer", borderRadius: "5px" }}>✕</button>
            </div>
          </div>

          <div style={{ background: "#f8faff", borderBottom: "2px solid #e8eef8", padding: "12px 28px", display: "flex", gap: "28px" }}>
            {["All", ...CATEGORIES].map(cat => {
              const count = cat === "All" ? productList.length : productList.filter(p => hasCategory(p, cat)).length;
              return (
                <div key={cat} style={{ textAlign: "center" }}>
                  <div style={{ fontSize: "18px", fontWeight: "900", color: "#1a3a8f", fontFamily: "'Playfair Display', Georgia, serif" }}>{count}</div>
                  <div style={{ fontSize: "9px", letterSpacing: "1.5px", color: "#7a9acf", fontWeight: "700" }}>{cat === "All" ? "TOTAL" : cat.toUpperCase()}</div>
                </div>
              );
            })}
          </div>

          <div style={{ flex: 1, overflowY: "auto", padding: "20px 28px" }}>
            {productList.length === 0 ? (
              <div style={{ textAlign: "center", padding: "60px 20px", color: "#7a9acf" }}>
                <div style={{ fontSize: "48px", marginBottom: "16px" }}>📦</div>
                <div style={{ fontSize: "16px", fontWeight: "700" }}>No products yet</div>
                <div style={{ fontSize: "13px", marginTop: "6px" }}>Click "+ Add Product" to get started</div>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {productList.map(p => (
                  <div key={p.id} style={{ display: "flex", alignItems: "center", gap: "14px", background: "#fff", border: "2px solid #e8eef8", borderRadius: "8px", padding: "12px 16px" }}>
                    <div style={{ width: "64px", height: "50px", background: "#f0f5ff", borderRadius: "5px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <img src={p.images && p.images[0] ? p.images[0] : PLACEHOLDER} alt="" style={{ width: "60px", height: "46px", objectFit: "contain" }} />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "7px", marginBottom: "2px" }}>
                        <span style={{ fontSize: "14px", fontWeight: "800", color: "#0c1e5c", fontFamily: "'Playfair Display', Georgia, serif" }}>{p.name}</span>
                        {p.badge && p.badge !== "None" && (
                          <span style={{ background: p.badge === "PRO" ? "#e63946" : p.badge === "BESTSELLER" ? "#0c6e3a" : p.badge === "SALE" ? "#f59e0b" : "#1a3a8f", color: "#fff", fontSize: "8px", fontWeight: "900", padding: "2px 6px", borderRadius: "2px" }}>{p.badge}</span>
                        )}
                      </div>
                      <div style={{ fontSize: "11px", color: "#7a9acf", fontWeight: "600" }}>
                        {categoryMeta[p.category] ? categoryMeta[p.category].icon : ""} {p.category} · BD {parseFloat(p.price).toFixed(3)} · Sizes: {p.sizes ? p.sizes.join(", ") : ""}
                      </div>
                    </div>
                    <div style={{ fontSize: "11px", color: "#7a9acf", fontWeight: "600" }}>🖼️ {p.images ? p.images.length : 0}</div>
                    <div style={{ display: "flex", gap: "6px" }}>
                      <button
                        onClick={() => {
                          const updated = productList.map(item =>
                            item.id === p.id ? { ...item, featured: !item.featured } : item
                          );
                          setProductList(updated);
                        }}
                        style={{
                          background: p.featured ? "#fff8e1" : "#f0f5ff",
                          color: p.featured ? "#b45309" : "#7a9acf",
                          border: p.featured ? "1.5px solid #f59e0b" : "1.5px solid #e8eef8",
                          padding: "7px 10px", fontSize: "11px", fontWeight: "700", cursor: "pointer", borderRadius: "4px",
                        }}
                        title={p.featured ? "Unpin from top" : "Pin to top"}
                      >{p.featured ? "📌 Pinned" : "📌 Pin"}</button>
                      <button onClick={() => openEdit(p)} style={{ background: "#f0f5ff", color: "#1a3a8f", border: "none", padding: "7px 12px", fontSize: "11px", fontWeight: "700", cursor: "pointer", borderRadius: "4px" }}>✏️ Edit</button>
                      {deleteConfirm === p.id ? (
                        <>
                          <button onClick={() => handleDelete(p.id)} style={{ background: "#e63946", color: "#fff", border: "none", padding: "7px 10px", fontSize: "11px", fontWeight: "700", cursor: "pointer", borderRadius: "4px" }}>Confirm</button>
                          <button onClick={() => setDeleteConfirm(null)} style={{ background: "#f0f5ff", color: "#7a9acf", border: "none", padding: "7px 8px", fontSize: "11px", cursor: "pointer", borderRadius: "4px" }}>Cancel</button>
                        </>
                      ) : (
                        <button onClick={() => setDeleteConfirm(p.id)} style={{ background: "#fff0f0", color: "#e63946", border: "none", padding: "7px 10px", fontSize: "11px", fontWeight: "700", cursor: "pointer", borderRadius: "4px" }}>🗑️</button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // ──
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 2000, background: "rgba(6,15,46,0.85)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#fff", borderRadius: "12px", width: "min(96vw, 860px)", maxHeight: "94vh", overflow: "hidden", display: "flex", flexDirection: "column", boxShadow: "0 40px 80px rgba(0,0,0,0.4)" }}>

        <div style={{ background: "linear-gradient(135deg, #0c1e5c, #1a3a8f)", padding: "18px 26px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ color: "#fff", fontSize: "16px", fontWeight: "900", fontFamily: "'Playfair Display', Georgia, serif" }}>
            {editingId ? "✏️ Edit Product" : "➕ Add New Product"}
          </div>
          <div style={{ display: "flex", gap: "8px" }}>
            <button onClick={() => setView("list")} style={{ background: "rgba(255,255,255,0.15)", color: "#fff", border: "none", padding: "8px 16px", fontSize: "12px", fontWeight: "700", cursor: "pointer", borderRadius: "4px" }}>← Back</button>
            <button onClick={handleSubmit} style={{ background: "#22c55e", color: "#fff", border: "none", padding: "8px 20px", fontSize: "12px", fontWeight: "900", cursor: "pointer", borderRadius: "4px" }}>
              {editingId ? "✓ Save Changes" : "✓ Add Product"}
            </button>
          </div>
        </div>

        <div style={{ flex: 1, overflowY: "auto", padding: "24px 28px", display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>

          {/* LEFT */}
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            <div>
              <label style={labelStyle}>Product Name *</label>
              <input
                value={form.name}
                onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
                placeholder="e.g. Aguila Cup FG"
                style={inputStyle}
              />
            </div>

            <div>
              <label style={labelStyle}>Category *</label>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "7px" }}>
                {CATEGORIES.map(cat => (
                  <button key={cat} onClick={() => handleCategoryChange(cat)} style={{
                    padding: "7px 14px", fontSize: "11px", fontWeight: "800", borderRadius: "4px", cursor: "pointer",
                    border: form.category === cat ? "2px solid #1a3a8f" : "2px solid #e8eef8",
                    background: form.category === cat ? "#1a3a8f" : "#f8faff",
                    color: form.category === cat ? "#fff" : "#0c1e5c",
                  }}>
                    {categoryMeta[cat].icon} {cat}
                  </button>
                ))}
              </div>
            </div>

            {/* Clothing type selector */}
            {form.category === "Clothing" && (
              <div>
                <label style={labelStyle}>Clothing Type *</label>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "7px" }}>
                  {CLOTHING_TYPES.map(type => (
                    <button key={type} onClick={() => setForm(p => ({ ...p, clothingType: type }))} style={{
                      padding: "7px 14px", fontSize: "11px", fontWeight: "800", borderRadius: "4px", cursor: "pointer",
                      border: form.clothingType === type ? "2px solid #e63946" : "2px solid #e8eef8",
                      background: form.clothingType === type ? "#e63946" : "#f8faff",
                      color: form.clothingType === type ? "#fff" : "#0c1e5c",
                    }}>
                      {type === "Pants" ? "👖" : type === "T-Shirt" ? "👕" : type === "Shorts" ? "🩳" : "🧦"} {type}
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div>
              <label style={labelStyle}>Price (BD) *</label>
              <div style={{ position: "relative" }}>
                <span style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", color: "#7a9acf", fontWeight: "700", fontSize: "13px" }}>BD</span>
                <input
                  value={form.price}
                  onChange={e => setForm(p => ({ ...p, price: e.target.value }))}
                  placeholder="0.000"
                  type="number"
                  step="0.001"
                  style={{ ...inputStyle, paddingLeft: "38px" }}
                />
              </div>
            </div>

            <div>
              <label style={labelStyle}>Badge</label>
              <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                {BADGES.map(b => (
                  <button key={b} onClick={() => setForm(p => ({ ...p, badge: b }))} style={{
                    padding: "6px 12px", fontSize: "10px", fontWeight: "800", borderRadius: "4px", cursor: "pointer",
                    border: form.badge === b ? "2px solid #1a3a8f" : "2px solid #e8eef8",
                    background: form.badge === b
                      ? b === "PRO" ? "#e63946" : b === "BESTSELLER" ? "#0c6e3a" : b === "SALE" ? "#f59e0b" : b === "None" ? "#e8eef8" : "#1a3a8f"
                      : "#f8faff",
                    color: form.badge === b && b !== "None" ? "#fff" : "#0c1e5c",
                  }}>{b}</button>
                ))}
              </div>
            </div>

            <div>
              <label style={labelStyle}>Description</label>
              <textarea
                value={form.description}
                onChange={e => setForm(p => ({ ...p, description: e.target.value }))}
                placeholder="Short product description..."
                rows={3}
                style={{ ...inputStyle, resize: "vertical", lineHeight: "1.5" }}
              />
            </div>

            <div>
              <label style={labelStyle}>Key Features <span style={{ color: "#7a9acf", fontWeight: "400", textTransform: "none", letterSpacing: 0 }}>(one per line)</span></label>
              <textarea
                value={form.features}
                onChange={e => setForm(p => ({ ...p, features: e.target.value }))}
                placeholder={"EVA cushioning midsole\nBreathable mesh upper\nAnti-slip rubber outsole"}
                rows={4}
                style={{ ...inputStyle, resize: "vertical", lineHeight: "1.6", fontFamily: "monospace", fontSize: "12px" }}
              />
            </div>

            <div>
              <label style={labelStyle}>Available Sizes (EU) *</label>
              <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                {SIZES_BY_CAT[form.category].map(sz => (
                  <button key={sz} onClick={() => toggleSize(sz)} style={{
                    width: "40px", height: "34px", borderRadius: "4px", fontSize: "12px", fontWeight: "700", cursor: "pointer",
                    border: form.sizes.includes(sz) ? "2px solid #1a3a8f" : "2px solid #e8eef8",
                    background: form.sizes.includes(sz) ? "#1a3a8f" : "#f8faff",
                    color: form.sizes.includes(sz) ? "#fff" : "#0c1e5c",
                  }}>{sz}</button>
                ))}
              </div>
              <div style={{ fontSize: "11px", color: "#7a9acf", marginTop: "5px" }}>
                Selected: {form.sizes.length > 0 ? form.sizes.join(", ") : "None"}
              </div>
            </div>
          </div>

          {/* RIGHT - Images */}
          <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
            <div>
              <label style={labelStyle}>Product Photos <span style={{ color: "#7a9acf", fontWeight: "400", textTransform: "none", letterSpacing: 0 }}>(up to 4)</span></label>
              <div
                onClick={() => imgPreviews.length < 4 && fileRef.current.click()}
                onDrop={e => { e.preventDefault(); setDragOver(false); handleImgUpload(e.dataTransfer.files); }}
                onDragOver={e => { e.preventDefault(); setDragOver(true); }}
                onDragLeave={() => setDragOver(false)}
                style={{
                  border: dragOver ? "2px dashed #1a3a8f" : "2px dashed #b0c8f0",
                  borderRadius: "8px", padding: "28px 20px", textAlign: "center",
                  cursor: imgPreviews.length >= 4 ? "not-allowed" : "pointer",
                  background: dragOver ? "#e8f0ff" : "#f8faff",
                  opacity: imgPreviews.length >= 4 ? 0.5 : 1,
                }}
              >
                <div style={{ fontSize: "32px", marginBottom: "8px" }}>🖼️</div>
                <div style={{ fontSize: "13px", fontWeight: "700", color: "#1a3a8f", marginBottom: "4px" }}>
                  {imgPreviews.length >= 4 ? "Maximum 4 photos reached" : "Click or drag & drop photos here"}
                </div>
                <div style={{ fontSize: "11px", color: "#7a9acf" }}>JPG, PNG, WEBP · Up to 4 photos</div>
                <input
                  ref={fileRef}
                  type="file"
                  accept="image/*"
                  multiple
                  style={{ display: "none" }}
                  onChange={e => handleImgUpload(e.target.files)}
                />
              </div>

              {imgPreviews.length > 0 && (
                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "8px", marginTop: "10px" }}>
                  {imgPreviews.map((img, i) => (
                    <div key={i} style={{ position: "relative", borderRadius: "6px", overflow: "hidden", border: "2px solid #e8eef8", background: "#f0f5ff" }}>
                      {i === 0 && (
                        <div style={{ position: "absolute", top: "5px", left: "5px", background: "#1a3a8f", color: "#fff", fontSize: "8px", fontWeight: "900", padding: "2px 6px", borderRadius: "2px", zIndex: 1 }}>MAIN</div>
                      )}
                      <button
                        onClick={() => setImgPreviews(prev => prev.filter((_, idx) => idx !== i))}
                        style={{ position: "absolute", top: "5px", right: "5px", background: "rgba(230,57,70,0.9)", color: "#fff", border: "none", borderRadius: "50%", width: "22px", height: "22px", fontSize: "12px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1 }}
                      >✕</button>
                      <img src={img} alt="" style={{ width: "100%", height: "110px", objectFit: "contain", padding: "8px" }} />
                    </div>
                  ))}
                  {Array.from({ length: Math.max(0, 4 - imgPreviews.length) }).map((_, i) => (
                    <div
                      key={"empty" + i}
                      onClick={() => fileRef.current.click()}
                      style={{ height: "126px", borderRadius: "6px", border: "2px dashed #d0e0f8", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", background: "#fafcff", color: "#b0c8f0", fontSize: "24px" }}
                    >+</div>
                  ))}
                </div>
              )}
            </div>

            {form.name !== "" && (
              <div>
                <label style={labelStyle}>Live Preview</label>
                <div style={{ border: "2px solid #e8eef8", borderRadius: "8px", overflow: "hidden", background: "#fff" }}>
                  <div style={{ background: "linear-gradient(140deg, #dce8ff, #f0f5ff)", height: "130px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <img src={imgPreviews[0] || PLACEHOLDER} alt="" style={{ maxHeight: "110px", maxWidth: "90%", objectFit: "contain" }} />
                  </div>
                  <div style={{ padding: "10px 12px" }}>
                    <div style={{ fontSize: "9px", color: "#7a9acf", fontWeight: "700", letterSpacing: "2px", marginBottom: "2px" }}>
                      {categoryMeta[form.category] ? categoryMeta[form.category].icon : ""} {form.category}
                    </div>
                    <div style={{ fontSize: "13px", fontWeight: "800", color: "#0c1e5c", fontFamily: "'Playfair Display', Georgia, serif" }}>{form.name}</div>
                    <div style={{ fontSize: "14px", fontWeight: "900", color: "#1a3a8f", marginTop: "6px", fontFamily: "'Playfair Display', Georgia, serif" }}>
                      BD {form.price ? parseFloat(form.price).toFixed(3) : "0.000"}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div style={{ borderTop: "2px solid #e8eef8", padding: "14px 28px", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#f8faff" }}>
          <div style={{ fontSize: "12px", color: "#7a9acf" }}>* Required fields · Upload images from your device</div>
          <div style={{ display: "flex", gap: "10px" }}>
            <button onClick={() => setView("list")} style={{ background: "transparent", color: "#7a9acf", border: "2px solid #e8eef8", padding: "9px 18px", fontSize: "12px", fontWeight: "700", cursor: "pointer", borderRadius: "5px" }}>Cancel</button>
            <button onClick={handleSubmit} style={{ background: "#1a3a8f", color: "#fff", border: "none", padding: "9px 24px", fontSize: "12px", fontWeight: "900", cursor: "pointer", borderRadius: "5px" }}>
              {editingId ? "✓ Save Changes" : "✓ Add Product"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

// ============================================================
// 🏠 MAIN APP — The full website layout
// Everything below this line is what customers see
// ============================================================
export default function App() {

  // ----------------------------------------------------------
  // 📊 STATE VARIABLES — Things the website remembers
  // ----------------------------------------------------------
  const [activeCategory, setActiveCategory] = useState("All");
  const [page, setPage] = useState("home");
  const [showWelcomePopup, setShowWelcomePopup] = useState(() => {
    try { return !localStorage.getItem("visited"); } catch { return true; }
  });
  const closeWelcome = () => {
    setShowWelcomePopup(false);
    try { localStorage.setItem("visited", "1"); } catch {}
  };
  const [visitorCurrency, setVisitorCurrency] = useState({ code: "BHD", symbol: "BD", rate: 1 });
  const VISITOR_RATES = { SA: { code: "SAR", symbol: "SAR", rate: 10 }, AE: { code: "AED", symbol: "AED", rate: 10 }, KW: { code: "KWD", symbol: "KWD", rate: 0.85 }, QA: { code: "QAR", symbol: "QAR", rate: 10 }, OM: { code: "OMR", symbol: "OMR", rate: 1 } };
  const [megaMenuOpen, setMegaMenuOpen] = useState(null);
  const [activeClothingType, setActiveClothingType] = useState("All");
  const [activeSize, setActiveSize] = useState("All");

  const [activeBrand, setActiveBrand] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("default");
  const [cart, setCart] = useState(() => {
    try { return JSON.parse(localStorage.getItem("joma_cart") || "[]"); } catch { return []; }
  });
  const [cartOpen, setCartOpen] = useState(false);
  const [shipping, setShipping] = useState("pickup");
  const [gccCurrency, setGccCurrency] = useState("SAR");
  const [discountCode, setDiscountCode] = useState("");
  const [appliedCode, setAppliedCode] = useState(null);
  const [codeError, setCodeError] = useState("");

  const DISCOUNT_CODES = {
    "!@#$%^&#$%^&*(": { type: "percent", value: 15, label: "15% off" },
    "GCCSHIP": { type: "freeshipping", value: 0, label: "Free GCC Shipping" }, };

  const applyCode = () => {
    const code = discountCode.trim().toUpperCase();
    if (DISCOUNT_CODES[code]) {
      setAppliedCode({ code, ...DISCOUNT_CODES[code] });
      setCodeError("");
    } else {
      setCodeError("Invalid code. Please try again.");
      setAppliedCode(null);
    }
  };
  const GCC_RATES = { SAR: 10, AED: 10, KWD: 0.85, QAR: 10, OMR: 1 };
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [products, setProducts] = useState(DEMO_PRODUCTS);

  // 🔁 Any product with deal:true gets sale price + SALE badge automatically
  const productsWithDeals = products.map(p =>
    p.deal ? { ...p, originalPrice: p.price, price: p.dealPrice || p.price, discountLabel: `${p.discount}% OFF`, badge: "SALE" } : p
  );
  const [adminOpen, setAdminOpen] = useState(false);
  const [adminMode, setAdminMode] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [pwInput, setPwInput] = useState("");
  const [pwError, setPwError] = useState(false);
  const [storyOpen, setStoryOpen] = useState(false);
  const [storyProduct, setStoryProduct] = useState(null);
  const [storyIndex, setStoryIndex] = useState(0);
  const [slideIndex, setSlideIndex] = useState(0);

  const openStories = (product, index) => {
    setStoryProduct(product);
    setStoryIndex(index);
    setStoryOpen(true);
  };

  const SLIDES = [
    {
      bg: "linear-gradient(135deg, #0c1e5c 0%, #1a3a8f 55%, #2855c8 100%)",
      label: "⚽ FOOTBALL COLLECTION",
      title: "Born to", highlight: "Compete.",
      sub: "Premium Spanish football boots engineered for Bahrain's pitches.",
    },
    {
      bg: "linear-gradient(135deg, #0a2444 0%, #1a5c8f 55%, #2896c8 100%)",
      label: "🏃 RUNNING COLLECTION",
      title: "Built to", highlight: "Run.",
      sub: "Lightweight EVA soles and breathable mesh — perfect for Bahrain's heat.",
    },
    {
      bg: "linear-gradient(135deg, #1a0c5c 0%, #5c1a8f 55%, #8f28c8 100%)",
      label: "🥅 FUTSAL COLLECTION",
      title: "Made to", highlight: "Control.",
      sub: "Non-marking flat soles for supreme grip on indoor courts.",
    },
    {
      bg: "linear-gradient(135deg, #0c3a1e 0%, #1a8f5c 55%, #28c87a 100%)",
      label: "🏐 VOLLEYBALL COLLECTION",
      title: "Jump", highlight: "Higher.",
      sub: "Gel cushioning and lateral support for explosive court play.",
    },
    {
      bg: "linear-gradient(135deg, #3a1a0c 0%, #8f4a1a 55%, #c87028 100%)",
      label: "👟 CASUAL COLLECTION",
      title: "Style Meets", highlight: "Comfort.",
      sub: "Spanish minimalist design for everyday wear across Bahrain.",
    },
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setSlideIndex(prev => (prev + 1) % SLIDES.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  const [wishlist, setWishlist] = useState(() => {
    try { return JSON.parse(localStorage.getItem("joma_wishlist") || "[]"); } catch { return []; }
  });
  const [wishlistOpen, setWishlistOpen] = useState(false);

  const toggleWishlist = (product) => {
    setWishlist(prev =>
      prev.find(i => i.id === product.id)
        ? prev.filter(i => i.id !== product.id)
        : [...prev, product]
    );
  };

  const isWishlisted = (id) => wishlist.some(i => i.id === id);


  // ----------------------------------------------------------
  // 🔍 FILTER & SORT LOGIC — Controls which products are shown
  // Filters by category, clothing type, search term, and sort order
  // ----------------------------------------------------------
  const allCategories = ["All", ...CATEGORIES];
  const filtered = (() => {
    let result = activeCategory === "All" ? productsWithDeals : productsWithDeals.filter(p => hasCategory(p, activeCategory));
    if (hasCategory({category: activeCategory}, "Clothing") && activeClothingType !== "All") {
      result = result.filter(p => p.clothingType === activeClothingType);
    }
    if (activeBrand !== "All") {
      result = result.filter(p => p.brand === activeBrand);
    }
    if (searchTerm.trim()) {
      const q = searchTerm.toLowerCase();
      result = result.filter(p =>
        p.name.toLowerCase().includes(q) ||
        (Array.isArray(p.category) ? p.category.join(" ").toLowerCase() : (p.category || "").toLowerCase()).includes(q) ||
        (p.description && p.description.toLowerCase().includes(q))
      );
    }
    if (sortBy === "bestseller") result = [...result].filter(p => p.badge === "BESTSELLER").concat(result.filter(p => p.badge !== "BESTSELLER"));
    if (sortBy === "new") result = [...result].filter(p => p.badge === "NEW").concat(result.filter(p => p.badge !== "NEW"));
    if (sortBy === "deals") result = result.filter(p => p.deal || p.discount);
    if (activeSize !== "All") result = result.filter(p => p.sizes && p.sizes.includes(activeSize));
    if (sortBy === "price_high") result = [...result].sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
    if (sortBy === "price_low") result = [...result].sort((a, b) => parseFloat(a.price) - parseFloat(b.price));
    result = [...result.filter(p => p.featured), ...result.filter(p => !p.featured)];
    return result;
  })();


  // ----------------------------------------------------------
  // 🛒 CART FUNCTIONS
  // ----------------------------------------------------------
  const addToCart = (product) => {
    let effectivePrice = product.price;
    if (product.dealPrice) {
      effectivePrice = product.dealPrice;
    } else if (product.discount && product.badge === "SALE") {
      effectivePrice = (parseFloat(product.price) * (1 - parseFloat(product.discount) / 100)).toFixed(3);
    }
    const cartProduct = { ...product, price: effectivePrice, originalPrice: product.originalPrice || product.price };
    setCart(prev => {
      const existing = prev.find(i => i.id === cartProduct.id && i.selectedSize === cartProduct.selectedSize);
      if (existing) return prev.map(i => i.id === cartProduct.id && i.selectedSize === cartProduct.selectedSize ? { ...i, qty: i.qty + 1 } : i);
      return [...prev, { ...cartProduct, qty: 1 }];
    });
  };

  const cartTotal = cart.reduce((s, i) => s + parseFloat(i.price) * i.qty, 0);
  const bahrainShippingCost = cartTotal >= 17 ? 0 : 2;
  const shippingCost = shipping === "gcc"
    ? (appliedCode?.type === "freeshipping" ? 0 : 5)
    : shipping === "bahrain" ? bahrainShippingCost : 0;
  const discountAmount = appliedCode?.type === "percent" ? cartTotal * (appliedCode.value / 100) : 0;
  const orderTotal = cartTotal + shippingCost - discountAmount;
  const cartCount = cart.reduce((s, i) => s + i.qty, 0);


  // ⬇️ SCROLL TO PRODUCTS — Used by "Shop Now" button
  const scrollToProducts = () => {
    const el = document.getElementById("products");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const goToShop = (cat = "All", sort = null) => {
    setActiveCategory(cat);
    setActiveClothingType("All");
    setActiveSize("All");
    setSortBy(sort || "default");
    setPage("shop");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  // 📱 WHATSAPP ORDER — Builds and sends order message
  const handleWhatsAppOrder = () => {
    const isGCC = shipping === "gcc";
    const cur = isGCC ? gccCurrency : "BHD";
    const rate = isGCC ? GCC_RATES[gccCurrency] : 1;
    const fmt = (bdPrice) => isGCC ? `${cur} ${(bdPrice * rate).toFixed(2)}` : `BD ${bdPrice.toFixed(3)}`;
    const itemLines = cart.map((item, idx) => {
      const itemTotal = parseFloat(item.price) * item.qty;
      return `${idx + 1}. *${item.name}*\n   Size: ${item.selectedSize || "N/A"}  |  Qty: ${item.qty}  |  ${fmt(itemTotal)}\n   https://jomasportbahrain.com/?product=${item.id}`;
    }).join("\n\n");
    const deliveryLine = shipping === "gcc"
      ? `🚚 GCC Delivery: ${fmt(5)}`
      : shipping === "bahrain"
      ? `🇧🇭 Bahrain Delivery: ${bahrainShippingCost === 0 ? "FREE ✅" : showPrice(2)}`
      : `🏪 Store Pickup: FREE ✅`;

    const message = `🏪 *JOMASPORTBAHRAIN*
━━━━━━━━━━━━━━━━━━
🛒 *ORDER REQUEST*
━━━━━━━━━━━━━━━━━━

${itemLines}

━━━━━━━━━━━━━━━━━━
${deliveryLine}${appliedCode ? `\n🎟️ Code (${appliedCode.code}): -${fmt(discountAmount)}` : ""}
💰 *TOTAL: ${fmt(orderTotal)}*
━━━━━━━━━━━━━━━━━━${shipping === "pickup" ? `\n📍 Store Location:\nhttps://maps.app.goo.gl/NC3mqnweRN6jzjJi8` : ""}
Thank you! Please confirm 🙏`;
    const encoded = encodeURIComponent(message);
    window.open(`https://wa.me/97337103055?text=${encoded}`, "_blank");
  };

  const handleAdminLogin = () => {
    if (pwInput === ADMIN_PASSWORD) {
      setAdminOpen(true);
      setShowLogin(false);
      setPwInput("");
      setPwError(false);
    } else {
      setPwError(true);
    }
  };

  // Secret keyboard shortcut: Ctrl + Shift + A  (invisible to customers)
  useEffect(() => {
    const handler = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === "A") {
        if (adminMode) {
          setAdminMode(false);
        } else {
          setShowLogin(true);
        }
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [adminMode]);

  // Auto-detect visitor country and set currency
  useEffect(() => {
    fetch("https://api.country.is/")
      .then(r => r.json())
      .then(data => {
        const code = data.country;
        if (VISITOR_RATES[code]) {
          setVisitorCurrency(VISITOR_RATES[code]);
        }
      })
      .catch(() => {
        // fallback to ipapi
        fetch("https://ipapi.co/json/")
          .then(r => r.json())
          .then(data => {
            if (VISITOR_RATES[data.country_code]) {
              setVisitorCurrency(VISITOR_RATES[data.country_code]);
            }
          })
          .catch(() => {});
      });
  }, []);

  // Price display helper
  const showPrice = (bdPrice) => {
    if (!bdPrice) return "";
    const bd = parseFloat(bdPrice);
    if (visitorCurrency.code === "BHD") return `BD ${bd.toFixed(3)}`;
    const converted = (bd * visitorCurrency.rate).toFixed(2);
    return `${visitorCurrency.symbol} ${converted}`;
  };

  // Save cart to localStorage
  useEffect(() => {
    try { localStorage.setItem("joma_cart", JSON.stringify(cart)); } catch {}
  }, [cart]);

  // Save wishlist to localStorage
  useEffect(() => {
    try { localStorage.setItem("joma_wishlist", JSON.stringify(wishlist)); } catch {}
  }, [wishlist]);

  // Lock body scroll when cart/wishlist is open
  useEffect(() => {
    if (cartOpen || wishlistOpen || selectedProduct) {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    } else {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    }
    return () => {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    };
  }, [cartOpen, wishlistOpen, selectedProduct]);

  // Open product or category from URL on page load
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const productId = params.get("product");
    const category = params.get("category");
    if (productId) {
      const found = DEMO_PRODUCTS.find(p => String(p.id) === String(productId));
      if (found) setSelectedProduct(found);
    } else if (category) {
      const matched = CATEGORIES.find(c => c.toLowerCase() === category.toLowerCase());
      if (matched) {
        goToShop(matched);
      }
    }
  }, []);

  const newArrivals = productsWithDeals.filter(p => p.badge === "NEW").slice(0, 6);

  return (
    <div style={{ fontFamily: "'Inter', 'Helvetica Neue', Arial, sans-serif", background: "#f8faff", minHeight: "100vh", overflowX: "hidden" }}>
      {/* Google Analytics */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-B7BNFK8SQZ"></script>
      <script dangerouslySetInnerHTML={{ __html: `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-B7BNFK8SQZ');
      `}} />

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@400;500;600;700;800;900&family=Playfair+Display:wght@700;800;900&display=swap');

        /* ===== MOBILE PERFORMANCE FIXES ===== */
        * { -webkit-tap-highlight-color: transparent; touch-action: manipulation; }
        button, a { cursor: pointer; -webkit-tap-highlight-color: transparent; touch-action: manipulation; user-select: none; -webkit-user-select: none; }

        /* Disable ALL transitions/animations on touch devices */
        @media (hover: none) {
          * { transition: none !important; animation: none !important; }
          .joma-bs-card, .joma-sport-card, .joma-sport-by-card, .joma-product-card { transform: none !important; box-shadow: none !important; }
        }

        /* Instant tap feedback via CSS active state */
        @media (hover: none) {
          button:active { opacity: 0.7 !important; transform: scale(0.97) !important; }
          .joma-filter-btns button:active,
          .joma-sort-btns-row button:active { background: #1a3a8f !important; color: #fff !important; }
        }
        
        /* Smooth scrolling */
        html { scroll-behavior: smooth; -webkit-overflow-scrolling: touch; }
        
        /* Fix inputs on iOS */
        input { -webkit-appearance: none; border-radius: 0; font-size: 16px !important; }
        @keyframes fadeUp { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
        @keyframes slideIn { from { opacity:0; transform:translateX(-30px); } to { opacity:1; transform:translateX(0); } }
        @keyframes slideRight { from { transform:translateX(100%); } to { transform:translateX(0); } }
        @keyframes modalIn { from { opacity:0; transform:scale(0.95); } to { opacity:1; transform:scale(1); } }
        @keyframes dealPulse { 0%,100% { box-shadow: 0 0 0 0 rgba(230,57,70,0.5); } 50% { box-shadow: 0 0 0 6px rgba(230,57,70,0); } }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 5px; }
        ::-webkit-scrollbar-track { background: #f0f5ff; }
        ::-webkit-scrollbar-thumb { background: #1a3a8f; border-radius: 3px; }
        input::placeholder, textarea::placeholder { color: #aabbd4; }

        /* ── Responsive ── */
        @media (max-width: 768px) {
          .joma-nav { padding: 10px 16px !important; height: auto !important; flex-wrap: wrap !important; gap: 4px !important; }
          .joma-nav-logo span { font-size: 22px !important; letter-spacing: 2px !important; }
          .joma-sport-by-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 8px !important; }
          .joma-sport-by-card { height: 72px !important; border-radius: 10px !important; }
          .joma-sport-by-card .card-deco { display: none !important; }
          .joma-sport-by-card .card-bg-icon { display: none !important; }
          .joma-sport-by-card .sport-card-content { flex-direction: row !important; align-items: center !important; gap: 12px !important; justify-content: flex-start !important; padding: 0 16px !important; }
          .joma-sport-by-card .sport-icon { font-size: 24px !important; flex-shrink: 0 !important; }
          .joma-sport-by-card .sport-name { font-size: 14px !important; margin-bottom: 0 !important; }
          .joma-sport-by-card .sport-desc { display: none !important; }
          .joma-sport-by-card .sport-link { display: none !important; }
          .joma-nav-links { display: flex !important; gap: 0 !important; order: 3 !important; width: 100% !important; height: auto !important; }
          .joma-nav-links a { font-size: 10px !important; letter-spacing: 1px !important; padding: 10px 10px !important; height: auto !important; border-bottom: none !important; border-top: 1px solid #e8eef8 !important; }
          .joma-nav-logo img { height: 36px !important; }
          .joma-nav-right span { display: none !important; }
          .joma-nav-right .cart-count { display: inline-flex !important; }
          .joma-nav-right button { padding: 8px 12px !important; font-size: 11px !important; }
          .joma-topbar { font-size: 9px !important; letter-spacing: 0.5px !important; padding: 6px 10px !important; }
          .joma-hero { height: auto !important; min-height: 480px !important; padding-bottom: 70px !important; }
          .joma-slide { padding: 0 20px !important; align-items: center !important; }
          .joma-hero-content { padding: 0 !important; }
          .joma-hero-logo { height: 36px !important; margin-bottom: 12px !important; }
          .joma-hero-label { font-size: 9px !important; padding: 4px 10px !important; margin-bottom: 12px !important; letter-spacing: 2px !important; }
          .joma-hero-logo-text { font-size: 28px !important; letter-spacing: 2px !important; }
          .joma-hero-title { font-size: 28px !important; margin-bottom: 10px !important; letter-spacing: -1px !important; }
          .joma-hero-sub { font-size: 12px !important; margin-bottom: 18px !important; max-width: 100% !important; }
          .joma-hero-btns { gap: 8px !important; }
          .joma-hero-btns button { padding: 10px 18px !important; font-size: 10px !important; letter-spacing: 1px !important; }
          .joma-hero-stats { gap: 20px !important; margin-top: 32px !important; padding-top: 24px !important; flex-wrap: wrap !important; }
          .joma-hero-img { width: 120px !important; height: 80px !important; }
          .joma-cat-strip > div { padding: 14px 16px !important; font-size: 10px !important; }
          .joma-section { padding: 40px 16px !important; }
          .joma-section-sm { padding: 40px 16px 0 !important; }
          .joma-sport-grid { grid-template-columns: repeat(3, 1fr) !important; gap: 8px !important; }
          .joma-sport-card { padding: 14px 8px !important; }
          .joma-sport-card .icon { font-size: 20px !important; }
          .joma-sport-card .label { font-size: 10px !important; }
          .joma-sport-card .desc { display: none !important; }
          .joma-products-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 12px !important; }
          .joma-section-title { font-size: 26px !important; }
          .joma-filter-btns { gap: 5px !important; flex-wrap: wrap !important; }
          .joma-filter-btns button { padding: 6px 10px !important; font-size: 10px !important; min-height: 32px !important; white-space: nowrap !important; }
          .joma-sort-btns-row { flex-wrap: wrap !important; justify-content: flex-start !important; gap: 6px !important; }
          .joma-sort-btns-row button { min-height: 32px !important; padding: 6px 10px !important; font-size: 10px !important; white-space: nowrap !important; }
          .joma-bestseller-banner { height: auto !important; padding: 20px 16px !important; flex-direction: column !important; gap: 16px !important; }
          .joma-bestseller-banner .banner-img { width: 100% !important; height: 140px !important; }
          .joma-bestseller-banner .banner-text h2 { font-size: 18px !important; }
          .joma-bs-grid { grid-template-columns: 1fr !important; }
          .joma-bs-container { flex-direction: column !important; }
          .joma-bs-card { flex-direction: column !important; }
          .joma-bs-img { height: 240px !important; min-height: unset !important; max-height: 240px !important; padding: 10px !important; overflow: hidden !important; }
          .joma-bs-img img { max-height: 210px !important; max-width: 90% !important; width: auto !important; object-fit: contain !important; }
          .joma-bs-info { flex-direction: column !important; align-items: flex-start !important; padding: 16px !important; }
          .joma-deal-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 8px !important; }
          .joma-deal-card { flex-direction: column !important; padding: 8px !important; gap: 6px !important; border-radius: 10px !important; border-width: 1.5px !important; }
          .joma-deal-card .joma-deal-badge { font-size: 7px !important; padding: 3px 6px !important; margin-bottom: 4px !important; }
          .joma-deal-img { width: 100% !important; height: 130px !important; border-radius: 8px !important; }
          .joma-deal-card .joma-deal-cat { font-size: 7px !important; margin-bottom: 2px !important; }
          .joma-deal-card .joma-deal-name { font-size: 12px !important; margin-bottom: 4px !important; }
          .joma-deal-card .joma-deal-desc { display: none !important; }
          .joma-deal-card .joma-deal-sizes { display: none !important; }
          .joma-deal-card .joma-deal-buttons { display: none !important; }
          .joma-deal-card .joma-deal-circles { display: none !important; }
          .joma-teams-grid { grid-template-columns: 1fr !important; }
          .joma-teams-grid img { height: 200px !important; }
          .joma-story-grid { grid-template-columns: 1fr !important; }
          .joma-story-history { grid-template-columns: 1fr !important; }
          .joma-story-contact { grid-template-columns: 1fr !important; }
          .joma-story-body { padding: 20px 16px !important; }
          .joma-modal-inner { flex-direction: column !important; max-height: 90vh !important; width: 96vw !important; overflow: hidden !important; }
          .joma-modal-gallery { width: 100% !important; min-height: 280px !important; max-height: 360px !important; overflow: visible !important; }
          .joma-modal-main-img { width: 100% !important; max-height: 260px !important; object-fit: contain !important; }
          .joma-modal-info { width: 100% !important; overflow-y: auto !important; padding: 20px 16px !important; -webkit-overflow-scrolling: touch !important; }
          .joma-admin-grid { grid-template-columns: 1fr !important; }
          .joma-newsletter-input { flex-direction: column !important; }
          .joma-newsletter-input input { padding: 12px !important; }
          .joma-newsletter-input button { padding: 12px !important; }
          .joma-footer { padding: 24px 16px !important; }
          .joma-whatsapp-fab { bottom: 16px !important; right: 16px !important; width: 52px !important; height: 52px !important; }
          .joma-cart-drawer { width: 100vw !important; max-height: 100vh !important; }
          .joma-cart-drawer > div:nth-child(2) { flex: 1; overflow-y: auto; -webkit-overflow-scrolling: touch; }
          .joma-wishlist-drawer { width: 100vw !important; }
          .joma-admin-stats { gap: 14px !important; overflow-x: auto !important; }
          .joma-deal-prices { flex-wrap: wrap !important; gap: 3px !important; margin-bottom: 0px !important; }
          .joma-deal-prices > div:first-child { font-size: 14px !important; }
          .joma-deal-prices > div:nth-child(2) { font-size: 10px !important; }
          .joma-deal-prices > div:nth-child(3) { font-size: 7px !important; padding: 2px 4px !important; }
        }

        @media (max-width: 480px) {
          .joma-products-grid { grid-template-columns: 1fr !important; }
          .joma-sport-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .joma-hero-title { font-size: 24px !important; }
          .joma-slide { padding: 0 16px !important; }
          .joma-bestseller-banner .banner-text h2 { font-size: 16px !important; }
        }

        /* Product card hover - CSS only, no JS re-render */
        .joma-product-card {
          transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease;
          box-shadow: 0 4px 12px rgba(0,0,0,0.04);
        }
        @media (hover: hover) {
          .joma-product-card:hover {
            background: #f0f5ff !important;
            border-color: #1a3a8f !important;
            transform: translateY(-6px);
            box-shadow: 0 20px 40px rgba(26,58,143,0.15) !important;
          }
          .joma-product-card:hover .joma-card-add-btn {
            background: #1a3a8f !important;
            color: #fff !important;
          }
        }
        @media (hover: none) {
          .joma-product-card { transition: none !important; }
        }

        @media (min-width: 769px) {
          .joma-bs-container { flex-direction: row !important; }
          .joma-bs-card { flex: 1 !important; flex-direction: column !important; }
          .joma-bs-img { height: 280px !important; }
          .joma-bs-info { flex-direction: column !important; align-items: flex-start !important; }
        }

        @media (min-width: 769px) and (max-width: 1024px) {
          .joma-nav { padding: 0 24px !important; }
          .joma-section { padding: 48px 24px !important; }
          .joma-section-sm { padding: 48px 24px 0 !important; }
          .joma-sport-grid { grid-template-columns: repeat(5, 1fr) !important; gap: 10px !important; }
          .joma-products-grid { grid-template-columns: repeat(2, 1fr) !important; }
          .joma-teams-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
      `}</style>

      {/* 🔑 ADMIN LOGIN POPUP — Password modal */}
      {showLogin && (
        <div style={{ position: "fixed", inset: 0, zIndex: 3000, background: "rgba(6,15,46,0.85)", backdropFilter: "blur(4px)", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div style={{ background: "#fff", borderRadius: "12px", padding: "36px", width: "360px", boxShadow: "0 40px 80px rgba(0,0,0,0.4)", animation: "modalIn 0.3s ease" }}>
            <div style={{ textAlign: "center", marginBottom: "24px" }}>
              <JomaBHLogo size={52} dark={false} />
              <div style={{ fontSize: "18px", fontWeight: "900", color: "#0c1e5c", fontFamily: "'Playfair Display', Georgia, serif" }}>Admin Login</div>
              <div style={{ fontSize: "12px", color: "#7a9acf", marginTop: "4px" }}>Enter password to manage products</div>
            </div>
            <input
              type="password"
              value={pwInput}
              onChange={e => { setPwInput(e.target.value); setPwError(false); }}
              onKeyDown={e => e.key === "Enter" && handleAdminLogin()}
              placeholder="Password"
              style={{ ...inputStyle, marginBottom: "8px", textAlign: "center", letterSpacing: "3px", border: pwError ? "2px solid #e63946" : "2px solid #e8eef8" }}
            />
            {pwError && <div style={{ color: "#e63946", fontSize: "12px", textAlign: "center", marginBottom: "8px", fontWeight: "600" }}>Incorrect password</div>}
            <div style={{ display: "flex", gap: "8px", marginTop: "4px" }}>
              <button onClick={() => { setShowLogin(false); setPwInput(""); setPwError(false); }} style={{ flex: 1, background: "#f8faff", color: "#7a9acf", border: "2px solid #e8eef8", padding: "11px", fontSize: "12px", fontWeight: "700", cursor: "pointer", borderRadius: "6px" }}>Cancel</button>
              <button onClick={handleAdminLogin} style={{ flex: 1, background: "#1a3a8f", color: "#fff", border: "none", padding: "11px", fontSize: "12px", fontWeight: "900", cursor: "pointer", borderRadius: "6px" }}>Login →</button>
            </div>
            <div style={{ textAlign: "center", fontSize: "11px", color: "#b0c8f0", marginTop: "14px" }}>
              Password: <code style={{ background: "#f0f5ff", padding: "1px 6px", borderRadius: "3px" }}>joma2025</code>
            </div>
          </div>
        </div>
      )}

      {/* 🔐 ADMIN PANEL — Hidden management panel */}
      {adminOpen && (
        <AdminPanel
          products={products}
          onSave={updated => { setProducts(updated); setAdminMode(true); }}
          onClose={() => setAdminOpen(false)}
        />
      )}

      {/* 🪟 PRODUCT DETAIL MODAL — Opens when clicking Details */}
      {selectedProduct && (
        <ProductModal
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
          onAdd={p => { addToCart(p); setCartOpen(true); }}
          wishlisted={isWishlisted(selectedProduct.id)}
          onWishlist={toggleWishlist}
          showPrice={showPrice}
          visitorCurrency={visitorCurrency}
          allProducts={productsWithDeals}
          onOpen={setSelectedProduct}
          onShowStories={(index) => openStories(selectedProduct, index)}
        />
      )}

      {/* 📖 OUR STORY MODAL — About the store popup */}
      {storyOpen && (
        <div style={{ position: "fixed", inset: 0, zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", overscrollBehavior: "contain" }}
          onClick={e => e.target === e.currentTarget && setStoryOpen(false)}>
          <div onClick={() => setStoryOpen(false)} style={{ position: "absolute", inset: 0, background: "rgba(6,15,46,0.8)", backdropFilter: "blur(4px)" }} />
          <div style={{
            position: "relative", background: "#fff", borderRadius: "16px",
            width: "min(94vw, 820px)", maxHeight: "90vh", overflowY: "auto",
            animation: "modalIn 0.3s ease", boxShadow: "0 40px 80px rgba(0,0,0,0.4)",
          }}>
            {/* Close */}
            <button onClick={() => setStoryOpen(false)} style={{
              position: "sticky", top: "14px", float: "right", marginRight: "14px",
              background: "rgba(0,0,0,0.08)", border: "none", borderRadius: "50%",
              width: "34px", height: "34px", fontSize: "16px", cursor: "pointer",
              display: "flex", alignItems: "center", justifyContent: "center", zIndex: 10,
            }}>✕</button>

            {/* Hero banner */}
            <div style={{
              background: "linear-gradient(135deg, #0c1e5c 0%, #1a3a8f 60%, #2855c8 100%)",
              padding: "52px 48px 44px", position: "relative", overflow: "hidden", borderRadius: "16px 16px 0 0",
            }}>
              {[0,1,2].map(i => (
                <div key={i} style={{ position: "absolute", borderRadius: "50%", width: `${160 + i * 100}px`, height: `${160 + i * 100}px`, border: `1px solid rgba(255,255,255,${0.04 + i * 0.01})`, top: `${-60 + i * 20}px`, right: `${60 - i * 30}px` }} />
              ))}
              <div style={{ display: "inline-block", marginBottom: "16px" }}>
                <span style={{ fontFamily: "'Bebas Neue', 'Arial Black', sans-serif", fontSize: "32px", fontWeight: "900", color: "white", letterSpacing: "3px", display: "block" }}>JomaBahrainSport</span>
                <div style={{ height: "2px", width: "100%", background: "#f59e0b", borderRadius: "2px", marginTop: "3px" }} />
              </div>
              <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "38px", fontWeight: "900", color: "#fff", letterSpacing: "-1px", marginBottom: "12px" }}>
                Our Story
              </h2>
              <p style={{ fontSize: "16px", color: "rgba(255,255,255,0.72)", maxWidth: "480px", lineHeight: "1.7" }}>
                From All Over the World to the streets of Bahrain — 10 Years of passion for sport.
              </p>
            </div>

            {/* Content */}
            <div className="joma-story-body" style={{ padding: "40px 48px", display: "flex", flexDirection: "column", gap: "40px" }}>

              {/* About the store */}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "32px", alignItems: "center" }}>
                <div>
                  <div style={{ fontSize: "10px", letterSpacing: "3px", color: "#7a9acf", fontWeight: "800", marginBottom: "10px" }}>🇧🇭 BAHRAIN OFFICIAL STORE</div>
                  <h3 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "24px", fontWeight: "900", color: "#0c1e5c", marginBottom: "14px" }}>
                    Joma Bahrain Sport 
                  </h3>
                  <p style={{ fontSize: "14px", color: "#4a6aab", lineHeight: "1.8" }}>
                    We are the official Joma Sport store in Bahrain, bringing world-class Spanish sportswear directly to athletes and sport enthusiasts across the Kingdom. Whether you play football on the weekend, run along the coast, or compete on the futsal court — we have the right gear for you.
                  </p>
                </div>
                <div style={{ background: "linear-gradient(135deg, #dce8ff, #f0f5ff)", borderRadius: "12px", padding: "32px", textAlign: "center" }}>
                  <div style={{ fontSize: "48px", marginBottom: "12px" }}>🇧🇭</div>
                  <div style={{ fontSize: "28px", fontWeight: "900", color: "#1a3a8f", fontFamily: "'Playfair Display', Georgia, serif" }}>Bahrain</div>
                  <div style={{ fontSize: "13px", color: "#7a9acf", fontWeight: "600", marginTop: "4px" }}>Official Joma Retailer</div>
                </div>
              </div>

              {/* Divider */}
              <div style={{ height: "2px", background: "linear-gradient(90deg, #1a3a8f, #dce8ff)" }} />

              {/* Brand history */}
              <div>
                <div style={{ fontSize: "10px", letterSpacing: "3px", color: "#7a9acf", fontWeight: "800", marginBottom: "10px" }}>📍 FIND US</div>
                <h3 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "24px", fontWeight: "900", color: "#0c1e5c", marginBottom: "20px" }}>
                  Contact & Location
                </h3>
                <div className="joma-story-contact" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "14px" }}>
                  {[
                    { icon: "📍", label: "Location", value: "Dar Kulaib, Bahrain", sub: "Click to open in Google Maps", link: "https://maps.app.goo.gl/TeppuUxfMTYMfYbKA" },
                    { icon: "💬", label: "WhatsApp", value: "+973 3710 3055", sub: "Chat with us on WhatsApp", link: "https://wa.me/97337103055" },
                    { icon: "👨‍💼", label: "Manager", value: "+973 3964 6361", sub: "For bulk orders & inquiries" },
                    { icon: "📸", label: "Instagram", value: "@jomabhsport", sub: "Follow us for new arrivals", link: "https://www.instagram.com/jomabhsport/" },
                    { icon: "📧", label: "Email", value: "jomasportbh@gmail.com", sub: "We reply within 24 hours", link: "mailto:jomasportbh@gmail.com" },
                  ].map(({ icon, label, value, sub, link }) => (
                    <div key={label}
                      onClick={() => link && window.open(link, "_blank")}
                      style={{ display: "flex", alignItems: "flex-start", gap: "14px", background: "#f8faff", border: "2px solid #e8eef8", borderRadius: "8px", padding: "16px", cursor: link ? "pointer" : "default", transition: "all 0.2s" }}
                      onMouseEnter={e => { if (link) { e.currentTarget.style.borderColor = "#1a3a8f"; e.currentTarget.style.background = "#f0f5ff"; }}}
                      onMouseLeave={e => { if (link) { e.currentTarget.style.borderColor = "#e8eef8"; e.currentTarget.style.background = "#f8faff"; }}}
                    >
                      <div style={{ fontSize: "24px", flexShrink: 0 }}>{icon}</div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: "10px", fontWeight: "800", color: "#7a9acf", letterSpacing: "1.5px", textTransform: "uppercase", marginBottom: "3px" }}>{label}</div>
                        <div style={{ fontSize: "14px", fontWeight: "800", color: link ? "#1a3a8f" : "#0c1e5c", textDecoration: link ? "underline" : "none" }}>{value}</div>
                        <div style={{ fontSize: "11px", color: "#7a9acf", marginTop: "2px" }}>{sub}</div>
                      </div>
                      {link && <div style={{ fontSize: "16px", color: "#7a9acf", alignSelf: "center" }}>↗</div>}
                    </div>
                  ))}
                </div>
              </div>

              {/* CTA */}
              <div style={{ background: "linear-gradient(135deg, #0c1e5c, #1a3a8f)", borderRadius: "12px", padding: "32px", textAlign: "center" }}>
                <div style={{ fontSize: "22px", fontWeight: "900", color: "#fff", fontFamily: "'Playfair Display', Georgia, serif", marginBottom: "8px" }}>
                  Ready to Compete?
                </div>
                <div style={{ fontSize: "14px", color: "rgba(255,255,255,0.7)", marginBottom: "20px" }}>
                  Browse our full collection of Joma footwear
                </div>
                <button
                  onClick={() => { setStoryOpen(false); goToShop("All"); }}
                  style={{ background: "#fff", color: "#1a3a8f", border: "none", padding: "13px 32px", fontSize: "12px", fontWeight: "900", letterSpacing: "2px", cursor: "pointer", borderRadius: "4px", textTransform: "uppercase" }}
                >
                  Shop Now →
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* ♥ WISHLIST DRAWER — Slides in from right */}
      {wishlistOpen && (
        <div style={{ position: "fixed", inset: 0, zIndex: 999 }}>
          <div onClick={() => setWishlistOpen(false)} style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.4)" }} />
          <div className="joma-wishlist-drawer" style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: "380px", background: "#fff", boxShadow: "-8px 0 40px rgba(0,0,0,0.15)", display: "flex", flexDirection: "column", animation: "slideRight 0.3s ease" }}>
            <div style={{ padding: "22px", borderBottom: "2px solid #e8eef8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "19px", fontWeight: "900", color: "#0c1e5c" }}>♥ Wishlist ({wishlist.length})</span>
              <button onClick={() => setWishlistOpen(false)} style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer", color: "#7a9acf" }}>✕</button>
            </div>
            <div style={{ overflowY: "scroll", overflowX: "hidden", padding: "14px 22px", WebkitOverflowScrolling: "touch", touchAction: "pan-y", maxHeight: "45vh", flexShrink: 0 }}>
              {wishlist.length === 0 ? (
                <div style={{ textAlign: "center", color: "#7a9acf", marginTop: "60px" }}>
                  <div style={{ fontSize: "44px", marginBottom: "14px" }}>♡</div>
                  <div style={{ fontSize: "14px", fontWeight: "600" }}>Your wishlist is empty</div>
                  <div style={{ fontSize: "12px", marginTop: "6px" }}>Tap ♡ on any product to save it</div>
                </div>
              ) : wishlist.map(item => (
                <div key={`${item.id}-${item.selectedSize}`} style={{ display: "flex", gap: "12px", padding: "12px 0", borderBottom: "1px solid #f0f5ff", alignItems: "center" }}>
                  <div style={{ width: "56px", height: "44px", background: "#f0f5ff", borderRadius: "4px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <img src={item.images && item.images[0] ? item.images[0] : PLACEHOLDER} alt="" style={{ width: "50px", height: "38px", objectFit: "contain" }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "13px", fontWeight: "800", color: "#0c1e5c" }}>{item.name}</div>
                    <div style={{ fontSize: "11px", color: "#7a9acf" }}>{item.category} · {showPrice(item.price)}</div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                    <button
                      onClick={() => { addToCart(item); setWishlistOpen(false); setCartOpen(true); }}
                      style={{ background: "#1a3a8f", color: "#fff", border: "none", padding: "6px 10px", fontSize: "10px", fontWeight: "800", cursor: "pointer", borderRadius: "3px" }}>
                      + Cart
                    </button>
                    <button
                      onClick={() => toggleWishlist(item)}
                      style={{ background: "#fff0f3", color: "#e63946", border: "none", padding: "6px 10px", fontSize: "10px", fontWeight: "800", cursor: "pointer", borderRadius: "3px" }}>
                      Remove
                    </button>
                  </div>
                </div>
              ))}
            </div>
            {wishlist.length > 0 && (
              <div style={{ padding: "18px 22px", borderTop: "2px solid #e8eef8" }}>
                <button
                  onClick={() => { wishlist.forEach(addToCart); setWishlistOpen(false); setCartOpen(true); }}
                  style={{ width: "100%", background: "#1a3a8f", color: "#fff", border: "none", padding: "14px", fontSize: "12px", fontWeight: "900", letterSpacing: "2px", cursor: "pointer", borderRadius: "4px", textTransform: "uppercase" }}>
                  Add All to Cart
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* 🛒 CART DRAWER — Slides in from right with shipping */}
      {cartOpen && (
        <div style={{ position: "fixed", inset: 0, zIndex: 999, overflow: "hidden" }}>
          <div onClick={() => setCartOpen(false)} style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.4)" }} />
          <div className="joma-cart-drawer" style={{ position: "absolute", right: 0, top: 0, bottom: 0, width: "380px", background: "#fff", boxShadow: "-8px 0 40px rgba(0,0,0,0.15)", display: "flex", flexDirection: "column", animation: "slideRight 0.3s ease", overflow: "hidden" }}>
            <div style={{ padding: "22px", borderBottom: "2px solid #e8eef8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <span style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "19px", fontWeight: "900", color: "#0c1e5c" }}>Your Cart ({cartCount})</span>
              <button onClick={() => setCartOpen(false)} style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer", color: "#7a9acf" }}>✕</button>
            </div>
            <div style={{ overflowY: "scroll", overflowX: "hidden", padding: "14px 22px", WebkitOverflowScrolling: "touch", touchAction: "pan-y", maxHeight: "45vh", flexShrink: 0 }}>
              {cart.length === 0 ? (
                <div style={{ textAlign: "center", color: "#7a9acf", marginTop: "60px" }}>
                  <div style={{ fontSize: "44px", marginBottom: "14px" }}>🛒</div>
                  <div style={{ fontSize: "14px", fontWeight: "600" }}>Your cart is empty</div>
                </div>
              ) : cart.map(item => (
                <div key={`${item.id}-${item.selectedSize}`} style={{ display: "flex", gap: "12px", padding: "12px 0", borderBottom: "1px solid #f0f5ff", alignItems: "center" }}>
                  <div style={{ width: "56px", height: "44px", background: "#f0f5ff", borderRadius: "4px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <img src={item.images && item.images[0] ? item.images[0] : PLACEHOLDER} alt="" style={{ width: "50px", height: "38px", objectFit: "contain" }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: "13px", fontWeight: "800", color: "#0c1e5c" }}>{item.name}</div>
                    <div style={{ fontSize: "11px", color: "#7a9acf", display: "flex", gap: "8px", alignItems: "center" }}>
                      {item.category}
                      {item.selectedSize && <span style={{ background: "#1a3a8f", color: "#fff", padding: "1px 7px", borderRadius: "3px", fontSize: "10px", fontWeight: "800" }}>Size: {item.selectedSize}</span>}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: "6px" }}>
                      <button onClick={() => setCart(prev => prev.map(i => i.id === item.id ? { ...i, qty: Math.max(1, i.qty - 1) } : i))} style={{ width: "22px", height: "22px", background: "#f0f5ff", border: "1px solid #dce8ff", borderRadius: "4px", cursor: "pointer", fontSize: "14px", fontWeight: "900", color: "#1a3a8f", display: "flex", alignItems: "center", justifyContent: "center" }}>−</button>
                      <span style={{ fontSize: "12px", fontWeight: "800", color: "#0c1e5c", minWidth: "16px", textAlign: "center" }}>{item.qty}</span>
                      <button onClick={() => setCart(prev => prev.map(i => i.id === item.id ? { ...i, qty: i.qty + 1 } : i))} style={{ width: "22px", height: "22px", background: "#f0f5ff", border: "1px solid #dce8ff", borderRadius: "4px", cursor: "pointer", fontSize: "14px", fontWeight: "900", color: "#1a3a8f", display: "flex", alignItems: "center", justifyContent: "center" }}>+</button>
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px" }}>
                    {item.originalPrice && parseFloat(item.originalPrice) > parseFloat(item.price) && (
                      <div style={{ fontSize: "11px", color: "#aab8d0", textDecoration: "line-through" }}>
                        {showPrice((parseFloat(item.originalPrice) * item.qty).toFixed(3))}
                      </div>
                    )}
                    <div style={{ fontWeight: "900", color: item.originalPrice && parseFloat(item.originalPrice) > parseFloat(item.price) ? "#e63946" : "#1a3a8f", fontSize: "13px" }}>
                      {showPrice((parseFloat(item.price) * item.qty).toFixed(3))}
                    </div>
                    <button onClick={() => setCart(prev => prev.filter(i => i.id !== item.id))} style={{ background: "none", border: "none", color: "#e63946", fontSize: "11px", cursor: "pointer", fontWeight: "700" }}>✕ Remove</button>
                  </div>
                </div>
              ))}
            </div>
            {cart.length > 0 && (
              <div style={{ padding: "18px 22px", borderTop: "2px solid #e8eef8", overflowY: "auto", WebkitOverflowScrolling: "touch", maxHeight: "55vh", flexShrink: 0 }}>

                {/* Shipping Options */}
                <div style={{ marginBottom: "14px" }}>
                  <div style={{ fontSize: "11px", fontWeight: "800", color: "#0c1e5c", letterSpacing: "1.5px", textTransform: "uppercase", marginBottom: "8px" }}>Delivery Option</div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <label style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 14px", border: shipping === "pickup" ? "2px solid #1a3a8f" : "2px solid #e8eef8", borderRadius: "6px", cursor: "pointer", background: shipping === "pickup" ? "#f0f5ff" : "#fff" }}>
                      <input type="radio" name="shipping" value="pickup" checked={shipping === "pickup"} onChange={() => setShipping("pickup")} style={{ accentColor: "#1a3a8f" }} />
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: "12px", fontWeight: "800", color: "#0c1e5c" }}>🏪 Store Pickup</div>
                        <div style={{ fontSize: "11px", color: "#7a9acf" }}>Dar Kulaib, Bahrain</div>
                      </div>
                      <div style={{ fontWeight: "900", color: "#0c6e3a", fontSize: "12px" }}>FREE</div>
                    </label>
                    {shipping === "pickup" && (
                      <a href="https://maps.app.goo.gl/NC3mqnweRN6jzjJi8" target="_blank" rel="noreferrer" style={{
                        display: "flex", alignItems: "center", gap: "10px",
                        padding: "10px 14px", background: "#0c1e5c", borderRadius: "6px",
                        textDecoration: "none", color: "#fff",
                      }}>
                        <span style={{ fontSize: "20px" }}>📍</span>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: "12px", fontWeight: "800" }}>View Store Location</div>
                          <div style={{ fontSize: "10px", color: "rgba(255,255,255,0.6)" }}>Dar Kulaib, Bahrain · Open in Google Maps</div>
                        </div>
                        <span style={{ fontSize: "16px", color: "#f59e0b" }}>→</span>
                      </a>
                    )}
                    <label style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 14px", border: shipping === "bahrain" ? "2px solid #1a3a8f" : "2px solid #e8eef8", borderRadius: "6px", cursor: "pointer", background: shipping === "bahrain" ? "#f0f5ff" : "#fff" }}>
                      <input type="radio" name="shipping" value="bahrain" checked={shipping === "bahrain"} onChange={() => setShipping("bahrain")} style={{ accentColor: "#1a3a8f" }} />
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: "12px", fontWeight: "800", color: "#0c1e5c" }}>🇧🇭 Bahrain Delivery</div>
                        <div style={{ fontSize: "11px", color: "#7a9acf" }}>{cartTotal >= 40 ? "Free delivery on orders over BD 40" : "Free on orders over BD 40.000"}</div>
                      </div>
                      <div style={{ fontWeight: "900", fontSize: "12px", color: bahrainShippingCost === 0 ? "#0c6e3a" : "#1a3a8f" }}>
                        {bahrainShippingCost === 0 ? "FREE" : showPrice(2)}
                      </div>
                    </label>
                    <label style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px 14px", border: shipping === "gcc" ? "2px solid #1a3a8f" : "2px solid #e8eef8", borderRadius: "6px", cursor: "pointer", background: shipping === "gcc" ? "#f0f5ff" : "#fff" }}>
                      <input type="radio" name="shipping" value="gcc" checked={shipping === "gcc"} onChange={() => setShipping("gcc")} style={{ accentColor: "#1a3a8f" }} />
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: "12px", fontWeight: "800", color: "#0c1e5c" }}>🚚 GCC Delivery</div>
                        <div style={{ fontSize: "11px", color: "#7a9acf" }}>Saudi, UAE, Kuwait, Qatar, Oman</div>
                      </div>
                      <div style={{ fontWeight: "900", color: "#1a3a8f", fontSize: "12px" }}>{showPrice(5)}</div>
                    </label>
                  </div>
                </div>

                {/* Discount Code */}
                <div style={{ marginBottom: "12px" }}>
                  <div style={{ fontSize: "10px", fontWeight: "800", color: "#7a9acf", letterSpacing: "1px", marginBottom: "6px", textTransform: "uppercase" }}>Discount Code</div>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <input
                      type="text"
                      value={discountCode}
                      onChange={e => { setDiscountCode(e.target.value.toUpperCase()); setCodeError(""); }}
                      placeholder="Enter code..."
                      style={{ flex: 1, padding: "8px 12px", border: "2px solid #e8eef8", borderRadius: "6px", fontSize: "12px", fontWeight: "700", color: "#0c1e5c", outline: "none", fontFamily: "inherit" }}
                    />
                    <button onClick={applyCode} style={{ background: "#1a3a8f", color: "#fff", border: "none", padding: "8px 16px", borderRadius: "6px", fontSize: "11px", fontWeight: "800", cursor: "pointer" }}>
                      Apply
                    </button>
                  </div>
                  {codeError && <div style={{ fontSize: "11px", color: "#e63946", marginTop: "4px" }}>{codeError}</div>}
                  {appliedCode && (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "6px", background: "#e8fff0", padding: "6px 10px", borderRadius: "6px", border: "1px solid #0c6e3a" }}>
                      <span style={{ fontSize: "11px", fontWeight: "800", color: "#0c6e3a" }}>✅ {appliedCode.code} — {appliedCode.label}</span>
                      <button onClick={() => { setAppliedCode(null); setDiscountCode(""); }} style={{ background: "none", border: "none", color: "#e63946", cursor: "pointer", fontSize: "14px", fontWeight: "900" }}>✕</button>
                    </div>
                  )}
                </div>

                {/* GCC Currency Flags */}
                {shipping === "gcc" && (
                  <div style={{ marginBottom: "12px", padding: "10px 12px", background: "#f0f5ff", borderRadius: "8px", border: "1px solid #dce8ff" }}>
                    <div style={{ fontSize: "10px", fontWeight: "800", color: "#7a9acf", letterSpacing: "1px", marginBottom: "8px" }}>SHOW PRICE IN</div>
                    <div style={{ display: "flex", gap: "6px" }}>
                      {[
                        { code: "SAR", flag: "🇸🇦", label: "SAR" },
                        { code: "AED", flag: "🇦🇪", label: "AED" },
                        { code: "KWD", flag: "🇰🇼", label: "KWD" },
                        { code: "QAR", flag: "🇶🇦", label: "QAR" },
                        { code: "OMR", flag: "🇴🇲", label: "OMR" },
                      ].map(({ code, flag, label }) => (
                        <button key={code} onClick={() => setGccCurrency(code)} style={{
                          display: "flex", flexDirection: "column", alignItems: "center", gap: "2px",
                          padding: "6px 8px", border: gccCurrency === code ? "2px solid #1a3a8f" : "2px solid #e8eef8",
                          borderRadius: "8px", background: gccCurrency === code ? "#1a3a8f" : "#fff",
                          cursor: "pointer", flex: 1,
                        }}>
                          <span style={{ fontSize: "20px", lineHeight: 1 }}>{flag}</span>
                          <span style={{ fontSize: "9px", fontWeight: "800", color: gccCurrency === code ? "#fff" : "#0c1e5c" }}>{label}</span>
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                {/* Totals */}
                <div style={{ borderTop: "1px solid #e8eef8", paddingTop: "12px", marginBottom: "14px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                    <span style={{ fontSize: "12px", color: "#7a9acf" }}>Subtotal</span>
                    <span style={{ fontSize: "12px", color: "#0c1e5c", fontWeight: "700" }}>{showPrice(cartTotal.toFixed(3))}</span>
                  </div>
                  {shipping !== "pickup" && (
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                      <span style={{ fontSize: "12px", color: "#7a9acf" }}>{shipping === "gcc" ? "GCC Shipping" : "Bahrain Delivery"}</span>
                      <span style={{ fontSize: "12px", color: shippingCost === 0 ? "#0c6e3a" : "#0c1e5c", fontWeight: "700" }}>{shippingCost === 0 ? "FREE" : showPrice(shippingCost)}</span>
                    </div>
                  )}
                  {discountAmount > 0 && (
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                      <span style={{ fontSize: "12px", color: "#0c6e3a", fontWeight: "700" }}>Discount ({appliedCode.value}%)</span>
                      <span style={{ fontSize: "12px", color: "#0c6e3a", fontWeight: "700" }}>- {showPrice(discountAmount.toFixed(3))}</span>
                    </div>
                  )}
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontWeight: "700", color: "#0c1e5c" }}>Total</span>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ fontWeight: "900", fontSize: "17px", color: "#1a3a8f", fontFamily: "'Playfair Display', Georgia, serif" }}>{showPrice(orderTotal.toFixed(3))}</div>
                      {shipping === "gcc" && (
                        <div style={{ fontSize: "12px", fontWeight: "800", color: "#f59e0b", marginTop: "2px" }}>
                          = {gccCurrency} {(orderTotal * GCC_RATES[gccCurrency]).toFixed(2)}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <button
                  onClick={handleWhatsAppOrder}
                  style={{ width: "100%", background: "#25D366", color: "#fff", border: "none", padding: "16px", fontSize: "13px", fontWeight: "900", letterSpacing: "1px", cursor: "pointer", borderRadius: "6px", display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  Order via WhatsApp
                </button>
                <div style={{ fontSize: "11px", color: "#7a9acf", textAlign: "center", marginTop: "8px" }}>
                  Opens WhatsApp with your order details ready to send
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* 💬 FLOATING WHATSAPP BUTTON — Bottom right green button */}
      <a
        className="joma-whatsapp-fab"
        href="https://wa.me/message/NY2HOLCM63FAJ1"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed", bottom: "28px", right: "28px", zIndex: 998,
          background: "#25D366", color: "#fff", borderRadius: "50%",
          width: "60px", height: "60px", display: "flex", alignItems: "center", justifyContent: "center",
          boxShadow: "0 6px 24px rgba(37,211,102,0.5)",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          textDecoration: "none",
        }}
        onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.1)"; e.currentTarget.style.boxShadow = "0 10px 32px rgba(37,211,102,0.6)"; }}
        onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; e.currentTarget.style.boxShadow = "0 6px 24px rgba(37,211,102,0.5)"; }}
        title="Chat with us on WhatsApp"
      >
        <svg width="30" height="30" viewBox="0 0 24 24" fill="white">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      </a>

      {/* 📢 TOP BAR — Blue delivery announcement banner */}
      <div className="joma-topbar" style={{ background: "#1a3a8f", color: "#a8c4ff", fontSize: "11px", letterSpacing: "2px", textAlign: "center", padding: "8px", fontWeight: "600" }}>
        🇧🇭 DELIVERY ACROSS THE MIDDLE EAST · OFFICIAL JOMA BAHRAIN STORE · DAR KULAIB, BAHRAIN
      </div>

      {/* 🧭 NAVBAR — Mega menu */}
      <nav className="joma-nav" style={{ background: "#fff", borderBottom: "1px solid #e8eef8", padding: "0 40px", display: "flex", alignItems: "center", justifyContent: "space-between", height: "70px", position: "sticky", top: 0, zIndex: 300, boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
        <div className="joma-nav-logo" style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setPage("home")}>
          <div style={{ display: "inline-block" }}>
            <span style={{ fontFamily: "'Bebas Neue', 'Arial Black', sans-serif", fontSize: "26px", fontWeight: "900", color: "#0c1e5c", letterSpacing: "3px", display: "block" }}>JomaBahrainSport</span>
            <div style={{ height: "2px", width: "100%", background: "#f59e0b", borderRadius: "2px", marginTop: "1px" }} />
          </div>
        </div>

        <div className="joma-nav-links" style={{ display: "flex", height: "70px" }}>
          {[
            { label: "Home", action: () => { setPage("home"); setMegaMenuOpen(null); }, cats: [] },
            { label: "Shop", action: () => { setMegaMenuOpen(prev => prev === "Shop" ? null : "Shop"); }, cats: CATEGORIES },
            { label: "Deals", action: () => { goToShop("All", "deals"); setMegaMenuOpen(null); }, cats: [] },
            { label: "About", action: () => { setStoryOpen(true); setMegaMenuOpen(null); }, cats: [] },
          ].map(({ label, action, cats }) => (
            <div key={label} style={{ position: "relative", height: "100%", display: "flex", alignItems: "center" }}
              onMouseEnter={() => { if(window.innerWidth > 768 && cats.length > 0) setMegaMenuOpen(label); }}
              onMouseLeave={() => { if(window.innerWidth > 768) setMegaMenuOpen(null); }}
            >
              <a href="#" onClick={e => { e.preventDefault(); action(); }} style={{
                display: "flex", alignItems: "center", gap: "4px", height: "100%", padding: "0 18px",
                color: "#0c1e5c", textDecoration: "none", fontSize: "12px", fontWeight: "700",
                letterSpacing: "1px", textTransform: "uppercase",
                borderBottom: (label === "Home" && page === "home") || (label === "Shop" && page === "shop") ? "3px solid #1a3a8f" : "3px solid transparent",
                boxSizing: "border-box", transition: "color 0.15s",
              }}>
                {label}{cats.length > 0 && <span style={{ fontSize: "8px", opacity: 0.4, marginTop: "1px" }}>▼</span>}
              </a>
              {cats.length > 0 && megaMenuOpen === label && (
                <>
                  {/* Full screen overlay to catch outside taps */}
                  <div onClick={() => setMegaMenuOpen(null)} style={{ position: "fixed", inset: 0, zIndex: 399 }} />
                  <div style={{
                    position: "fixed", top: "118px", left: "50%", transform: "translateX(-50%)",
                    background: "#fff", boxShadow: "0 16px 40px rgba(0,0,0,0.2)",
                    border: "1px solid #e8eef8", borderTop: "3px solid #1a3a8f",
                    borderRadius: "0 0 12px 12px", padding: "10px 8px",
                    display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "2px",
                    width: "min(460px, 96vw)", zIndex: 400,
                  }}>
                    {cats.map(cat => (
                      <button key={cat} onClick={() => { goToShop(cat); setMegaMenuOpen(null); }} style={{
                        display: "flex", flexDirection: "column", alignItems: "center", gap: "4px",
                        padding: "8px 4px", background: "transparent", border: "none",
                        borderRadius: "6px", cursor: "pointer", textAlign: "center",
                      }}
                        onMouseEnter={e => e.currentTarget.style.background = "#f0f5ff"}
                        onMouseLeave={e => e.currentTarget.style.background = "transparent"}
                      >
                        <span style={{ fontSize: "22px" }}>{categoryMeta[cat]?.icon}</span>
                        <span style={{ fontSize: "10px", fontWeight: "700", color: "#0c1e5c" }}>{cat}</span>
                      </button>
                    ))}
                  </div>
                </>
              )}
            </div>
          ))}
        </div>

        <div className="joma-nav-right" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <button onClick={() => setWishlistOpen(true)} style={{ background: wishlist.length > 0 ? "#fff0f3" : "transparent", color: wishlist.length > 0 ? "#e63946" : "#0c1e5c", border: wishlist.length > 0 ? "1.5px solid #e63946" : "1.5px solid #e8eef8", padding: "9px 14px", fontSize: "14px", fontWeight: "800", cursor: "pointer", borderRadius: "4px", display: "flex", alignItems: "center", gap: "6px" }}>
            {wishlist.length > 0 ? "♥" : "♡"}{wishlist.length > 0 && <span style={{ fontSize: "11px" }}>{wishlist.length}</span>}
          </button>
          <button onClick={() => setCartOpen(true)} style={{ background: "#1a3a8f", color: "#fff", border: "none", padding: "10px 18px", fontSize: "12px", fontWeight: "800", letterSpacing: "1px", cursor: "pointer", borderRadius: "4px", display: "flex", alignItems: "center", gap: "7px" }}>
            🛒 Cart{cartCount > 0 && <span className="cart-count" style={{ background: "#e63946", borderRadius: "50%", width: "19px", height: "19px", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "10px", fontWeight: "900" }}>{cartCount}</span>}
          </button>
        </div>
      </nav>

      {/* ⚙️ ADMIN MODE BAR — Shows when admin panel is active */}
      {adminMode && (
        <div style={{ background: "#f59e0b", padding: "10px 40px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ fontSize: "13px", fontWeight: "800", color: "#fff" }}>
            ⚙️ Admin Mode · {products.length} products · Press Ctrl+Shift+A to exit
          </div>
          <button onClick={() => setAdminOpen(true)} style={{ background: "#fff", color: "#f59e0b", border: "none", padding: "7px 16px", fontSize: "12px", fontWeight: "900", cursor: "pointer", borderRadius: "4px" }}>
            Open Product Manager
          </button>
        </div>
      )}

      {/* ===== HOME PAGE ===== */}
      {page === "home" && (<>

      {/* 🎠 HERO */}
      <section className="joma-hero" style={{ position: "relative", height: "520px", overflow: "hidden", background: "linear-gradient(120deg, #060f2e 0%, #0c1e5c 50%, #1a3a8f 100%)" }}>
        {[0,1,2,3].map(j => (
          <div key={j} style={{ position: "absolute", borderRadius: "50%", width: `${200+j*120}px`, height: `${200+j*120}px`, border: `1px solid rgba(255,255,255,${0.03+j*0.01})`, top: `${-60+j*30}px`, right: `${100-j*40}px` }} />
        ))}
        <div className="joma-slide" style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", padding: "0 40px" }}>
          <div style={{ maxWidth: "560px", color: "#fff" }}>
            {/* Logo */}
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "20px" }}>
              <div style={{ flex: 1, height: "2px", background: "#f59e0b", borderRadius: "2px" }} />
              <span style={{ fontFamily: "'Bebas Neue', 'Arial Black', sans-serif", fontSize: "28px", fontWeight: "900", color: "#fff", letterSpacing: "3px", whiteSpace: "nowrap" }}>JomaBahrainSport</span>
              <div style={{ flex: 1, height: "2px", background: "#f59e0b", borderRadius: "2px" }} />
            </div>
            <div style={{ fontSize: "10px", letterSpacing: "4px", fontWeight: "700", color: "#f59e0b", marginBottom: "16px" }}>🇧🇭 OFFICIAL JOMA STORE — BAHRAIN</div>
            <h1 className="joma-hero-title" style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "clamp(36px,6vw,76px)", fontWeight: "900", lineHeight: "1.0", marginBottom: "20px", letterSpacing: "-2px" }}>
              Your Game,<br /><span style={{ color: "#7ab4ff" }}>Our Gear.</span>
            </h1>
            <p className="joma-hero-sub" style={{ fontSize: "15px", color: "rgba(255,255,255,0.65)", lineHeight: "1.7", marginBottom: "20px", maxWidth: "400px" }}>
              Premium Joma sportswear for football, running, futsal, volleyball and more.
            </p>
            <div className="joma-hero-btns" style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
              <button onClick={() => goToShop("All")} style={{ background: "#f59e0b", color: "#060f2e", border: "none", padding: "14px 32px", fontSize: "12px", fontWeight: "900", letterSpacing: "2px", cursor: "pointer", borderRadius: "4px", textTransform: "uppercase" }}
                onMouseEnter={e => e.currentTarget.style.background = "#e08c00"} onMouseLeave={e => e.currentTarget.style.background = "#f59e0b"}>Shop Now</button>
              <button onClick={() => setStoryOpen(true)} style={{ background: "transparent", color: "#fff", border: "2px solid rgba(255,255,255,0.4)", padding: "14px 32px", fontSize: "12px", fontWeight: "900", letterSpacing: "2px", cursor: "pointer", borderRadius: "4px", textTransform: "uppercase" }}>Our Story</button>
            </div>
          </div>
        </div>
        <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, background: "rgba(0,0,0,0.3)", backdropFilter: "blur(8px)", padding: "16px 40px", display: "flex", gap: "32px", flexWrap: "wrap" }}>
          {[["20+","Teams"],["10 Yrs","Experience"],["9","Categories"],["🇧🇭","Bahrain"]].map(([v,l]) => (
            <div key={l}>
              <div style={{ fontSize: "20px", fontWeight: "900", fontFamily: "'Playfair Display', Georgia, serif", color: "#f59e0b" }}>{v}</div>
              <div style={{ fontSize: "9px", letterSpacing: "2px", color: "rgba(255,255,255,0.5)", fontWeight: "600", textTransform: "uppercase" }}>{l}</div>
            </div>
          ))}
        </div>
      </section>

      {/* ⭐ BEST SELLERS — 3 column unique grid */}
      <section style={{ padding: "56px 40px", background: "linear-gradient(180deg, #060f2e 0%, #0c1e5c 100%)" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: "36px", flexWrap: "wrap", gap: "12px" }}>
            <div>
              <div style={{ fontSize: "11px", letterSpacing: "3px", color: "#f59e0b", fontWeight: "800", marginBottom: "8px" }}>🔥 MOST POPULAR</div>
              <h2 className="joma-section-title" style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "36px", fontWeight: "900", color: "#fff", letterSpacing: "-1px" }}>Best Sellers</h2>
              <p style={{ color: "rgba(255,255,255,0.5)", fontSize: "13px", marginTop: "6px" }}>Our top picks — loved by customers across Bahrain</p>
            </div>
            <button onClick={() => goToShop("All")} style={{ background: "transparent", color: "#f59e0b", border: "2px solid #f59e0b", padding: "10px 22px", fontSize: "12px", fontWeight: "800", cursor: "pointer", borderRadius: "4px", letterSpacing: "1px", textTransform: "uppercase", whiteSpace: "nowrap" }}>
              View All →
            </button>
          </div>

          {/* Responsive Navy & Gold Cards */}
          <div className="joma-bs-container" style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            {[...productsWithDeals]
              .sort((a, b) => {
                const order = { BESTSELLER: 0, PRO: 1, NEW: 2, SALE: 3 };
                return (order[a.badge] ?? 4) - (order[b.badge] ?? 4);
              })
              .slice(0, 3)
              .map((product, i) => {
                const img = product.images && product.images[0] ? product.images[0] : PLACEHOLDER;
                const rankLabels = ["⭐ #1 Best Seller", "🥈 #2 Popular", "🥉 #3 Top Rated"];
                const goldShades = ["#f59e0b", "#d4872a", "#c47820"];
                return (
                  <div
                    key={product.id}
                    className="joma-bs-card"
                    onClick={() => setSelectedProduct(product)}
                    style={{
                      background: "linear-gradient(160deg, #060f2e 0%, #0c1e5c 60%, #1a3a8f 100%)",
                      borderRadius: "16px", overflow: "hidden",
                      cursor: "pointer", position: "relative",
                      boxShadow: "0 8px 32px rgba(6,15,46,0.4)",
                      border: `1px solid rgba(245,158,11,${0.15 + i * 0.05})`,
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-8px)"; e.currentTarget.style.boxShadow = "0 24px 56px rgba(6,15,46,0.55)"; e.currentTarget.style.borderColor = `rgba(245,158,11,0.6)`; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 8px 32px rgba(6,15,46,0.4)"; e.currentTarget.style.borderColor = `rgba(245,158,11,${0.15 + i * 0.05})`; }}
                  >
                    {/* Gold top bar */}
                    <div style={{ height: "4px", background: `linear-gradient(90deg, ${goldShades[i]}, #fbbf24)` }} />

                    {/* Rank badge — sits on top of card, above image */}
                    <div style={{ padding: "10px 16px 0" }}>
                      <div style={{ display: "inline-block", background: `linear-gradient(90deg, ${goldShades[i]}, #fbbf24)`, color: "#060f2e", fontSize: "9px", fontWeight: "900", letterSpacing: "0.5px", padding: "4px 10px", borderRadius: "3px", whiteSpace: "nowrap" }}>
                        {rankLabels[i]}
                      </div>
                    </div>

                    {/* Image area */}
                    <div className="joma-bs-img" style={{ background: "rgba(255,255,255,0.04)", padding: "20px", display: "flex", alignItems: "center", justifyContent: "center", height: "280px", position: "relative", borderBottom: "1px solid rgba(245,158,11,0.1)", overflow: "hidden" }}>
                      {/* Discount badge */}
                      {product.discount && (
                        <div style={{ position: "absolute", top: "12px", right: "12px", background: "#e63946", color: "#fff", fontSize: "9px", fontWeight: "900", padding: "4px 8px", borderRadius: "2px" }}>
                          {product.discountLabel || `-${product.discount}%`}
                        </div>
                      )}
                      <img
                        src={img}
                        alt={product.name}
                        style={{ maxWidth: "100%", maxHeight: "240px", height: "auto", objectFit: "contain", transition: "transform 0.4s ease", filter: "drop-shadow(0 8px 16px rgba(0,0,0,0.4))" }}
                        onMouseEnter={e => e.currentTarget.style.transform = "scale(1.08)"}
                        onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
                      />
                    </div>

                    {/* Info area */}
                    <div className="joma-bs-info" style={{ padding: "20px 24px", display: "flex", flexDirection: "column", gap: "8px" }}>
                      {/* Category */}
                      <div style={{ fontSize: "9px", letterSpacing: "2px", color: goldShades[i], fontWeight: "800", textTransform: "uppercase" }}>
                        {categoryMeta[getFirstCategory(product)]?.icon} {Array.isArray(product.category) ? product.category.join(" · ") : product.category}
                      </div>
                      {/* Name */}
                      <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "20px", fontWeight: "900", color: "#fff", letterSpacing: "-0.3px" }}>
                        {product.name}
                      </div>
                      {/* Description */}
                      <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.5)", lineHeight: "1.5" }}>
                        {product.description?.slice(0, 70)}…
                      </div>
                      {/* Price + Buttons */}
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "10px", width: "100%" }}>
                        <div style={{ flex: 1 }}>
                          {product.discount ? (
                            <div>
                              <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "20px", fontWeight: "900", color: goldShades[i] }}>
                                {showPrice(product.dealPrice ? product.dealPrice : (parseFloat(product.price) * (1 - parseFloat(product.discount) / 100)).toFixed(3))}
                              </div>
                              <div style={{ fontSize: "11px", color: "rgba(255,255,255,0.35)", textDecoration: "line-through" }}>{showPrice(product.originalPrice || product.price)}</div>
                            </div>
                          ) : (
                            <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "20px", fontWeight: "900", color: goldShades[i] }}>
                              {showPrice(product.price)}
                            </div>
                          )}
                        </div>
                        <div style={{ display: "flex", gap: "6px", flexShrink: 0 }}>
                          <button onClick={e => { e.stopPropagation(); setSelectedProduct(product); }} style={{ background: `linear-gradient(90deg, ${goldShades[i]}, #fbbf24)`, color: "#060f2e", border: "none", padding: "8px 14px", fontSize: "10px", fontWeight: "900", cursor: "pointer", borderRadius: "4px", whiteSpace: "nowrap" }}>+ Cart</button>
                          <button onClick={e => { e.stopPropagation(); toggleWishlist(product); }} style={{ background: "rgba(255,255,255,0.08)", color: isWishlisted(product.id) ? "#e63946" : "rgba(255,255,255,0.6)", border: "1px solid rgba(255,255,255,0.15)", padding: "8px 10px", fontSize: "14px", cursor: "pointer", borderRadius: "4px" }}>{isWishlisted(product.id) ? "♥" : "♡"}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>

      </>)}

      {/* ===== SHOP PAGE ===== */}
      {page === "shop" && (<>
      <div style={{ height: "50px" }} />

      {/* Shop header */}
      <div style={{ background: "#0c1e5c", padding: "12px 40px", display: "flex", alignItems: "center", gap: "16px", position: "fixed", top: 0, left: 0, right: 0, zIndex: 500, boxShadow: "0 6px 18px rgba(6,15,46,0.25)", willChange: "transform", transform: "translateZ(0)" }}>
        <button onClick={() => setPage("home")} style={{ background: "rgba(255,255,255,0.1)", color: "#fff", border: "1px solid rgba(255,255,255,0.2)", padding: "8px 16px", fontSize: "12px", fontWeight: "700", cursor: "pointer", borderRadius: "4px", letterSpacing: "1px" }}>← Home</button>
        <span style={{ fontSize: "12px", fontWeight: "700", color: "rgba(255,255,255,0.6)", letterSpacing: "2px", textTransform: "uppercase" }}>
          {activeCategory === "All" ? "All Products" : `${categoryMeta[activeCategory]?.icon} ${activeCategory}`}
        </span>
      </div>

      {/* 🛍️ PRODUCTS GRID — Main product listing with search/filter/sort */}
      <section id="products" className="joma-section" style={{ padding: "44px 40px 64px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>

          {/* Row 1: Search + Sort on right */}
          <div className="joma-sort-btns-row" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "6px", marginBottom: "12px", flexWrap: "wrap" }}>
            {/* Search Bar */}
            <div style={{ display: "flex", alignItems: "center", background: "#fff", border: "2px solid #e8eef8", borderRadius: "6px", padding: "0 14px", gap: "8px", width: "220px" }}>
              <span style={{ fontSize: "14px", color: "#7a9acf" }}>🔍</span>
              <input type="text" placeholder="Search products..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} style={{ border: "none", outline: "none", fontSize: "13px", color: "#0c1e5c", padding: "9px 0", background: "transparent", width: "100%", fontFamily: "inherit" }} />
              {searchTerm && <button onClick={() => setSearchTerm("")} style={{ background: "none", border: "none", cursor: "pointer", color: "#7a9acf", fontSize: "16px", padding: 0 }}>✕</button>}
            </div>
            {/* Sort Buttons */}
            {[
              { key: "default", label: "Default" },
              { key: "bestseller", label: "⭐ Best Seller" },
              { key: "new", label: "🆕 New" },
              { key: "price_high", label: "💰 High Price" },
              { key: "price_low", label: "💸 Low Price" },
            ].map(s => (
              <button key={s.key} onClick={() => setSortBy(s.key)} style={{ padding: "6px 12px", fontSize: "10px", fontWeight: "800", cursor: "pointer", borderRadius: "20px", background: sortBy === s.key ? "#1a3a8f" : "#fff", color: sortBy === s.key ? "#fff" : "#1a3a8f", border: sortBy === s.key ? "2px solid #1a3a8f" : "2px solid #e8eef8", transition: "all 0.2s" }}>{s.label}</button>
            ))}
            {productsWithDeals.some(p => p.deal || p.discount) && (
              <button
                onClick={() => setSortBy(sortBy === "deals" ? "default" : "deals")}
                style={{
                  padding: "6px 12px", fontSize: "10px", fontWeight: "800", cursor: "pointer",
                  borderRadius: "20px",
                  background: sortBy === "deals" ? "#e63946" : "#fff",
                  color: sortBy === "deals" ? "#fff" : "#e63946",
                  border: "2px solid #e63946",
                  transition: "all 0.2s",
                  animation: sortBy !== "deals" ? "dealPulse 2s infinite" : "none",
                }}
              >🏷️ Deals</button>
            )}
          </div>

          {/* Row 2: Title on left, Filter buttons on right */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "24px", flexWrap: "wrap", gap: "12px" }}>
            <div>
              <div style={{ fontSize: "11px", letterSpacing: "3px", color: "#7a9acf", fontWeight: "700", marginBottom: "4px" }}>COLLECTION 2025</div>
              <h2 className="joma-section-title" style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "32px", fontWeight: "900", color: "#0c1e5c", letterSpacing: "-1px" }}>
                {searchTerm ? `🔍 Results for "${searchTerm}"` : activeCategory === "All" ? "All Products" : activeCategory === "Clothing" ? `👕 ${activeClothingType === "All" ? "All Clothing" : activeClothingType}` : `${categoryMeta[activeCategory] ? categoryMeta[activeCategory].icon : ""} ${activeCategory} Shoes`}
                <span style={{ fontSize: "13px", color: "#7a9acf", fontFamily: "sans-serif", fontWeight: "600", marginLeft: "10px" }}>({filtered.length} items)</span>
              </h2>
            </div>
            <div className="joma-filter-btns" style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
              {allCategories.map(cat => (
                <button key={cat} onClick={() => { setActiveCategory(cat); setActiveClothingType("All"); setActiveSize("All"); }} style={{ background: activeCategory === cat ? "#1a3a8f" : "transparent", color: activeCategory === cat ? "#fff" : "#1a3a8f", border: "2px solid #1a3a8f", padding: "6px 13px", fontSize: "10px", fontWeight: "800", letterSpacing: "1px", cursor: "pointer", borderRadius: "3px", transition: "all 0.2s", textTransform: "uppercase" }}>{cat}</button>
              ))}
            </div>
          </div>

          {/* Size filter — reads actual sizes from products in selected category */}
          {(() => {
            const catProducts = activeCategory === "All" ? productsWithDeals : productsWithDeals.filter(p => hasCategory(p, activeCategory));
            const availableSizes = [...new Set(catProducts.flatMap(p => p.sizes || []))].sort((a, b) => {
              const numA = parseFloat(a), numB = parseFloat(b);
              if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
              const order = ["XS","S","M","L","XL","XXL"];
              return order.indexOf(a) - order.indexOf(b);
            });
            return availableSizes.length > 0 && (
              <div style={{ display: "flex", gap: "8px", marginBottom: "16px", flexWrap: "wrap", alignItems: "center" }}>
                <span style={{ fontSize: "10px", fontWeight: "800", color: "#7a9acf", letterSpacing: "1px", textTransform: "uppercase" }}>Size:</span>
                {["All", ...availableSizes].map(sz => (
                  <button key={sz} onClick={() => setActiveSize(sz)} style={{
                    background: activeSize === sz ? "#f59e0b" : "#f8faff",
                    color: activeSize === sz ? "#060f2e" : "#0c1e5c",
                    border: activeSize === sz ? "2px solid #f59e0b" : "2px solid #e8eef8",
                    padding: "5px 12px", fontSize: "11px", fontWeight: "800",
                    cursor: "pointer", borderRadius: "4px", minWidth: "40px",
                    textAlign: "center",
                  }}>{sz}</button>
                ))}
              </div>
            );
          })()}

          {/* Clothing type sub-filter */}
          {activeCategory === "Clothing" && (
            <div style={{ display: "flex", gap: "8px", marginBottom: "24px", flexWrap: "wrap" }}>
              {["All", ...CLOTHING_TYPES].map(type => (
                <button key={type} onClick={() => setActiveClothingType(type)} style={{
                  background: activeClothingType === type ? "#e63946" : "#f8faff",
                  color: activeClothingType === type ? "#fff" : "#0c1e5c",
                  border: activeClothingType === type ? "2px solid #e63946" : "2px solid #e8eef8",
                  padding: "7px 16px", fontSize: "11px", fontWeight: "800",
                  cursor: "pointer", borderRadius: "20px", transition: "all 0.2s",
                  display: "flex", alignItems: "center", gap: "5px",
                }}>
                  {type === "Pants" ? "👖" : type === "T-Shirt" ? "👕" : type === "Shorts" ? "🩳" : type === "Socks" ? "🧦" : "👕"} {type}
                </button>
              ))}
            </div>
          )}

          {filtered.length === 0 ? (
            <div style={{ textAlign: "center", padding: "60px 20px", color: "#7a9acf" }}>
              <div style={{ fontSize: "48px", marginBottom: "14px" }}>
                {activeBrand !== "All" ? "🏷️" : "👟"}
              </div>
              <div style={{ fontSize: "20px", fontWeight: "900", color: "#0c1e5c", marginBottom: "10px" }}>
                {activeBrand !== "All" ? `No ${activeBrand} products yet` : "No products in this category yet"}
              </div>
              <div style={{ fontSize: "14px", color: "#7a9acf", maxWidth: "340px", margin: "0 auto", lineHeight: "1.7" }}>
                {activeBrand !== "All"
                  ? `We are working on adding ${activeBrand} products. In the meantime, browse our full collection!`
                  : "Check back soon for new arrivals."}
              </div>
              {activeBrand !== "All" && (
                <button onClick={() => { setActiveBrand("All"); }} style={{ marginTop: "20px", background: "#1a3a8f", color: "#fff", border: "none", padding: "12px 28px", fontSize: "12px", fontWeight: "900", cursor: "pointer", borderRadius: "4px", letterSpacing: "1px" }}>
                  VIEW ALL PRODUCTS
                </button>
              )}
              {adminMode && (
                <button onClick={() => setAdminOpen(true)} style={{ marginTop: "16px", background: "#1a3a8f", color: "#fff", border: "none", padding: "10px 24px", fontSize: "12px", fontWeight: "900", cursor: "pointer", borderRadius: "4px" }}>
                  + Add Products
                </button>
              )}
            </div>
          ) : (
            <div className="joma-products-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(268px, 1fr))", gap: "20px" }}>
              {filtered.map((product, i) => (
                <ProductCard
                  key={product.id}
                  product={product}
                  index={i}
                  onAdd={p => { addToCart(p); setCartOpen(true); }}
                  onOpen={setSelectedProduct}
                  adminMode={adminMode}
                  onDelete={id => setProducts(prev => prev.filter(p => p.id !== id))}
                  wishlisted={isWishlisted(product.id)}
                  onWishlist={toggleWishlist}
                  showPrice={showPrice}
                  onShowStories={(index) => openStories(product, index)}
                />
              ))}
            </div>
          )}
        </div>
      </section>

      </>)}

      {/* 🏷️ BRANDS WE CARRY */}
      <section style={{ padding: "56px 40px", background: "#f8faff" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ fontSize: "11px", letterSpacing: "3px", color: "#7a9acf", fontWeight: "700", textAlign: "center", marginBottom: "6px" }}>OUR BRANDS</div>
          <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "32px", fontWeight: "900", color: "#0c1e5c", textAlign: "center", marginBottom: "32px", letterSpacing: "-1px" }}>Brands We Carry</h2>
          <div style={{ display: "flex", gap: "16px", flexWrap: "wrap", justifyContent: "center" }}>
            {[
              { name: "All", country: "All Brands", color: "#1a3a8f" },
              { name: "Joma", country: "Spain", color: "#1a3a8f" },
            ].map(b => (
              <div key={b.name}
                onClick={() => { setActiveBrand(b.name); goToShop("All"); }}
                style={{
                  width: "130px",
                  background: activeBrand === b.name ? b.color : "#fff",
                  border: `2px solid ${activeBrand === b.name ? b.color : "#e8eef8"}`,
                  borderRadius: "12px", padding: "22px 12px", textAlign: "center",
                  cursor: "pointer", transition: "all 0.25s",
                  boxShadow: activeBrand === b.name ? "0 8px 24px rgba(0,0,0,0.15)" : "none",
                  transform: activeBrand === b.name ? "translateY(-5px)" : "translateY(0)",
                }}
                onMouseEnter={e => { if (activeBrand !== b.name) { e.currentTarget.style.borderColor = b.color; e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = "0 12px 28px rgba(0,0,0,0.1)"; }}}
                onMouseLeave={e => { if (activeBrand !== b.name) { e.currentTarget.style.borderColor = "#e8eef8"; e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}}
              >
                <div style={{ width: "52px", height: "52px", borderRadius: "50%", background: activeBrand === b.name ? "rgba(255,255,255,0.2)" : b.color, margin: "0 auto 12px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <span style={{ color: "#fff", fontWeight: "900", fontSize: "14px", letterSpacing: "1px" }}>{b.name.slice(0,2).toUpperCase()}</span>
                </div>
                <div style={{ fontWeight: "900", fontSize: "13px", color: activeBrand === b.name ? "#fff" : "#0c1e5c", marginBottom: "3px" }}>{b.name}</div>
                <div style={{ fontSize: "10px", color: activeBrand === b.name ? "rgba(255,255,255,0.7)" : "#7a9acf" }}>{b.country}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 🏆 SHOP BY SPORT */}
      <section style={{ background: "#f8faff", padding: "60px 40px" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ marginBottom: "36px" }}>
            <div style={{ fontSize: "10px", letterSpacing: "4px", color: "#7a9acf", fontWeight: "700", marginBottom: "8px", textTransform: "uppercase" }}>Browse Collection</div>
            <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "36px", fontWeight: "900", color: "#0c1e5c", letterSpacing: "-1px" }}>Shop by Sport</h2>
          </div>
          <div className="joma-sport-by-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "12px" }}>
            {CATEGORIES.map((cat, i) => {
              const configs = [
                { bg: "#060f2e", accent: "#3a6fd8", border: "#1a3a8f" },
                { bg: "#0a2010", accent: "#2d8f4e", border: "#1a5c32" },
                { bg: "#1a0a00", accent: "#c46a1a", border: "#8f4a10" },
                { bg: "#0d0a24", accent: "#6a3ab8", border: "#3a1a8f" },
                { bg: "#00111a", accent: "#1a7aab", border: "#0c4a6e" },
                { bg: "#1a0010", accent: "#b81a6a", border: "#8f0c4a" },
                { bg: "#0a1400", accent: "#5a8f1a", border: "#3a6010" },
                { bg: "#001a1a", accent: "#1aabab", border: "#0c6e6e" },
                { bg: "#001a0a", accent: "#22c55e", border: "#15803d" },
              ];
              const cfg = configs[i % configs.length];
              return (
                <div key={cat} className="joma-sport-by-card" onClick={() => goToShop(cat)}
                  style={{
                    position: "relative", height: "220px", borderRadius: "12px",
                    overflow: "hidden", cursor: "pointer",
                    background: cfg.bg,
                    border: `1px solid ${cfg.border}`,
                    transition: "transform 0.25s, box-shadow 0.25s",
                  }}
                  onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = `0 20px 48px rgba(0,0,0,0.35)`; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
                >
                  {/* Diagonal accent stripe */}
                  <div className="card-deco" style={{ position: "absolute", top: 0, right: 0, width: "60%", height: "100%", background: `linear-gradient(135deg, transparent 40%, ${cfg.accent}18)`, pointerEvents: "none" }} />
                  {/* Top accent line */}
                  <div className="card-deco" style={{ position: "absolute", top: 0, left: 0, right: 0, height: "3px", background: `linear-gradient(90deg, ${cfg.accent}, transparent)` }} />
                  {/* Large background icon */}
                  <div className="card-bg-icon" style={{ position: "absolute", right: "-10px", top: "10px", fontSize: "90px", opacity: 0.06, userSelect: "none", lineHeight: 1 }}>
                    {categoryMeta[cat]?.icon}
                  </div>
                  {/* Content */}
                  <div className="sport-card-content" style={{ position: "absolute", inset: 0, padding: "22px", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <div className="sport-icon" style={{ fontSize: "28px", lineHeight: 1 }}>{categoryMeta[cat]?.icon}</div>
                    <div>
                      <div className="sport-name" style={{ fontSize: "16px", fontWeight: "900", color: "#fff", fontFamily: "'Playfair Display', Georgia, serif", marginBottom: "4px", letterSpacing: "-0.3px" }}>{cat}</div>
                      <div className="sport-desc" style={{ fontSize: "10px", color: "rgba(255,255,255,0.45)", marginBottom: "14px", lineHeight: "1.5" }}>{categoryMeta[cat]?.desc}</div>
                      <div className="sport-link" style={{ display: "inline-flex", alignItems: "center", gap: "5px", fontSize: "10px", fontWeight: "800", color: cfg.accent, letterSpacing: "1px", textTransform: "uppercase" }}>
                        Shop {cat} <span style={{ fontSize: "12px" }}>→</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* 🏷️ DEAL OF THE MONTH — auto from products with deal:true */}
      {productsWithDeals.some(p => p.deal) && (
        <section className="joma-section" style={{ padding: "56px 40px", background: "#f8faff" }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <div style={{ marginBottom: "28px" }}>
              <div style={{ fontSize: "11px", letterSpacing: "3px", color: "#e63946", fontWeight: "800", marginBottom: "8px" }}>💥 LIMITED TIME</div>
              <h2 className="joma-section-title" style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "36px", fontWeight: "900", color: "#0c1e5c", letterSpacing: "-1px" }}>OFFERS</h2>
            </div>
            <div className="joma-deal-grid" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(min(100%, 560px), 1fr))", gap: "24px" }}>
              {productsWithDeals.filter(p => p.deal).map(p => (
                <div key={p.id} className="joma-deal-card" onClick={() => setSelectedProduct({ ...p, price: p.dealPrice })} style={{ display: "flex", alignItems: "center", gap: "24px", background: "#fff", border: "2px solid #1a3a8f", borderRadius: "16px", padding: "24px", position: "relative", overflow: "hidden", boxShadow: "0 8px 32px rgba(26,58,143,0.1)", cursor: "pointer" }}>
                  <div className="joma-deal-circles" style={{ position: "absolute", top: "-40px", right: "-40px", width: "180px", height: "180px", borderRadius: "50%", background: "rgba(26,58,143,0.04)" }} />
                  <div className="joma-deal-circles" style={{ position: "absolute", bottom: "-30px", right: "60px", width: "120px", height: "120px", borderRadius: "50%", background: "rgba(230,57,70,0.04)" }} />
                  <div className="joma-deal-img" style={{ width: "160px", height: "150px", flexShrink: 0, background: "linear-gradient(135deg,#dce8ff,#f0f5ff)", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <img src={p.images && p.images[0] ? p.images[0] : PLACEHOLDER} alt={p.name} style={{ width: "90%", height: "90%", objectFit: "contain" }} />
                  </div>
                  <div style={{ flex: 1, position: "relative", minWidth: 0 }}>
                    <div className="joma-deal-badge" style={{ display: "inline-flex", alignItems: "center", gap: "6px", background: "#e63946", color: "#fff", borderRadius: "4px", padding: "5px 12px", fontSize: "12px", fontWeight: "900", letterSpacing: "1px", marginBottom: "10px" }}>
                      🏷️ {p.discount}% ID OFFERS
                    </div>
                    <div className="joma-deal-cat" style={{ fontSize: "9px", letterSpacing: "2px", color: "#7a9acf", fontWeight: "800", marginBottom: "4px", textTransform: "uppercase" }}>{categoryMeta[p.category]?.icon} {p.category}</div>
                    <div className="joma-deal-name" style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "20px", fontWeight: "900", color: "#0c1e5c", marginBottom: "6px" }}>{p.name}</div>
                    <p className="joma-deal-desc" style={{ fontSize: "13px", color: "#7a9acf", lineHeight: "1.6", marginBottom: "12px" }}>{p.description}</p>
                    <div className="joma-deal-prices" style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "12px", flexWrap: "wrap" }}>
                      <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "24px", fontWeight: "900", color: "#e63946" }}>{showPrice(p.dealPrice)}</div>
                      <div style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "15px", color: "#b0c0d8", textDecoration: "line-through", fontWeight: "600" }}>{showPrice(p.originalPrice)}</div>
                      <div style={{ background: "#e63946", color: "#fff", fontSize: "10px", fontWeight: "900", padding: "3px 8px", borderRadius: "3px" }}>SAVE {showPrice((parseFloat(p.originalPrice) - parseFloat(p.dealPrice)).toFixed(3))}</div>
                    </div>
                    <div className="joma-deal-sizes" style={{ display: "flex", gap: "6px", marginBottom: "14px", flexWrap: "wrap" }}>
                      {p.sizes.map(sz => (
                        <div key={sz} style={{ width: "36px", height: "30px", border: "1.5px solid #dce8ff", borderRadius: "4px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "11px", fontWeight: "700", color: "#1a3a8f", background: "#f8faff" }}>{sz}</div>
                      ))}
                    </div>
                    <div className="joma-deal-buttons" style={{ display: "flex", gap: "8px", flexWrap: "wrap" }} onClick={e => e.stopPropagation()}>
                      <button onClick={() => { addToCart({ ...p, price: p.dealPrice }); setCartOpen(true); }} style={{ background: "#1a3a8f", color: "#fff", border: "none", padding: "11px 18px", fontSize: "12px", fontWeight: "900", letterSpacing: "1px", cursor: "pointer", borderRadius: "5px", textTransform: "uppercase" }}>+ Add to Cart</button>
                      <button onClick={() => setSelectedProduct({ ...p, price: p.dealPrice })} style={{ background: "transparent", color: "#1a3a8f", border: "2px solid #1a3a8f", padding: "11px 14px", fontSize: "12px", fontWeight: "800", cursor: "pointer", borderRadius: "5px" }}>Details</button>
                      <button onClick={() => toggleWishlist({ ...p, price: p.dealPrice })} style={{ background: isWishlisted(p.id) ? "#fff0f3" : "transparent", color: isWishlisted(p.id) ? "#e63946" : "#7a9acf", border: isWishlisted(p.id) ? "2px solid #e63946" : "2px solid #dce8ff", padding: "11px 12px", fontSize: "16px", cursor: "pointer", borderRadius: "5px" }}>{isWishlisted(p.id) ? "♥" : "♡"}</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* 👥 TEAMS GALLERY — Photos of teams you work with */}
      <section className="joma-section" style={{ padding: "60px 40px", background: "#fff" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
          <div style={{ textAlign: "center", marginBottom: "40px" }}>
            <div style={{ fontSize: "11px", letterSpacing: "3px", color: "#7a9acf", fontWeight: "700", marginBottom: "8px" }}>TRUSTED BY CHAMPIONS</div>
            <h2 className="joma-section-title" style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "36px", fontWeight: "900", color: "#0c1e5c", letterSpacing: "-1px" }}>
              Teams We Work With
            </h2>
            <p style={{ color: "#7a9acf", fontSize: "14px", marginTop: "10px" }}>
              From Bahrain courts to Asian finals — Joma is worn by the best
            </p>
          </div>
          <div className="joma-teams-grid" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "20px" }}>
            {[ {img : [darkulain] , caption : ""},
            {img : [darkulain1] , caption : ""},
            {img : [ahli] , caption : ""},
            {img : [riffa] , caption : ""},
           
            ].map(({ img, caption, cat }, i) => (
              <div key={i} style={{
                position: "relative", borderRadius: "10px", overflow: "hidden",
                boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
                cursor: "pointer", transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
                onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "0 20px 48px rgba(26,58,143,0.2)"; }}
                onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 8px 32px rgba(0,0,0,0.12)"; }}
              >
                <img src={img} alt={caption} style={{ width: "100%", height: "280px", objectFit: "cover", display: "block" }} />
                <div style={{
                  position: "absolute", bottom: 0, left: 0, right: 0,
                  background: "linear-gradient(transparent, rgba(6,15,46,0.92))",
                  padding: "40px 20px 20px",
                }}>
                  <div style={{ fontSize: "10px", letterSpacing: "2px", color: "#7ab4ff", fontWeight: "700", marginBottom: "4px" }}>{cat}</div>
                  <div style={{ fontSize: "14px", fontWeight: "800", color: "#fff", fontFamily: "'Playfair Display', Georgia, serif" }}>{caption}</div>
                </div>
                
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ⚡ TECH BANNER — Joma technology features */}
      <section style={{ background: "linear-gradient(90deg, #f0f5ff 0%, #dce8ff 100%)", padding: "50px 40px", borderTop: "3px solid #1a3a8f", borderBottom: "3px solid #1a3a8f" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "32px" }}>
          <div>
            <h2 style={{ fontFamily: "'Playfair Display', Georgia, serif", fontSize: "30px", fontWeight: "900", color: "#0c1e5c", marginBottom: "10px" }}>Joma Sport Bahtain Store</h2>
            <p style={{ color: "#4a6aab", fontSize: "15px", maxWidth: "440px", lineHeight: "1.7" }}>
              Your official sports store in Bahrain — serving 20+ teams across the Kingdom with premium gear and fast delivery to Bahrain and the GCC.
            </p>
          </div>
          <div style={{ display: "flex", gap: "24px", flexWrap: "wrap" }}>
            {[["👥","20+ Teams"],["🇧🇭","Dar Kulaib"],["🚚","Ships to GCC"],["⚽","All Sports"],["💎","Premium Gear"]].map(([icon, label]) => (
              <div key={label} style={{ textAlign: "center" }}>
                <div style={{ fontSize: "26px", marginBottom: "6px" }}>{icon}</div>
                <div style={{ fontSize: "10px", fontWeight: "800", letterSpacing: "1.5px", color: "#1a3a8f", textTransform: "uppercase" }}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 🦶 FOOTER — Store info at the bottom */}
      <footer className="joma-footer" style={{ background: "#060f2e", color: "rgba(255,255,255,0.45)", padding: "40px 40px 28px", textAlign: "center" }}>
        {/* Logo */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "20px" }}>
          <div style={{ display: "inline-block" }}>
            <span style={{ fontFamily: "'Bebas Neue', 'Arial Black', sans-serif", fontSize: "28px", fontWeight: "900", color: "white", letterSpacing: "3px", display: "block" }}>JomaBahrainSport</span>
            <div style={{ height: "2px", width: "100%", background: "#f59e0b", borderRadius: "2px", marginTop: "2px" }} />
          </div>
        </div>

        {/* Social & Contact buttons */}
        <div style={{ display: "flex", gap: "12px", justifyContent: "center", marginBottom: "24px", flexWrap: "wrap" }}>
          {/* WhatsApp */}
          <a href="https://wa.me/97337103055" target="_blank" rel="noreferrer" style={{
            display: "flex", alignItems: "center", gap: "8px",
            background: "#25D366", color: "#fff", textDecoration: "none",
            padding: "10px 18px", borderRadius: "6px", fontSize: "12px", fontWeight: "800", letterSpacing: "0.5px",
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            WhatsApp
          </a>

          {/* Instagram */}
          <a href="https://instagram.com/jomabhsport" target="_blank" rel="noreferrer" style={{
            display: "flex", alignItems: "center", gap: "8px",
            background: "linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)",
            color: "#fff", textDecoration: "none",
            padding: "10px 18px", borderRadius: "6px", fontSize: "12px", fontWeight: "800", letterSpacing: "0.5px",
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            Instagram
          </a>

          {/* TikTok */}
          <a href="https://tiktok.com/@jomasportbh" target="_blank" rel="noreferrer" style={{
            display: "flex", alignItems: "center", gap: "8px",
            background: "#010101", color: "#fff", textDecoration: "none",
            border: "1px solid rgba(255,255,255,0.15)",
            padding: "10px 18px", borderRadius: "6px", fontSize: "12px", fontWeight: "800", letterSpacing: "0.5px",
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z"/></svg>
            TikTok
          </a>

        </div>

        <div style={{ fontSize: "11px", letterSpacing: "2px", marginBottom: "6px", color: "rgba(255,255,255,0.3)" }}>
          DAR KULAIB, BAHRAIN · EST. 2016
        </div>
        <div style={{ fontSize: "11px", color: "#1e2d5a" }}>© 2025 JomaBahrainSport · All Rights Reserved</div>
      </footer>

      {/* 📸 STORY VIEWER — Full-screen story overlay */}
      {storyOpen && storyProduct && (
        <StoryViewer
          product={storyProduct}
          stories={(storyProduct.highlights || []).filter(h => h.type === "video")}
          startIndex={storyIndex}
          onClose={() => { setStoryOpen(false); setStoryProduct(null); }}
          onNavigate={(index) => setStoryIndex(index)}
        />
      )}
    </div>
  );
}
